<template>
  <!-- caption panel -->
  <div
    v-if="receivedCaption"
    class="flex flex-col w-[98%] lg:w-[95%] xl:w-[95%] 2xl:w-[90%] items-center justify-center space-y-3 pt-3 mx-auto mb-6 mt-8"
  >
    <!-- tranlate cost calculation -->
    <div
      v-if="originalText.length != 0 && !isFromNotification"
      class="container py-3 items-center justify-center flex flex-row"
    >
      <!-- <div
        v-if="balanceNotEnough && !computePricing"
        class="text-base pl-4 text-red-600 font-medium"
      >
        <p class="text-base pl-4 text-red-600 font-medium">
          {{ $t("your-balance-is-insufficient-please-recharge-to-continue") }}
        </p>
        <button @click="navToPayment">
          {{ $t("clicking-here") }}
        </button>
      </div> -->
      <!-- <p
        v-if="computePricing"
        class="text-base pl-4 text-[#2152B6] font-medium"
      >
        {{ $t("calculating-text-translation-cost-please-wait") }}
      </p> -->
    </div>
    <div
      v-if="fontFamilyListShow"
      class="overlay z-50"
      @click="showFontFamilyList"
    >
      <div class="overlay-content flex flex-col relative w-[95%] lg:w-[85%] xl:w-[70%] max-h-[1000px]" @click.stop>
        <p class="text-[#061B44] font-semibold text-xl pb-2 text-center">
          {{ $t("select-a-font") }}
        </p>
        <input
          v-model="searchQuery"
          type="text"
          :placeholder="$t('search-font')"
          class="border p-2 mb-4 rounded-md w-full"
        />
        <ul
          class="py-1 h-75vh grid grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 gap-4 overflow-y-auto"
        >
          <li
            v-for="font in filteredFonts"
            :key="font.name"
            :class="{ 'space-x-reverse': locale === 'ar' }"
            class="flex flex-row space-x-2"
          >
            <a
              @click="updatePreviewFont(font.name, font.files.regular)"
              :class="{
                'border-subBlue bg-subBlue bg-opacity-15': font.name === selectedPreviewFont,
              }"
              class="block px-4 py-2 text-xs md:text-base text-gray-800 font-medium cursor-pointer border border-slate-500 p-2 rounded-md w-full"
              :style="{ fontFamily: font.name }"
            >
              {{ font.name }}
            </a>
          </li>
        </ul>
        <div class="flex flex-col space-y-2 pt-2">
          <p class="text-slate-900 font-medium text-lg text-center">
            {{ $t("preview") }}
          </p>
          <p
            :style="{ fontFamily: selectedPreviewFont }"
            class="text-slate-900 font-normal text-xs md:text-base border border-slate-700 p-2 min-w-full rounded-md bg-subBlue bg-opacity-15 text-wrap text-start"
          >
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
          </p>
          <div
            :class="{ 'space-x-reverse': locale === 'ar' }"
            class="flex flex-row md:space-x-2 justify-between md:justify-end pt-2"
          >
            <button
              @click="showFontFamilyList"
              class="bg-white border border-slate-900 rounded-md text-slate-900 text-sm md:text-lg font-bold py-1 px-8 h-10"
            >
              {{ $t("close") }}
            </button>
            <button
              @click="
                selectedPreviewFont != null
                  ? applyFont(selectedPreviewFont)
                  : null
              "
              class="bg-subDark border border-slate-900 rounded-md text-white text-sm md:text-lg font-bold py-1 px-8 h-10"
            >
              {{ $t("apply-font") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- languages panel -->
    <div
      class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-center relative"
    >
      <div
        class="absolute flex flex-row items-center justify-center mx-auto min-h-20 w-full -translate-y-7 md:-translate-y-5"
      >
        <button
          type="button"
          @click="showTextTab = true"
          :aria-pressed="showTextTab"
          :aria-label="$t('text')"
          class="flex relative w-[50%] justify-end mb-12 md:mb-0 border-0 bg-transparent p-0 cursor-pointer rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4867C8] focus-visible:ring-offset-2"
        >
          <div
            :class="{
              'bg-[#4867C8] text-white': showTextTab,
              'bg-[#EEEEEE] text-black': !showTextTab,
            }"
            class="w-[65%] sm:w-[50%] md:w-[50%] lg:w-[40%] xl:w-[30%] font-medium h-10 rounded-full px-4 flex items-center text-xs md:text-lg pointer-events-none"
          >
            {{ $t("text") }}
          </div>
          <div
            :class="{
              'bg-[#4867C8] text-white': showTextTab,
              'bg-[#EEEEEE] text-black': !showTextTab,
              '-translate-x-[20px]': locale != 'ar',
              'translate-x-[20px]': locale === 'ar',
            }"
            class="h-[55px] w-[55px] md:h-[100px] md:w-[100px] rounded-full border-[5px] border-white transform -translate-y-[10px] md:-translate-y-[30px] flex items-center justify-center shrink-0 pointer-events-none"
          >
            <img src="../../../assets/images/home/voice.svg" class="w-10" alt="" />
          </div>
        </button>
        <button
          type="button"
          @click="showTextTab = false"
          :aria-pressed="!showTextTab"
          :aria-label="$t('captions')"
          class="flex relative w-[50%] justify-start items-start mb-12 md:mb-0 border-0 bg-transparent p-0 cursor-pointer rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4867C8] focus-visible:ring-offset-2"
        >
          <div
            :class="{
              'bg-[#4867C8] text-white': !showTextTab,
              'bg-[#D6D6D6] text-black': showTextTab,
              'translate-x-[20px]': locale != 'ar',
              '-translate-x-[20px]': locale === 'ar',
            }"
            class="h-[55px] w-[55px] md:h-[100px] md:w-[100px] rounded-full border-[5px] border-white transform -translate-y-[10px] md:-translate-y-[30px] flex items-center justify-center shrink-0 pointer-events-none"
          >
            <img
              src="../../../assets/images/home/closed-caption.svg"
              class="w-10"
              alt=""
            />
          </div>
          <div
            :class="{
              'bg-[#4867C8] text-white': !showTextTab,
              'bg-[#EEEEEE] text-black': showTextTab,
            }"
            class="w-[65%] sm:w-[50%] md:w-[50%] lg:w-[40%] xl:w-[30%] font-medium h-10 rounded-full px-4 flex items-center justify-end text-xs md:text-lg text-nowrap pointer-events-none"
          >
            {{ $t("captions") }}
          </div>
        </button>
      </div>
      <!-- <p class="text-[#061B44] font-semibold text-xl pt-12">
        {{ $t("language-settings") }}
      </p> -->
      <div
        class="flex flex-row items-center justify-end text-nowrap mx-auto w-auto pt-10"
      >
        <!-- first language button -->
        <div
          class="flex flex-col sm:flex-row items-center justify-center w-full"
        >
          <div
            class="flex items-center gap-1.5"
            :class="{ 'flex-row-reverse': locale === 'ar' }"
          >
            <i
              class="pi pi-globe text-[#061B44] opacity-85 flex-shrink-0 text-sm sm:text-base lg:text-lg leading-none"
              aria-hidden="true"
            ></i>
            <p
              class="text-[#061B44] font-semibold text-xs sm:text-sm lg:text-lg"
            >
              {{ getLanguageText() }}
            </p>
          </div>
        </div>
        <!-- translate button -->
        <div class="flex flex-row items-center justify-center">
          <button
            @click="showTextTab ? translateText() : translateCaptions()"
            :class="{ 
              'opacity-70 cursor-not-allowed': balanceNotEnough || (isTranslatingCaptions && !showTextTab),
              'bg-subDark text-white border-subDark': showTextTab && isMultiLanguageMode && selectedTargetLanguages.length > 0,
              'border-subBlue bg-subBlue bg-opacity-10': translationHint && translationHint.trim().length > 0 && !balanceNotEnough && !(showTextTab && isMultiLanguageMode && selectedTargetLanguages.length > 0)
            }"
            :disabled="balanceNotEnough || (showTextTab && isMultiLanguageMode && selectedTargetLanguages.length === 0) || (isTranslatingCaptions && !showTextTab)"
            class="relative flex flex-row items-center justify-center text-slate-800 border-2 border-slate-700 px-2 sm:px-10 py-1 rounded-lg font-semibold text-sm md:text-base transition-all duration-200 hover:shadow-md"
          >
            <p class="flex items-center space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
              <span
                v-if="isTranslatingCaptions && !showTextTab"
                class="inline-block w-4 h-4 border-2 border-slate-500 border-t-transparent rounded-full animate-spin"
                aria-hidden="true"
              ></span>
              <span>{{ isTranslatingCaptions && !showTextTab ? $t("translating-captions") : $t("translate") }}</span>
              <!-- Hint Active Indicator on Button -->
              <span
                v-if="translationHint && translationHint.trim().length > 0"
                class="flex items-center space-x-1 bg-subBlue text-white rounded-full px-2 py-0.5 text-xs font-bold"
                :class="{ 'space-x-reverse': locale === 'ar' }"
                :title="$t('translation-with-context') || 'Translation will use context hint'"
              >
                <i class="pi pi-lightbulb" style="font-size: 0.75rem"></i>
                <span>{{ $t("context") || "Context" }}</span>
              </span>
              <!-- Multi-language count badge -->
              <span
                v-if="showTextTab && isMultiLanguageMode && selectedTargetLanguages.length > 0"
                class="bg-white text-subDark rounded-full px-2 py-0.5 text-xs font-bold"
              >
                {{ selectedTargetLanguages.length }}
              </span>
            </p>
          </button>
        </div>
        <!-- second language button -->
        <div class="relative flex flex-row items-center justify-center w-full">
          <button
            @click="isTargetListOpen = !isTargetListOpen"
            :class="{ 'space-x-reverse': locale === 'ar' }"
            class="flex flex-col sm:flex-row items-center justify-center space-x-2"
          >
            <div
              class="flex items-center gap-1.5"
              :class="{ 'flex-row-reverse': locale === 'ar' }"
            >
              <i
                class="pi pi-globe text-[#061B44] opacity-85 flex-shrink-0 text-sm sm:text-base lg:text-lg leading-none"
                aria-hidden="true"
              ></i>
              <p
                class="text-[#061B44] font-semibold text-xs sm:text-sm lg:text-lg"
              >
                {{ removeParentheses(translationLanguage.langName) }}
              </p>
            </div>
            <img
              src="../../../assets/images/audio/02.svg"
              alt=""
              class="w-[5%] text-white fill-white"
            />
          </button>
          <!-- Context Hint Button - Simple Icon Next to Language Selector -->
          <button
            @click.stop="showHintPopup = !showHintPopup"
            :class="{ 
              'text-slate-900 bg-slate-100': translationHint && translationHint.trim().length > 0,
              'text-slate-400 hover:text-slate-600 hover:bg-slate-50': !translationHint || translationHint.trim().length === 0,
              'mr-2 ml-0': locale === 'ar',
              'ml-2': locale !== 'ar'
            }"
            class="relative flex items-center justify-center w-8 h-8 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-1"
            :title="translationHint && translationHint.trim().length > 0 
              ? ($t('context-hint-active') || 'Context Hint Active - Click to edit') 
              : ($t('add-context-hint') || 'Add Context Hint for Better Translation')"
          >
            <i
              class="pi pi-lightbulb"
              :style="{ fontSize: '1rem' }"
            ></i>
            <span
              v-if="translationHint && translationHint.trim().length > 0"
              class="absolute -top-0.5 -right-0.5 bg-slate-900 text-white rounded-full w-2.5 h-2.5 flex items-center justify-center"
            >
              <span class="text-[8px]">✓</span>
            </span>
          </button>
          <!-- translation language gridview -->
          <div v-if="isTargetListOpen" class="overlay z-50" @click="closeList">
            <div
              class="overlay-content is-language-picker-overlay flex flex-col items-stretch min-w-[80%] w-[90%] max-w-5xl h-[min(85vh,900px)] max-h-[85vh] min-h-0 overflow-hidden"
              @click.stop
            >
              <div
                :class="{ 'space-x-reverse': locale === 'ar' }"
                class="flex-shrink-0 flex flex-row flex-wrap gap-2 md:gap-0 md:space-x-4 w-full items-center justify-center min-h-10 py-3"
              >
                <input
                  v-model="searchQuery"
                  @input="filteredLanguages"
                  type="text"
                  :placeholder="$t('search-for-a-language')"
                  class="pl-1 md:pl-4 bg-white border border-slate-900 rounded-md text-slate-900 text-xs md:text-base font-semibold w-[60%] sm:w-[40%] h-10"
                />
                <!-- Toggle switch for single/multi selection mode -->
                <div
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                  class="flex flex-row items-center space-x-2 px-2 border border-slate-300 rounded-lg h-10"
                >
                  <span class="text-slate-900 font-semibold text-xs md:text-sm">
                    {{ $t("single-select") }}
                  </span>
                  <label class="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      :checked="isMultiLanguageMode"
                      @change="isMultiLanguageMode = !isMultiLanguageMode"
                      class="sr-only peer"
                    />
                    <div
                      class="w-11 h-6 bg-gray-300 rounded-full peer peer-focus:ring-2 peer-focus:ring-subDark peer-checked:bg-subDark peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"
                    ></div>
                  </label>
                  <span class="text-slate-900 font-semibold text-xs md:text-sm">
                    {{ $t("multi-select") }}
                  </span>
                </div>
                <!-- Context Hint Button in Language Selection -->
                <button
                  @click.stop="showHintPopup = !showHintPopup"
                  :class="{ 
                    'bg-slate-900 text-white border-slate-900': translationHint && translationHint.trim().length > 0,
                    'bg-white border-slate-400 text-slate-700 hover:bg-slate-50': !translationHint || translationHint.trim().length === 0
                  }"
                  class="flex flex-row items-center justify-center gap-1.5 border-2 rounded-lg px-3 py-1.5 h-10 font-medium text-xs md:text-sm transition-all duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-1"
                  :title="translationHint && translationHint.trim().length > 0 
                    ? ($t('context-hint-active') || 'Context Hint Active - Click to edit') 
                    : ($t('add-context-hint') || 'Add Context Hint for Better Translation')"
                >
                  <i class="pi pi-lightbulb" style="font-size: 0.9rem"></i>
                  <span class="whitespace-nowrap hidden sm:inline">
                    {{ $t("context-hint") || "Context" }}
                  </span>
                  <span
                    v-if="translationHint && translationHint.trim().length > 0"
                    class="ml-0.5 bg-white text-slate-900 rounded-full px-1.5 py-0.5 text-xs font-bold shadow-sm"
                  >
                    ✓
                  </span>
                </button>
                <button
                  @click="closeList"
                  class="bg-white border border-slate-900 rounded-md text-slate-900 text-base md:text-lg font-bold py-1 px-8 h-10"
                >
                  {{ $t("close") }}
                </button>
              </div>
              <!-- Quick Access: Languages with existing translations -->
              <div
                v-if="searchQuery.length === 0 && availableTranslatedLanguages.length > 0"
                class="flex-shrink-0 py-3 border-b border-gray-300 w-full px-1 max-h-[min(22vh,220px)] min-h-0 overflow-y-auto"
              >
                <p class="text-xs md:text-sm font-semibold text-gray-600 mb-2">
                  {{ $t("languages-with-translations") || "Languages with Translations" }}
                </p>
                <div
                 class="py-1 grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 gap-4"
                 :class="{ 'space-x-reverse': locale === 'ar' }"
                >
                  <div
                    v-for="lang in availableTranslatedLanguages"
                    :key="lang.langCode"
                    @click="loadTranslationDirectly(lang)"
                    class="flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-full border-2 border-blue-300 bg-blue-50 text-blue-700 cursor-pointer transition-all duration-200 whitespace-nowrap hover:bg-blue-100 hover:border-blue-400"
                  >
                    <i
                      class="pi pi-globe text-blue-600 flex-shrink-0"
                      style="font-size: 0.875rem"
                      aria-hidden="true"
                    ></i>
                    <span>{{ lang.langName }}</span>
                    <i
                      class="pi pi-check-circle text-blue-600"
                      style="font-size: 0.875rem"
                    ></i>
                  </div>
                </div>
              </div>
              <!-- Selected languages display (multi-select mode) -->
              <div
                v-if="isMultiLanguageMode"
                class="flex-shrink-0 w-full px-4 py-3 mb-2 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 shadow-sm max-h-[min(28vh,280px)] min-h-0 overflow-y-auto"
              >
                <div class="flex items-center justify-between mb-2">
                  <p class="text-xs md:text-sm font-semibold text-blue-700">
                    {{ $t("selected-languages") || "Selected Languages" }}
                  </p>
                  <span 
                    v-if="selectedTargetLanguages.length > 0"
                    class="text-xs md:text-sm font-bold text-blue-600 bg-white px-2 py-1 rounded-full border border-blue-300"
                  >
                    {{ selectedTargetLanguages.length }}
                  </span>
                  <span 
                    v-else
                    class="text-xs md:text-sm font-medium text-gray-500 italic"
                  >
                    {{ $t("no-languages-selected") || "None selected" }}
                  </span>
                </div>
                <div
                  v-if="selectedTargetLanguages.length > 0"
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                  class="flex flex-row flex-wrap gap-2"
                >
                  <span
                    v-for="lang in selectedTargetLanguages"
                    :key="lang.langCode"
                    class="flex items-center gap-2 bg-white text-subDark px-3 py-1.5 rounded-full text-sm font-medium border border-blue-300 shadow-sm hover:shadow-md transition-shadow"
                  >
                    <i
                      class="pi pi-globe text-subDark opacity-70 flex-shrink-0"
                      style="font-size: 0.875rem"
                      aria-hidden="true"
                    ></i>
                    <span>{{ lang.langName }}</span>
                    <i
                      v-if="hasTranslation(lang.langCode)"
                      class="pi pi-check-circle text-green-600"
                      style="font-size: 0.875rem"
                      :title="$t('translation-available') || 'Translation available'"
                    ></i>
                  </span>
                </div>
                <p 
                  v-else
                  class="text-xs md:text-sm text-gray-500 italic text-center py-2"
                >
                  {{ $t("select-languages-to-translate") || "Select one or more languages to translate" }}
                </p>
              </div>
              <ul
                class="py-1 flex-1 min-h-0 w-full grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 gap-4 overflow-y-auto overscroll-contain"
              >
                <li
                  v-for="lang in myLanguagesList"
                  :key="lang.langName"
                  :class="{
                    'space-x-reverse': locale === 'ar',
                    'opacity-50 cursor-not-allowed': isMultiLanguageMode && originalLanguage.langCode && lang.langCode === originalLanguage.langCode,
                    'cursor-pointer hover:bg-gray-50': isMultiLanguageMode && (!originalLanguage.langCode || lang.langCode !== originalLanguage.langCode),
                  }"
                  @click="isMultiLanguageMode && (!originalLanguage.langCode || lang.langCode !== originalLanguage.langCode) ? selectTargetLanguage(lang) : null"
                  class="flex flex-row space-x-2 items-center px-2 py-2 rounded-md transition-colors"
                >
                  <!-- Checkbox for multi-select mode -->
                  <input
                    v-if="isMultiLanguageMode"
                    type="checkbox"
                    :checked="selectedTargetLanguages.some((l) => l.langCode === lang.langCode)"
                    :disabled="!!(originalLanguage.langCode && lang.langCode === originalLanguage.langCode)"
                    @change="selectTargetLanguage(lang)"
                    @click.stop
                    class="w-4 h-4 text-subBlue border-gray-300 rounded focus:ring-subBlue disabled:opacity-40 disabled:cursor-not-allowed"
                  />
                  <i
                    class="pi pi-globe text-gray-400 flex-shrink-0"
                    style="font-size: 0.875rem"
                    aria-hidden="true"
                  ></i>
                  <a
                    @click.stop="selectTargetLanguage(lang)"
                    :class="{
                      'font-bold text-subBlue': !isMultiLanguageMode && translationLanguage.langCode === lang.langCode,
                      'opacity-50': isMultiLanguageMode && selectedTargetLanguages.some((l) => l.langCode === lang.langCode),
                      'bg-green-50 border-l-4 border-green-500 pl-3': hasTranslation(lang.langCode) && !isMultiLanguageMode,
                      'bg-blue-50': hasTranslation(lang.langCode) && isMultiLanguageMode,
                      'text-gray-400': isMultiLanguageMode && originalLanguage.langCode && lang.langCode === originalLanguage.langCode,
                    }"
                    class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer rounded-md transition-colors flex-1"
                  >
                    <span class="flex items-center gap-2">
                      <span class="truncate">{{ lang.langName }}</span>
                      <i
                        v-if="hasTranslation(lang.langCode)"
                        class="pi pi-check-circle text-green-600 flex-shrink-0"
                        style="font-size: 0.875rem"
                        :title="$t('translation-available') || 'Translation available'"
                      ></i>
                      <i
                        v-if="isMultiLanguageMode && originalLanguage.langCode && lang.langCode === originalLanguage.langCode"
                        class="pi pi-info-circle text-gray-400 flex-shrink-0"
                        style="font-size: 0.875rem"
                        :title="$t('same-as-original-language') || 'Same as original language'"
                      ></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Context Hint Popup -->
        <div v-if="showHintPopup" class="overlay z-50" @click="showHintPopup = false">
          <div
            class="overlay-content flex flex-col items-center min-w-[90%] sm:min-w-[80%] md:min-w-[60%] lg:min-w-[50%] max-w-[600px] max-h-[80vh]"
            @click.stop
          >
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row space-x-4 w-full items-center justify-between h-10 py-6 border-b-2 border-slate-300 bg-white"
            >
              <div class="flex items-center space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
                <div class="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center">
                  <i class="pi pi-lightbulb text-slate-900" style="font-size: 1.25rem"></i>
                </div>
                <h3 class="text-slate-900 font-semibold text-lg md:text-xl px-3 py-1.5 rounded-lg bg-white">
                  {{ $t("add-context-hint") || "Add Context Hint" }}
                </h3>
              </div>
              <button
                @click="showHintPopup = false"
                class="bg-white border-2 border-slate-300 rounded-lg text-slate-900 text-sm md:text-base font-semibold py-1.5 px-4 h-10 hover:bg-slate-50 transition-colors"
              >
                <i class="pi pi-times" style="font-size: 1rem"></i>
              </button>
            </div>
            
            <div class="w-full p-4 overflow-y-auto flex-1 bg-white">
              <!-- Info Section -->
              <div class="bg-slate-50 border border-slate-300 rounded-lg p-4 mb-4">
                <div class="flex items-start space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
                  <i class="pi pi-info-circle text-slate-900 mt-0.5" style="font-size: 1.25rem"></i>
                  <div>
                    <p class="text-sm font-semibold text-slate-900 mb-1 px-2 py-1 rounded bg-slate-50">
                      {{ $t("what-is-context-hint") || "What is a Context Hint?" }}
                    </p>
                    <p class="text-xs text-slate-700 px-2 py-1 rounded bg-slate-50">
                      {{ $t("context-hint-description") || "Provide brief context about your text's topic (e.g., Medical document, Legal contract) to get more accurate, domain-specific translations." }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Hint Input -->
              <div class="mb-4">
                <label class="block text-sm font-semibold text-slate-900 mb-2">
                  {{ $t("context-hint-label") || "What is this text about?" }}
                </label>
                <textarea
                  v-model="translationHint"
                  @input="handleHintInput"
                  :placeholder="$t('context-hint-placeholder') || 'e.g., Medical document, Legal contract, Technical manual, Business presentation, Marketing content, etc.'"
                  class="w-full px-4 py-3 text-sm border-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 resize-none transition-all bg-white"
                  :class="{
                    'border-slate-900 bg-slate-50': translationHint && translationHint.trim().length > 0,
                    'border-slate-300': !translationHint || translationHint.trim().length === 0
                  }"
                  rows="3"
                  maxlength="200"
                ></textarea>
                
                <!-- Character Counter with Visual Feedback -->
                <div
                  :class="{ 'text-right': locale === 'ar' }"
                  class="flex items-center justify-between mt-2"
                >
                  <div class="flex items-center space-x-2">
                    <div
                      class="flex-1 h-1.5 bg-slate-200 rounded-full overflow-hidden"
                      :class="{ 'max-w-24': locale !== 'ar' }"
                    >
                      <div
                        class="h-full rounded-full transition-all duration-300"
                        :class="{
                          'bg-slate-900': translationHint.length < 150,
                          'bg-subOrange': translationHint.length >= 150 && translationHint.length < 190,
                          'bg-subOrange opacity-90': translationHint.length >= 190
                        }"
                        :style="{ width: `${(translationHint.length / 200) * 100}%` }"
                      ></div>
                    </div>
                    <span
                      class="text-xs font-medium"
                        :class="{
                          'text-slate-900': translationHint.length < 150,
                          'text-subOrange': translationHint.length >= 150
                        }"
                    >
                      {{ translationHint.length }}/200
                    </span>
                  </div>
                  <button
                    v-if="translationHint && translationHint.trim().length > 0"
                    @click="translationHint = ''"
                    class="flex items-center space-x-1 text-xs text-subOrange hover:text-subOrange hover:opacity-80 font-medium transition-colors"
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                  >
                    <i class="pi pi-times" style="font-size: 0.75rem"></i>
                    <span>{{ $t("clear-hint") || "Clear" }}</span>
                  </button>
                </div>
              </div>
              
              <!-- Quick Example Buttons -->
              <div class="mb-4">
                <p class="text-xs text-slate-700 mb-2 font-medium">
                  {{ $t("quick-examples") || "Quick examples:" }}
                </p>
                <div
                  class="flex flex-wrap gap-2"
                  :class="{ 'flex-row-reverse': locale === 'ar' }"
                >
                  <button
                    v-for="example in contextExamples"
                    :key="example"
                    @click="translationHint = example"
                    class="px-3 py-1.5 text-xs bg-white hover:bg-slate-900 hover:text-white text-slate-900 rounded-full transition-all duration-200 border border-slate-300 hover:border-slate-900 font-medium"
                  >
                    {{ example }}
                  </button>
                </div>
              </div>

              <!-- Active Hint Status -->
              <div
                v-if="translationHint && translationHint.trim().length > 0"
                class="bg-slate-50 border-2 border-slate-900 rounded-lg p-3 flex items-center space-x-2 mb-4"
                :class="{ 'space-x-reverse': locale === 'ar' }"
              >
                <i class="pi pi-check-circle text-slate-900" style="font-size: 1.25rem"></i>
                <div>
                  <p class="text-sm font-semibold text-slate-900">
                    {{ $t("hint-active") || "Context Hint Active" }}
                  </p>
                  <p class="text-xs text-slate-700">
                    {{ $t("hint-will-be-used") || "This hint will be used for more accurate translations" }}
                  </p>
                </div>
              </div>
            </div>
            
            <!-- Action Buttons -->
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row space-x-3 w-full items-center justify-end pt-4 border-t-2 border-slate-300 bg-white"
            >
              <button
                @click="showHintPopup = false"
                class="bg-white border-2 border-slate-300 rounded-lg text-slate-900 text-sm md:text-base font-semibold py-2 px-6 hover:bg-slate-50 transition-colors"
              >
                {{ $t("cancel") || "Cancel" }}
              </button>
              <button
                @click="saveHintAndClose"
                :disabled="!translationHint || translationHint.trim().length === 0"
                :class="{
                  'opacity-50 cursor-not-allowed': !translationHint || translationHint.trim().length === 0,
                  'bg-subDark text-white hover:bg-opacity-90': translationHint && translationHint.trim().length > 0
                }"
                class="bg-subDark text-white rounded-lg text-sm md:text-base font-semibold py-2 px-6 transition-all duration-200 hover:shadow-md"
              >
                {{ $t("save") || "Save" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
    <!-- audio player -->
    <!-- <div
      class="flex flex-row space-x-4 w-[60%] items-center justify-center pb-2 mx-auto"
    >
      <button
        @click="speakText"
        class="w-full lg:w-[50%] flex justify-center items-center lg:space-x-4 bg-[#F5F4F4] h-10 p-2 lg:p-3 rounded-full"
      >
        <div v-if="!isPlaying && !isAudioLoading">
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 17v-10l9 5.146-9 4.854z"
            />
          </svg>
        </div>
        <div v-else-if="isAudioLoading">
          <svg
            width="20"
            height="20"
            aria-hidden="true"
            class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
        <div v-else>
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2h20v20h-20z" />
          </svg>
        </div>
        <div class="px-1 lg:hidden"></div>
        <p class="text-[#061B44] font-semibold text-xs lg:text-sm">
          {{ $t("play") }}
        </p></button
      ><button
        @click="downloadAudioFile"
        class="w-full lg:w-[50%] flex justify-center items-center lg:space-x-4 bg-[#F5F4F4] h-10 p-2 lg:p-3 rounded-full"
      >
        <div v-if="isAudioDownloading">
          <svg
            width="20"
            height="20"
            aria-hidden="true"
            class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
        <div v-else>
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.5 8h1v7.826l2.5-3.076.753.665-3.753 4.585-3.737-4.559.737-.677 2.5 3.064v-7.828zm7 12h-13c-2.481 0-4.5-2.019-4.5-4.5 0-2.178 1.555-4.038 3.698-4.424l.779-.14.043-.79c.185-3.447 3.031-6.146 6.48-6.146 3.449 0 6.295 2.699 6.479 6.146l.043.79.78.14c2.142.386 3.698 2.246 3.698 4.424 0 2.481-2.019 4.5-4.5 4.5m.979-9.908c-.212-3.951-3.473-7.092-7.479-7.092s-7.267 3.141-7.479 7.092c-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408"
            />
          </svg>
        </div>
        <div class="px-1 lg:hidden"></div>
        <p class="text-[#061B44] font-semibold text-xs lg:text-sm">
          {{ $t("download-audio") }}
        </p>
      </button>
    </div> -->
    <div></div>
    <div
      v-if="showTextTab"
      class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-center"
    >
      <div
        v-if="!editingTexts && showSavedText"
        :class="{ 'space-x-reverse': locale === 'ar' }"
        class="flex flex-row items-center justify-start space-x-1"
      >
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          fill="#061B44"
        >
          <path
            d="M2.305,11.235a1,1,0,0,1,1.414.024l3.206,3.319L14.3,7.289A1,1,0,0,1,15.7,8.711l-8.091,8a1,1,0,0,1-.7.289H6.9a1,1,0,0,1-.708-.3L2.281,12.649A1,1,0,0,1,2.305,11.235ZM20.3,7.289l-7.372,7.289-.263-.273a1,1,0,1,0-1.438,1.39l.966,1a1,1,0,0,0,.708.3h.011a1,1,0,0,0,.7-.289l8.091-8A1,1,0,0,0,20.3,7.289Z"
          ></path>
        </svg>
        <p class="pb-2 text-[#061B44] font-medium text-sm h-6 lg:text-base">
          {{ $t("saved") }}
        </p>
      </div>
      <div
        v-else-if="editingTexts"
        :class="{ 'space-x-reverse': locale === 'ar' }"
        class="flex flex-row items-center justify-center space-x-1"
      >
        <p class="pb-2 text-[#061B44] font-medium text-sm h-6 lg:text-base">
          {{ $t("saving") }}
        </p>
      </div>
      <!-- text containers -->
      <div
        id="textPanel"
        :class="{ 'space-x-reverse': locale === 'ar' }"
        class="w-full flex flex-col xl:flex-row justify-between pt-1"
      >
        <!-- original text container -->
        <div class="flex flex-col items-start w-full space-y-1">
          <div
            class="flex flex-row items-center justify-start space-x-2 bg-gray-200 px-1 h-10 rounded-md w-full"
          >
            <button
              @click="toggleShowOrinialSummarized(false)"
              :class="{
                'bg-white text-subDark': !showOriginalSummarized,
                'bg-gray-200 text-gray-500': showOriginalSummarized,
              }"
              class="font-normal text-sm md:text-xl w-full md:min-w-44 border-[1px] rounded-md py-[2px] px-2 flex items-center justify-center"
            >
              <p>{{ $t("source-text") }}</p>
            </button>
            <button
              @click="toggleShowOrinialSummarized(true)"
              :class="{
                'bg-white text-subDark': showOriginalSummarized,
                'bg-gray-200 text-gray-500': !showOriginalSummarized,
              }"
              class="font-normal text-sm md:text-xl w-full md:min-w-44 border-[1px] rounded-md py-[2px] px-2 flex items-center justify-center"
            >
              <p>{{ $t("summarized-text") }}</p>
            </button>
          </div>
          <!-- text to speech panel -->
          <div
            class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-start"
          >
            <div
              id="ttsPanel"
              class="rounded-xl w-full h-auto flex flex-col items-start justify-start my-1 space-y-2"
            >
              <div class="flex flex-wrap gap-x-2 gap-y-2">
                <p
                  class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
                >
                  {{ t("voice-over") }}:
                </p>
                <div
                  class="flex flex-row border p-2 border-slate-700 rounded-md h-10"
                >
                  <div
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                    class="flex flex-row items-center justify-center space-x-2 px-2"
                  >
                    <input
                      id="none-checkbox"
                      type="checkbox"
                      value="none"
                      @change="selectOnlyThis($event)"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                    <label
                      for="none-checkbox"
                      class="ms-2 text-sm font-medium text-gray-900"
                      >{{ $t("none") }}</label
                    >
                  </div>
                  <div
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                    class="flex flex-row items-center justify-center space-x-2 px-2"
                  >
                    <input
                      id="female-checkbox"
                      type="checkbox"
                      value="female"
                      @change="selectOnlyThis($event)"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                    <img
                      src="../../../assets/images/youtube/female.svg"
                      alt=""
                      class="w-3"
                    />
                    <label
                      for="female-checkbox"
                      class="ms-2 text-sm font-medium text-gray-900"
                      >{{ $t("female") }}</label
                    >
                  </div>
                  <div
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                    class="flex flex-row items-center justify-center space-x-2 px-2"
                  >
                    <input
                      id="male-checkbox"
                      type="checkbox"
                      value="male"
                      @change="selectOnlyThis($event)"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                    <img
                      src="../../../assets/images/youtube/male.svg"
                      alt=""
                      class="w-3"
                    />
                    <label
                      for="male-checkbox"
                      class="ms-2 text-sm font-medium text-gray-900"
                      >{{ $t("male") }}</label
                    >
                  </div>
                </div>
                <button
                  @click="() => speakText(false)"
                  :class="{ 'opacity-40': showOriginalSummarized }"
                  class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                >
                  <div
                    v-if="
                      isPlaying &&
                      !isAudioLoading &&
                      playOriginalAudio &&
                      !playTranslationAudio
                    "
                  >
                    <svg
                      width="24"
                      height="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M2 2h20v20h-20z" />
                    </svg>
                  </div>
                  <div
                    v-else-if="
                      isAudioLoading &&
                      playOriginalAudio &&
                      !playTranslationAudio
                    "
                  >
                    <svg
                      width="20"
                      height="20"
                      aria-hidden="true"
                      class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </div>
                  <div v-else>
                    <svg
                      width="24"
                      height="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 17v-10l9 5.146-9 4.854z"
                      />
                    </svg>
                  </div>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("play") }}
                  </p>
                </button>
                <div
                  class="flex flex-row border md:p-2 border-slate-700 rounded-md h-10 items-center"
                >
                  <p
                    class="ms-2 text-nowrap text-xs md:text-sm font-medium text-gray-900"
                  >
                    {{ $t("playback-speed") }}
                  </p>
                  <p class="w-7 text-xs text-end font-bold text-blue-600 px-1">
                    {{ playbackSpeed }}x
                  </p>
                  <input
                    type="range"
                    min="0.5"
                    max="2"
                    step="0.25"
                    v-model="playbackSpeed"
                    list="speed-markers"
                    class="ms-2 w-36 md:w-44 h-6 accent-blue-600"
                    @input="setPlaybackSpeed(playbackSpeed)"
                  />
                </div>
                <audio
                  ref="audioElement"
                  controls
                  :class="{ 'opacity-70 pointer-events-none': !audioContent }"
                  class="h-10"
                >
                  <source ref="audioSource" src="" type="audio/mpeg" />
                </audio>
              </div>
              <!-- <button
                @click="() => downloadAudioFile(false)"
                :class="{ 'opacity-40': showOriginalSummarized }"
                class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
              >
                <div v-if="isAudioDownloading && playOriginalAudio">
                  <svg
                    width="20"
                    height="20"
                    aria-hidden="true"
                    class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                </div>
                <div v-else>
                  <svg
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.5 8h1v7.826l2.5-3.076.753.665-3.753 4.585-3.737-4.559.737-.677 2.5 3.064v-7.828zm7 12h-13c-2.481 0-4.5-2.019-4.5-4.5 0-2.178 1.555-4.038 3.698-4.424l.779-.14.043-.79c.185-3.447 3.031-6.146 6.48-6.146 3.449 0 6.295 2.699 6.479 6.146l.043.79.78.14c2.142.386 3.698 2.246 3.698 4.424 0 2.481-2.019 4.5-4.5 4.5m.979-9.908c-.212-3.951-3.473-7.092-7.479-7.092s-7.267 3.141-7.479 7.092c-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408"
                    />
                  </svg>
                </div>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("download-audio") }}
                </p>
              </button> -->
              <div class="flex flex-wrap gap-x-2 gap-y-2">
                <p
                  class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
                >
                  {{ $t("summary") }}:
                </p>
                <button
                  @click="summarizeText(true)"
                  class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                >
                  <svg
                    v-if="summarizingOriginalText"
                    aria-hidden="true"
                    class="inline w-4 text-gray-200 animate-spin fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <img
                    v-else
                    src="../../../assets/icons/robot.svg"
                    alt=""
                    class="h-6 text-black fill-black"
                  />
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("summarize") }}
                  </p>
                </button>
                <div class="flex flex-row items-center space-x-1">
                  <div class="flex flex-col items-center w-[150px] h-10">
                    <div class="flex justify-between w-full mb-1">
                      <span class="text-sm font-medium text-gray-700">{{
                        $t("short")
                      }}</span>
                      <span class="text-sm font-medium text-gray-700">{{
                        $t("long")
                      }}</span>
                    </div>
                    <input
                      type="range"
                      v-model="origineTokenValue"
                      :min="minTokens"
                      :max="maxTokens"
                      step="50"
                      class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                      :style="originSliderStyle"
                    />
                  </div>
                  <div class="mt-3 text-sm font-medium text-gray-700">
                    ~ {{ originalSummPercentage }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="{ 'space-x-reverse': locale === 'ar' }"
            class="container bg-[#F5F4F4] rounded-xl w-full h-auto p-2 flex flex-col items-center justify-center border border-slate-300"
          >
            <div
              v-if="summarizingOriginalText"
              class="flex items-center justify-center w-full h-40"
            >
              <div class="flex flex-col items-center space-y-3">
                <svg
                  aria-hidden="true"
                  class="w-8 h-8 text-gray-200 animate-spin fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <p class="text-slate-700 font-medium text-sm">{{ $t("summarizing") }}</p>
              </div>
            </div>
            <textarea
              v-else-if="showOriginalSummarized"
              ref="originalSummarizedTextAreaRef"
              v-model="originalSummarizedText"
              rows="10"
              :style="{ fontFamily: fontFamily, color: pickedColor }"
              :class="computedOriginalClass"
              :dir="as.originalLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
              class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
            ></textarea>
            <textarea
              v-else
              ref="originalTextAreaRef"
              v-model="originalText"
              rows="10"
              :style="{ fontFamily: fontFamily, color: pickedColor }"
              :class="computedOriginalClass"
              :dir="as.originalLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
              class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
            ></textarea>
            <div
              :class="{ 'lg:space-x-reverse': locale === 'ar' }"
              class="container flex flex-col lg:flex-row items-center justify-start py-4 space-y-2 lg:space-y-0 lg:space-x-2"
            >
              <button
                @click="toggleDownloadTypes"
                class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <img
                  src="../../../assets/images/audio/04.png"
                  alt=""
                  class="h-3 lg:h-5"
                />
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("download") }}
                </p>
              </button>
              <button
                @click="copyText(true)"
                class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <img
                  src="../../../assets/images/audio/05.png"
                  alt=""
                  class="h-3 lg:h-5"
                />
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("Copy") }}
                </p>
              </button>
              <button
                @click="resetText(true)"
                :class="{ 'opacity-40': showOriginalSummarized }"
                class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 0c-3.31 0-6.291 1.353-8.459 3.522l-2.48-2.48-1.061 7.341 7.437-.966-2.489-2.488c1.808-1.808 4.299-2.929 7.052-2.929 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.872 0-7.229-2.216-8.89-5.443l-1.717 1.046c2.012 3.803 6.005 6.397 10.607 6.397 6.627 0 12-5.373 12-12s-5.373-12-12-12z"
                  />
                </svg>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("discard-changes") }}
                </p>
              </button>
              <button
                @click="openFindReplace('text', 'original')"
                :class="{ 'opacity-40': showOriginalSummarized }"
                class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <svg
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  class="text-[#061B44]"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="font-semibold text-xs lg:text-sm"
                >
                  {{ $t("find-replace") }}
                </p>
              </button>
            </div>
            <div
              v-if="showDownloadTypes"
              class="overlay z-50"
              @click="toggleDownloadTypes"
            >
              <div class="overlay-content relative" @click.stop>
                <p
                  class="text-[#061B44] font-semibold text-xl pb-4 text-center"
                >
                  {{ $t("download-as") }}
                </p>
                <ul
                  class="py-1 h-75vh grid grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto pb-4"
                >
                  <li
                    v-for="type in supportFileDownloadTypes"
                    :key="type"
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                    class="flex flex-row space-x-2 hover:bg-[#4867C8] hover:bg-opacity-10"
                  >
                    <a
                      @click="downloadFileAs(type, true)"
                      class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer border border-slate-700 rounded-md w-full text-center"
                    >
                      {{ type }}
                    </a>
                  </li>
                </ul>
                <div
                  @click="showDownloadTypes = false"
                  class="absolute right-0 top-0 bg-[#4867C8] p-2 rounded-bl-2xl rounded-tr-md cursor-pointer"
                >
                  <img
                    src="../../../assets/images/audio/close.svg"
                    class="w-6 fill-white text-white invert"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="showDownloadTranslatedTypes"
              class="overlay z-50"
              @click="toggleDownloadTranslatedTypes"
            >
              <div class="overlay-content relative" @click.stop>
                <p
                  class="text-[#061B44] font-semibold text-xl pb-4 text-center"
                >
                  {{ $t("download-as") }}
                </p>
                <ul
                  class="py-1 h-75vh grid grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto pb-4"
                >
                  <li
                    v-for="type in supportFileDownloadTypes"
                    :key="type"
                    class="flex flex-row space-x-2 hover:bg-[#4867C8] hover:bg-opacity-10"
                  >
                    <div v-if="type === 'json'"></div>
                    <a
                      v-else
                      @click="downloadFileAs(type, false)"
                      class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer border border-slate-700 rounded-md w-full text-center"
                    >
                      {{ type }}
                    </a>
                  </li>
                </ul>
                <div
                  @click="showDownloadTranslatedTypes = false"
                  class="absolute right-0 top-0 bg-[#4867C8] p-2 rounded-bl-2xl rounded-tr-md cursor-pointer"
                >
                  <img
                    src="../../../assets/images/audio/close.svg"
                    class="w-6 fill-white text-white invert"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="px-2"></div>
        <!-- translated text container -->
        <div class="flex flex-col items-start w-full space-y-1">
          <div class="flex flex-row justify-between w-full">
            <div
              class="flex flex-row items-center justify-start space-x-2 bg-gray-200 px-1 h-10 rounded-md w-full"
            >
              <button
                @click="toggleShowTranslatedSummarized(false)"
                :class="{
                  'bg-white text-subDark': !showTranslatedSummarized,
                  'bg-gray-200 text-gray-500': showTranslatedSummarized,
                }"
                class="font-normal text-sm md:text-xl w-full md:min-w-44 border-[1px] rounded-md py-[2px] px-2 flex items-center justify-center"
              >
                {{ $t("translated-text-0") }}
              </button>
              <button
                @click="toggleShowTranslatedSummarized(true)"
                :class="{
                  'bg-white text-subDark': showTranslatedSummarized,
                  'bg-gray-200 text-gray-500': !showTranslatedSummarized,
                }"
                class="font-normal text-sm md:text-xl w-full md:min-w-44 border-[1px] rounded-md py-[2px] px-2 flex items-center justify-center"
              >
                <p>{{ $t("summarized-text") }}</p>
              </button>
            </div>
            <div v-if="showTranslatedSummarized" class="relative inline-block">
              <button
                @click="isSummarizedLangsDropOpen = !isSummarizedLangsDropOpen"
                class="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <i
                  class="pi pi-globe text-gray-500"
                  style="font-size: 1rem"
                ></i>
                <span>
                  {{ getLanguageName(selectedSummarizedLanguage) }}
                </span>
                <i
                  :class="[
                    'pi',
                    isSummarizedLangsDropOpen
                      ? 'pi-chevron-up'
                      : 'pi-chevron-down',
                    'text-gray-500',
                  ]"
                  style="font-size: 0.75rem"
                ></i>
              </button>
              <div
                v-if="isSummarizedLangsDropOpen"
                class="absolute z-10 mt-1 min-w-32 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto"
                @click.stop
              >
                <hr class="border-gray-200" />
                <ul>
                  <li
                    v-for="language in translatedSummarizesLangs"
                    :key="language"
                    @click="selectTranslatedSummaryLang(language)"
                    class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-blue-50 hover:text-blue-900"
                    :class="{
                      'bg-blue-50 text-blue-900':
                        selectedSummarizedLanguage === language.id,
                    }"
                  >
                    <i
                      class="pi pi-globe text-gray-500"
                      style="font-size: 1rem"
                    ></i>
                    <span>{{ getLanguageName(language) }}</span>
                    <i
                      v-if="selectedSummarizedLanguage === language"
                      class="pi pi-check ml-auto text-blue-600"
                      style="font-size: 1rem"
                    ></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- text to speech panel -->
          <div
            class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-start"
          >
            <div
              id="ttsPanel"
              class="rounded-xl w-full h-auto flex flex-col items-start justify-start my-1 space-y-2"
            >
              <div class="flex flex-wrap gap-x-2 gap-y-2">
                <p
                  class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
                >
                  {{ t("voice-over") }}:
                </p>
                <div
                  class="flex flex-row border p-2 border-slate-700 rounded-md h-10"
                >
                  <div
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                    class="flex flex-row items-center justify-center space-x-2 px-2"
                  >
                    <input
                      id="none-checkbox-translated"
                      type="checkbox"
                      value="none"
                      @change="selectOnlyThisTranslation($event)"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                    <label
                      for="none-checkbox-translated"
                      class="ms-2 text-sm font-medium text-gray-900"
                      >{{ $t("none") }}</label
                    >
                  </div>
                  <div
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                    class="flex flex-row items-center justify-center space-x-2 px-2"
                  >
                    <input
                      id="female-checkbox-translated"
                      type="checkbox"
                      value="female"
                      @change="selectOnlyThisTranslation($event)"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                    <img
                      src="../../../assets/images/youtube/female.svg"
                      alt=""
                      class="w-3"
                    />
                    <label
                      for="female-checkbox-translated"
                      class="ms-2 text-sm font-medium text-gray-900"
                      >{{ $t("female") }}</label
                    >
                  </div>
                  <div
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                    class="flex flex-row items-center justify-center space-x-2 px-2"
                  >
                    <input
                      id="male-checkbox-translated"
                      type="checkbox"
                      value="male"
                      @change="selectOnlyThisTranslation($event)"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                    <img
                      src="../../../assets/images/youtube/male.svg"
                      alt=""
                      class="w-3"
                    />
                    <label
                      for="male-checkbox-translated"
                      class="ms-2 text-sm font-medium text-gray-900"
                      >{{ $t("male") }}</label
                    >
                  </div>
                </div>
                <button
                  @click="() => speakText(true)"
                  :class="{ 'opacity-40': showTranslatedSummarized }"
                  class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                >
                  <div
                    v-if="
                      isPlaying &&
                      !isAudioLoading &&
                      playTranslationAudio &&
                      !playOriginalAudio
                    "
                  >
                    <!-- stop -->
                    <svg
                      width="24"
                      height="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M2 2h20v20h-20z" />
                    </svg>
                  </div>
                  <div
                    v-else-if="
                      isAudioLoading &&
                      playTranslationAudio &&
                      !playOriginalAudio
                    "
                  >
                    <!-- loading -->
                    <svg
                      width="20"
                      height="20"
                      aria-hidden="true"
                      class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </div>
                  <div v-else>
                    <!-- start -->
                    <svg
                      width="24"
                      height="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 17v-10l9 5.146-9 4.854z"
                      />
                    </svg>
                  </div>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("play") }}
                  </p>
                </button>
                <div
                  class="flex flex-row border p-2 border-slate-700 rounded-md h-10 items-center"
                >
                  <p
                    class="ms-2 text-nowrap text-xs md:text-sm font-medium text-gray-900"
                  >
                    {{ $t("playback-speed") }}
                  </p>
                  <p
                    class="ms-2 text-nowrap text-xs md:text-sm font-medium text-gray-900"
                  >
                    {{ playbackSpeedTranslated }}x
                  </p>
                  <input
                    type="range"
                    min="0.5"
                    max="2"
                    step="0.25"
                    v-model="playbackSpeedTranslated"
                    list="speed-markers"
                    class="ms-2 w-36 md:w-44 h-6 accent-blue-600"
                    @input="setPlaybackSpeedTranslated(playbackSpeedTranslated)"
                  />
                </div>
                <audio
                  ref="audioElementTranslated"
                  controls
                  :class="{ 'opacity-70 pointer-events-none': !audioContentTranslated }"
                  class="h-10"
                >
                  <source
                    ref="audioSourceTranslated"
                    src=""
                    type="audio/mpeg"
                  />
                </audio>
              </div>
              <!-- <button
                @click="() => downloadAudioFile(true)"
                :class="{ 'opacity-40': showTranslatedSummarized }"
                class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
              >
                <div v-if="isAudioDownloading && !playOriginalAudio">
                  <svg
                    width="20"
                    height="20"
                    aria-hidden="true"
                    class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                </div>
                <div v-else>
                  <svg
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.5 8h1v7.826l2.5-3.076.753.665-3.753 4.585-3.737-4.559.737-.677 2.5 3.064v-7.828zm7 12h-13c-2.481 0-4.5-2.019-4.5-4.5 0-2.178 1.555-4.038 3.698-4.424l.779-.14.043-.79c.185-3.447 3.031-6.146 6.48-6.146 3.449 0 6.295 2.699 6.479 6.146l.043.79.78.14c2.142.386 3.698 2.246 3.698 4.424 0 2.481-2.019 4.5-4.5 4.5m.979-9.908c-.212-3.951-3.473-7.092-7.479-7.092s-7.267 3.141-7.479 7.092c-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408"
                    />
                  </svg>
                </div>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("download-audio") }}
                </p>
              </button> -->
              <div class="flex flex-wrap gap-x-2 gap-y-2">
                <p
                  class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
                >
                  {{ $t("summary") }}:
                </p>
                <button
                  @click="summarizeText(false)"
                  class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                >
                  <svg
                    v-if="summarizingTranslatedText"
                    aria-hidden="true"
                    class="inline w-4 text-gray-200 animate-spin fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <img
                    v-else
                    src="../../../assets/icons/robot.svg"
                    alt=""
                    class="h-6 text-black fill-black"
                  />
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("summarize") }}
                  </p>
                </button>
                <div class="flex flex-row space-x-1 items-center">
                  <div class="flex flex-col items-center w-[150px] h-10">
                    <div class="flex justify-between w-full mb-1">
                      <span class="text-sm font-medium text-gray-700">{{
                        $t("short")
                      }}</span>
                      <span class="text-sm font-medium text-gray-700">{{
                        $t("long")
                      }}</span>
                    </div>
                    <input
                      type="range"
                      v-model="translatedTokenValue"
                      :min="minTokens"
                      :max="maxTokens"
                      step="50"
                      class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                      :style="translatedSliderStyle"
                    />
                  </div>
                  <div class="mt-3 text-sm font-medium text-gray-700">
                    ~ {{ translatedSummPercentage }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="{ 'space-x-reverse': locale === 'ar' }"
            class="container bg-[#F5F4F4] rounded-xl w-full h-auto p-2 flex flex-col items-center justify-center border border-slate-300"
          >
            <div
              v-if="summarizingTranslatedText"
              class="flex items-center justify-center w-full h-40"
            >
              <div class="flex flex-col items-center space-y-3">
                <svg
                  aria-hidden="true"
                  class="w-8 h-8 text-gray-200 animate-spin fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <p class="text-slate-700 font-medium text-sm">{{ $t("summarizing") }}</p>
              </div>
            </div>
            <textarea
              v-else-if="showTranslatedSummarized"
              ref="translatedSummarizedTextAreaRef"
              v-model="translatedSummarizedText"
              rows="10"
              :style="{ fontFamily: fontFamily, color: pickedColor }"
              :class="computedTranslatedClass"
              :dir="as.translationLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
              class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
            ></textarea>
            <textarea
              v-else
              ref="translatedTextAreaRef"
              v-model="translatedText"
              rows="10"
              :style="{ fontFamily: fontFamily, color: pickedColor }"
              :class="computedTranslatedClass"
              :dir="as.translationLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
              class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
            ></textarea>
            <div
              :class="{ 'lg:space-x-reverse': locale === 'ar' }"
              class="container flex flex-col lg:flex-row items-center justify-start py-4 space-y-2 lg:space-y-0 lg:space-x-2"
            >
              <button
                @click="toggleDownloadTranslatedTypes"
                class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <img
                  src="../../../assets/images/audio/04.png"
                  alt=""
                  class="h-3 lg:h-5"
                />
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("download") }}
                </p>
              </button>
              <button
                @click="copyText(false)"
                class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <img
                  src="../../../assets/images/audio/05.png"
                  alt=""
                  class="h-3 lg:h-5"
                />
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("Copy") }}
                </p>
              </button>
              <button
                @click="resetText(false)"
                :class="{ 'opacity-40': showTranslatedSummarized }"
                class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 0c-3.31 0-6.291 1.353-8.459 3.522l-2.48-2.48-1.061 7.341 7.437-.966-2.489-2.488c1.808-1.808 4.299-2.929 7.052-2.929 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.872 0-7.229-2.216-8.89-5.443l-1.717 1.046c2.012 3.803 6.005 6.397 10.607 6.397 6.627 0 12-5.373 12-12s-5.373-12-12-12z"
                  />
                </svg>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("discard-changes") }}
                </p>
              </button>
              <button
                @click="openFindReplace('text', 'translated')"
                :class="{ 'opacity-40': showTranslatedSummarized }"
                class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <svg
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  class="text-[#061B44]"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="font-semibold text-xs lg:text-sm"
                >
                  {{ $t("find-replace") }}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- font handler -->
      <div
        class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-center"
      >
        <p class="text-[#061B44] font-semibold text-xl">
          {{ $t("font-settings") }}
        </p>
        <div
          id="fontPanel"
          class="flex flex-wrap w-full items-center gap-x-2 space-y-4 lg:space-y-0"
        >
          <div
            :class="{ 'space-x-reverse': locale === 'ar' }"
            class="w-full flex flex-wrap justify-start gap-x-2 md:gap-x-0 gap-y-2 md:gap-y-0 md:space-x-1 lg:space-x-4 rounded-full"
          >
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row items-center space-x-2 border border-slate-500 px-4 h-10 rounded-lg"
            >
              <p class="text-[#061B44] font-bold text-xs lg:text-sm">
                {{ $t("font-size") }}
              </p>
              <button
                @click="decreaseFontSize"
                class="text-xl flex items-center justify-center h-5 w-4 text-[#061B44] font-bold"
              >
                <p><</p>
              </button>
              <p class="text-lg font-semibold text-[#061B44]">
                {{ fontSizePercent }}%
              </p>
              <button
                @click="increaseFontSize"
                class="text-xl flex items-center justify-center h-5 w-4 text-[#061B44] font-bold"
              >
                <p>></p>
              </button>
            </div>
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row items-center space-x-2 border border-slate-500 px-4 h-10 rounded-lg"
            >
              <p class="text-[#061B44] font-bold text-xs lg:text-sm">
                {{ $t("font-color") }}
              </p>
              <color-picker
                v-model:pureColor="pickedColor"
                format="hex"
                shape="circle"
              />
            </div>
            <button
              @click="showFontFamilyList"
              class="flex flex-row justify-center items-center border border-slate-500 px-4 h-10 rounded-lg"
            >
              <p
                :class="{ 'pl-2': locale === 'ar', 'pr-2': locale !== 'ar' }"
                class="text-[#061B44] font-bold text-xs lg:text-sm"
              >
                {{ $t("font") }}
              </p>
              <p class="text-[#061B44] font-medium text-xs lg:text-sm">
                {{ fontFamily }}
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- caption panel -->
    <div
      v-if="!showTextTab"
      class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-center"
    >
      <div
        v-if="!editingSubtitles && showSubtitlesText"
        :class="{ 'space-x-reverse': locale === 'ar' }"
        class="flex flex-row items-center justify-start space-x-1"
      >
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          fill="#061B44"
        >
          <path
            d="M2.305,11.235a1,1,0,0,1,1.414.024l3.206,3.319L14.3,7.289A1,1,0,0,1,15.7,8.711l-8.091,8a1,1,0,0,1-.7.289H6.9a1,1,0,0,1-.708-.3L2.281,12.649A1,1,0,0,1,2.305,11.235ZM20.3,7.289l-7.372,7.289-.263-.273a1,1,0,1,0-1.438,1.39l.966,1a1,1,0,0,0,.708.3h.011a1,1,0,0,0,.7-.289l8.091-8A1,1,0,0,0,20.3,7.289Z"
          ></path>
        </svg>
        <p class="pb-2 text-[#061B44] font-medium text-sm h-6 lg:text-base">
          {{ $t("saved") }}
        </p>
      </div>
      <div
        v-else-if="editingSubtitles"
        :class="{ 'space-x-reverse': locale === 'ar' }"
        class="flex flex-row items-center justify-center space-x-1"
      >
        <p class="pb-2 text-[#061B44] font-medium text-sm h-6 lg:text-base">
          {{ $t("saving") }}
        </p>
      </div>
      <!-- edit srt panel -->
      <div
        id="srtPanel"
        class="flex flex-col md:flex-row justify-between pt-1 space-y-2 md:space-y-0 w-full"
      >
        <!-- original text container -->
        <div
          class="flex flex-col items-start md:items-center w-full space-y-1"
        >
          <p class="text-[#061B44] font-semibold text-sm md:text-xl">
            {{ $t("source-captions") }}
          </p>
          <!-- Speaker Diarization Display - Toggleable panel -->
          <div
            v-if="!showTextTab && parsedCaptionsWithSpeakers.length > 0"
            class="bg-white rounded-xl w-full max-w-full h-auto p-4 mb-4 flex flex-col items-start justify-center border-2 border-blue-300 shadow-md"
            style="width: 100%;"
          >
            <!-- Header with Toggle Button and Color Controls -->
            <div class="flex items-center justify-between w-full mb-3">
              <p class="text-[#061B44] font-semibold text-xs md:text-sm">
                {{ $t("speaker-diarization") || "Multi-Speaker Detection" }}
              </p>
              <div class="flex items-center space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
                <!-- Color Controls Button -->
                <button
                  @click.stop="showSpeakerColorControls = !showSpeakerColorControls"
                  class="px-2 py-1 rounded-md text-xs font-medium transition-colors bg-gray-100 text-gray-700 hover:bg-gray-200"
                  :title="$t('speaker-color-settings') || 'Speaker Color Settings'"
                >
                  🎨
                </button>
                <!-- Show/Hide Toggle Button -->
                <button
                  @click="showSpeakerDiarization = !showSpeakerDiarization"
                  class="flex items-center space-x-1 px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                  :class="[
                    showSpeakerDiarization 
                      ? 'bg-blue-100 text-blue-700 hover:bg-blue-200' 
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200',
                    { 'space-x-reverse': locale === 'ar' }
                  ]"
                >
                  <svg 
                    v-if="showSpeakerDiarization"
                    class="w-4 h-4" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                  </svg>
                  <svg 
                    v-else
                    class="w-4 h-4" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                  <span>{{ showSpeakerDiarization ? ($t("hide") || "Hide") : ($t("show") || "Show") }}</span>
                </button>
              </div>
            </div>
            <!-- Color Controls Panel -->
            <div 
              v-show="showSpeakerColorControls && showSpeakerDiarization" 
              class="w-full mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200"
            >
              <p class="text-xs font-semibold text-gray-700 mb-2">
                {{ $t("speaker-color-settings") || "Speaker Color Settings" }}
              </p>
              <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2">
                <div 
                  v-for="speakerNum in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" 
                  :key="speakerNum"
                  class="flex items-center space-x-2"
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                >
                  <label class="text-xs text-gray-600 min-w-[60px]">
                    {{ $t("speaker") || "Speaker" }} {{ speakerNum }}:
                  </label>
                  <input
                    type="color"
                    :value="getSpeakerColor(speakerNum)"
                    @input="updateSpeakerColor(speakerNum, ($event.target as HTMLInputElement).value)"
                    class="w-8 h-8 rounded border border-gray-300 cursor-pointer"
                  />
                </div>
              </div>
            </div>
            <!-- Collapsible Content -->
            <div v-show="showSpeakerDiarization" class="w-full">
              <p v-if="!parsedCaptionsWithSpeakers.some(c => c.speakerTag !== null && c.speakerTag !== undefined || (c.words && c.words.some(w => w.speakerTag !== null && w.speakerTag !== undefined)))" 
                 class="text-amber-600 text-xs mb-2 italic bg-amber-50 p-2 rounded">
                ⚠️ {{ $t("speaker-info-not-available") }}
              </p>
              <div class="w-full max-h-96 overflow-y-auto space-y-2">
              <div
                v-for="(caption, index) in parsedCaptionsWithSpeakers"
                :key="index"
                class="caption-item p-2 rounded-md border-l-4 transition-all duration-200 hover:shadow-sm"
                :style="{
                  borderLeftColor: getSpeakerColor(caption.speakerTag),
                  backgroundColor: `${getSpeakerColor(caption.speakerTag)}10`
                }"
              >
                <div v-if="caption.words && caption.words.length > 0" class="flex flex-wrap gap-1">
                  <span
                    v-for="(wordData, wordIdx) in caption.words"
                    :key="wordIdx"
                    :style="{
                      color: getSpeakerColor(wordData.speakerTag),
                      fontWeight: wordData.speakerTag ? 500 : 400
                    }"
                    class="inline-block"
                  >
                    {{ wordData.word }}
                  </span>
                </div>
                <div v-else class="text-slate-700">
                  {{ caption.text }}
                </div>
                <div class="flex items-center justify-between mt-2 text-xs">
                  <span 
                    v-if="caption.speakerTag !== null && caption.speakerTag !== undefined" 
                    class="font-bold px-3 py-1.5 rounded-md shadow-sm" 
                    :style="{ 
                      color: 'white',
                      backgroundColor: getSpeakerColor(caption.speakerTag)
                    }"
                  >
                    🎤 {{ $t("speaker") || "Speaker" }} {{ caption.speakerTag }}
                  </span>
                  <span v-else-if="caption.words && caption.words.some(w => w.speakerTag !== null && w.speakerTag !== undefined)" 
                    class="font-bold px-3 py-1.5 rounded-md text-white bg-gradient-to-r from-purple-500 to-pink-500 shadow-sm">
                    🎤 {{ $t("multiple-speakers") || "Multiple Speakers" }}
                  </span>
                  <span v-else class="font-medium px-3 py-1.5 rounded-md text-slate-600 bg-slate-200">
                    🎤 {{ $t("speaker-unknown") || "Speaker Unknown" }}
                  </span>
                  <span class="text-slate-500 ml-2">
                    {{ caption.start }} → {{ caption.dur }}
                  </span>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div
            class="container bg-[#F5F4F4] rounded-xl w-full h-auto p-2 flex flex-col items-center justify-center border border-slate-300"
          >
            <textarea
              ref="webvttTextArea1"
              @scroll="syncScroll('webvttTextArea2')"
              v-model="originalAudioSubtitle"
              rows="10"
              :style="{ fontFamily: fontFamily, color: pickedColor }"
              :class="computedOriginalClass"
              :dir="as.originalLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
              class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
            ></textarea>
            <div
              :class="{ 'lg:space-x-reverse': locale === 'ar' }"
              class="container flex flex-col lg:flex-row items-center justify-start py-4 space-y-2 lg:space-y-0 lg:space-x-2"
            >
              <button
                @click="toggleDownloadSRTTypes"
                class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <img
                  src="../../../assets/images/audio/04.png"
                  alt=""
                  class="h-3 lg:h-5"
                />
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("download") }}
                </p>
              </button>
              <button
                @click="copySubtitle(true)"
                class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <img
                  src="../../../assets/images/audio/05.png"
                  alt=""
                  class="h-3 lg:h-5"
                />
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("Copy") }}
                </p>
              </button>
              <button
                @click="resetSubtitle(true)"
                class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 0c-3.31 0-6.291 1.353-8.459 3.522l-2.48-2.48-1.061 7.341 7.437-.966-2.489-2.488c1.808-1.808 4.299-2.929 7.052-2.929 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.872 0-7.229-2.216-8.89-5.443l-1.717 1.046c2.012 3.803 6.005 6.397 10.607 6.397 6.627 0 12-5.373 12-12s-5.373-12-12-12z"
                  />
                </svg>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("discard-changes") }}
                </p>
              </button>
              <button
                @click="openFindReplace('caption', 'original')"
                class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <svg
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  class="text-[#061B44]"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("find-replace") }}
                </p>
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="showDownloadSRTTypes"
          class="overlay z-50"
          @click="toggleDownloadSRTTypes"
        >
          <div class="overlay-content relative" @click.stop>
            <p class="text-[#061B44] font-semibold text-xl pb-4 text-center">
              {{ $t("download-as") }}
            </p>
            <ul
              class="py-1 h-75vh grid grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto pb-4"
            >
              <li
                v-for="type in supportFileDownloadSRTTypes"
                :key="type"
                :class="{ 'space-x-reverse': locale === 'ar' }"
                class="flex flex-row space-x-2 hover:bg-[#4867C8] hover:bg-opacity-10"
              >
                <a
                  @click="downloadFileAs(type, true)"
                  class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer border border-slate-700 rounded-md w-full text-center"
                >
                  {{ type }}
                </a>
              </li>
            </ul>
            <div
              @click="showDownloadSRTTypes = false"
              class="absolute right-0 top-0 bg-[#4867C8] p-2 rounded-bl-2xl rounded-tr-md cursor-pointer"
            >
              <img
                src="../../../assets/images/audio/close.svg"
                class="w-6 fill-white text-white invert"
              />
            </div>
            <div
              @click.stop
              class="flex flex-row items-center justify-start space-x-2 py-2"
            >
              <input
                id="ignoreTiming-checkbox"
                type="checkbox"
                v-model="downloadOnlySentencesSrt"
                @change="handleIgnoreSrtCheckbox($event)"
                class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
              />
              <label class="text-base font-medium text-gray-900">{{
                $t("Download_only_the_extracted_s")
              }}</label>
            </div>
          </div>
        </div>
        <div
          v-if="showDownloadTranslatedSRTTypes"
          class="overlay z-50"
          @click="toggleDownloadTranslatedSRTTypes"
        >
          <div class="overlay-content relative" @click.stop>
            <p class="text-[#061B44] font-semibold text-xl pb-4 text-center">
              {{ $t("download-as") }}
            </p>
            <ul
              class="py-1 h-75vh grid grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto pb-4"
            >
              <li
                v-for="type in supportFileDownloadSRTTypes"
                :key="type"
                :class="{ 'space-x-reverse': locale === 'ar' }"
                class="flex flex-row space-x-2 hover:bg-[#4867C8] hover:bg-opacity-10"
              >
                <a
                  @click="downloadFileAs(type, false)"
                  class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer border border-slate-700 rounded-md w-full text-center"
                >
                  {{ type }}
                </a>
              </li>
            </ul>
            <div
              @click="showDownloadTranslatedSRTTypes = false"
              class="absolute right-0 top-0 bg-[#4867C8] p-2 rounded-bl-2xl rounded-tr-md cursor-pointer"
            >
              <img
                src="../../../assets/images/audio/close.svg"
                class="w-6 fill-white text-white invert"
              />
            </div>
            <div
              @click.stop
              class="flex flex-row items-center justify-start space-x-2 py-2"
            >
              <input
                id="ignoreTiming-checkbox"
                type="checkbox"
                v-model="downloadOnlySentencesSrt"
                @change="handleIgnoreSrtCheckbox($event)"
                class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
              />
              <label class="text-base font-medium text-gray-900">{{
                $t("Download_only_the_extracted_s")
              }}</label>
            </div>
          </div>
        </div>
        <div class="px-2"></div>
        <!-- translated text container -->
        <div
          class="flex flex-col items-start md:items-center w-full space-y-1"
        >
          <p class="text-[#061B44] font-semibold text-sm md:text-xl">
            {{ $t("translated-captions") }}
          </p>
          <!-- Speaker Diarization Display for Translated Captions - Toggleable panel -->
          <div
            v-if="!showTextTab && translatedCaptionsWithSpeakers.length > 0"
            class="bg-white rounded-xl w-full max-w-full h-auto p-4 mb-4 flex flex-col items-start justify-center border-2 border-blue-300 shadow-md"
            style="width: 100%;"
          >
            <!-- Header with Toggle Button and Color Controls -->
            <div class="flex items-center justify-between w-full mb-3">
              <p class="text-[#061B44] font-semibold text-xs md:text-sm">
                {{ $t("speaker-diarization") || "Multi-Speaker Detection" }} ({{ $t("translated") || "Translated" }})
              </p>
              <div class="flex items-center space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
                <!-- Color Controls Button -->
                <button
                  @click.stop="showTranslatedSpeakerColorControls = !showTranslatedSpeakerColorControls"
                  class="px-2 py-1 rounded-md text-xs font-medium transition-colors bg-gray-100 text-gray-700 hover:bg-gray-200"
                  :title="$t('speaker-color-settings') || 'Speaker Color Settings'"
                >
                  🎨
                </button>
                <!-- Show/Hide Toggle Button -->
                <button
                  @click="showTranslatedSpeakerDiarization = !showTranslatedSpeakerDiarization"
                  class="flex items-center space-x-1 px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                  :class="[
                    showTranslatedSpeakerDiarization 
                      ? 'bg-blue-100 text-blue-700 hover:bg-blue-200' 
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200',
                    { 'space-x-reverse': locale === 'ar' }
                  ]"
                >
                  <svg 
                    v-if="showTranslatedSpeakerDiarization"
                    class="w-4 h-4" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                  </svg>
                  <svg 
                    v-else
                    class="w-4 h-4" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                  <span>{{ showTranslatedSpeakerDiarization ? ($t("hide") || "Hide") : ($t("show") || "Show") }}</span>
                </button>
              </div>
            </div>
            <!-- Color Controls Panel -->
            <div 
              v-show="showTranslatedSpeakerColorControls && showTranslatedSpeakerDiarization" 
              class="w-full mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200"
            >
              <p class="text-xs font-semibold text-gray-700 mb-2">
                {{ $t("speaker-color-settings") || "Speaker Color Settings" }}
              </p>
              <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2">
                <div 
                  v-for="speakerNum in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" 
                  :key="speakerNum"
                  class="flex items-center space-x-2"
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                >
                  <label class="text-xs text-gray-600 min-w-[60px]">
                    {{ $t("speaker") || "Speaker" }} {{ speakerNum }}:
                  </label>
                  <input
                    type="color"
                    :value="getSpeakerColor(speakerNum)"
                    @input="updateSpeakerColor(speakerNum, ($event.target as HTMLInputElement).value)"
                    class="w-8 h-8 rounded border border-gray-300 cursor-pointer"
                  />
                </div>
              </div>
            </div>
            <!-- Collapsible Content -->
            <div v-show="showTranslatedSpeakerDiarization" class="w-full">
              <p v-if="!translatedCaptionsWithSpeakers.some(c => c.speakerTag !== null && c.speakerTag !== undefined || (c.words && c.words.some(w => w.speakerTag !== null && w.speakerTag !== undefined)))" 
                 class="text-amber-600 text-xs mb-2 italic bg-amber-50 p-2 rounded">
                ⚠️ {{ $t("speaker-info-not-available") }}
              </p>
              <div class="w-full max-h-96 overflow-y-auto space-y-2">
              <div
                v-for="(caption, index) in translatedCaptionsWithSpeakers"
                :key="index"
                class="caption-item p-2 rounded-md border-l-4 transition-all duration-200 hover:shadow-sm"
                :style="{
                  borderLeftColor: getSpeakerColor(caption.speakerTag),
                  backgroundColor: `${getSpeakerColor(caption.speakerTag)}10`
                }"
              >
                <div v-if="caption.words && caption.words.length > 0" class="flex flex-wrap gap-1">
                  <span
                    v-for="(wordData, wordIdx) in caption.words"
                    :key="wordIdx"
                    :style="{
                      color: getSpeakerColor(wordData.speakerTag),
                      fontWeight: wordData.speakerTag ? 500 : 400
                    }"
                    class="inline-block"
                  >
                    {{ wordData.word }}
                  </span>
                </div>
                <div v-else class="text-slate-700">
                  {{ caption.text }}
                </div>
                <div class="flex items-center justify-between mt-2 text-xs">
                  <span 
                    v-if="caption.speakerTag !== null && caption.speakerTag !== undefined" 
                    class="font-bold px-3 py-1.5 rounded-md shadow-sm" 
                    :style="{ 
                      color: 'white',
                      backgroundColor: getSpeakerColor(caption.speakerTag)
                    }"
                  >
                    🎤 {{ $t("speaker") || "Speaker" }} {{ caption.speakerTag }}
                  </span>
                  <span v-else-if="caption.words && caption.words.some(w => w.speakerTag !== null && w.speakerTag !== undefined)" 
                    class="font-bold px-3 py-1.5 rounded-md text-white bg-gradient-to-r from-purple-500 to-pink-500 shadow-sm">
                    🎤 {{ $t("multiple-speakers") || "Multiple Speakers" }}
                  </span>
                  <span v-else class="font-medium px-3 py-1.5 rounded-md text-slate-600 bg-slate-200">
                    🎤 {{ $t("speaker-unknown") || "Speaker Unknown" }}
                  </span>
                  <span class="text-slate-500 ml-2">
                    {{ caption.start }} → {{ caption.dur }}
                  </span>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div
            class="container bg-[#F5F4F4] rounded-xl w-full h-auto p-2 flex flex-col items-center justify-center border border-slate-300"
          >
            <textarea
              ref="webvttTextArea2"
              @scroll="syncScroll('webvttTextArea1')"
              v-model="translatedAudioSubtitle"
              rows="10"
              :style="{ fontFamily: fontFamily, color: pickedColor }"
              :class="computedTranslatedClass"
              :dir="as.translationLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
              class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
            ></textarea>
            <div
              :class="{ 'lg:space-x-reverse': locale === 'ar' }"
              class="container flex flex-col lg:flex-row items-center justify-start py-4 space-y-2 lg:space-y-0 lg:space-x-2"
            >
              <button
                @click="toggleDownloadTranslatedSRTTypes"
                class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <img
                  src="../../../assets/images/audio/04.png"
                  alt=""
                  class="h-3 lg:h-5"
                />
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("download") }}
                </p>
              </button>
              <button
                @click="copySubtitle(false)"
                class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <img
                  src="../../../assets/images/audio/05.png"
                  alt=""
                  class="h-3 lg:h-5"
                />
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("Copy") }}
                </p>
              </button>
              <button
                @click="resetSubtitle(false)"
                class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 0c-3.31 0-6.291 1.353-8.459 3.522l-2.48-2.48-1.061 7.341 7.437-.966-2.489-2.488c1.808-1.808 4.299-2.929 7.052-2.929 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.872 0-7.229-2.216-8.89-5.443l-1.717 1.046c2.012 3.803 6.005 6.397 10.607 6.397 6.627 0 12-5.373 12-12s-5.373-12-12-12z"
                  />
                </svg>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("discard-changes") }}
                </p>
              </button>
              <button
                @click="openFindReplace('caption', 'translated')"
                class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
              >
                <svg
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  class="text-[#061B44]"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <div class="px-1 lg:hidden"></div>
                <p
                  :class="{ 'pr-2': locale === 'ar' }"
                  class="text-[#061B44] font-semibold text-xs lg:text-sm"
                >
                  {{ $t("find-replace") }}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- font handler -->
      <div
        class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-center"
      >
        <p class="text-[#061B44] font-semibold text-xl">
          {{ $t("font-settings") }}
        </p>
        <div
          id="fontPanel"
          class="flex flex-col lg:flex-row w-full items-center justify-center space-y-4 lg:space-y-0 lg:space-x-4"
        >
          <div
            :class="{ 'space-x-reverse': locale === 'ar' }"
            class="w-full flex flex-wrap justify-start gap-x-2 md:gap-x-0 gap-y-2 md:gap-y-0 md:space-x-1 lg:space-x-4 rounded-full"
          >
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row items-center space-x-2 border border-slate-500 px-4 h-10 rounded-lg"
            >
              <p class="text-[#061B44] font-bold text-xs lg:text-sm">
                {{ $t("font-size") }}
              </p>
              <button
                @click="decreaseFontSize"
                class="text-xl text-[#061B44] font-bold"
              >
                <
              </button>
              <p class="text-lg font-semibold text-[#061B44]">
                {{ fontSizePercent }}%
              </p>
              <button
                @click="increaseFontSize"
                class="text-xl text-[#061B44] font-bold"
              >
                >
              </button>
            </div>
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row items-center space-x-2 border border-slate-500 px-4 h-10 rounded-lg"
            >
              <p class="text-[#061B44] font-bold text-xs lg:text-sm">
                {{ $t("font-color") }}
              </p>
              <color-picker
                v-model:pureColor="pickedColor"
                format="hex"
                shape="circle"
              />
            </div>
            <button
              @click="showFontFamilyList"
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row justify-center items-center border border-slate-500 px-4 h-10 rounded-lg"
            >
              <p
                :class="{ 'pl-2': locale === 'ar', 'pr-2': locale !== 'ar' }"
                class="text-[#061B44] font-bold text-xs lg:text-sm"
              >
                {{ $t("font") }}
              </p>
              <p class="text-[#061B44] font-medium text-xs lg:text-sm">
                {{ fontFamily }}
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Find/Replace Dialog -->
  <FindReplaceDialog
    ref="findReplaceDialogRef"
    :is-open="showFindReplace"
    :show-target-selector="true"
    :initial-target="findReplaceTarget"
    @close="closeFindReplace"
    @find="(term, target) => { findReplaceTarget = target; performFind(term, target); }"
    @find-next="findNextMatch"
  />

  <!-- PDF Preview Modal -->
  <PdfPreviewModal
    :is-open="showPdfPreview"
    :text="previewText"
    :font-family="previewConfig.fontFamily"
    :font-size="previewConfig.fontSize"
    :color="previewConfig.color"
    :is-rtl="previewConfig.isRtl"
    @close="closePdfPreview"
    @export="exportPdfFromPreview"
  />

  <!-- PDF Generation Loading Indicator -->
  <div
    v-if="isPdfGenerating"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10001]"
  >
    <div class="bg-white rounded-lg p-8 flex flex-col items-center space-y-4 min-w-[300px]">
      <svg
        aria-hidden="true"
        class="w-12 h-12 text-gray-200 animate-spin fill-blue-600"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
      <p class="text-slate-700 font-medium text-lg">{{ $t("generating-pdf") || "Generating PDF..." }}</p>
      <p class="text-slate-500 font-normal text-sm">{{ $t("please-wait") || "Please wait..." }}</p>
      <button
        @click="cancelPdfGeneration"
        class="mt-4 px-4 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-md transition-colors"
      >
        {{ $t("pdf-cancel-button") || "Cancel" }}
      </button>
    </div>
  </div>

  <!-- PDF Generation Error Overlay -->
  <div
    v-if="pdfError && !isPdfGenerating"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10001]"
  >
    <div class="bg-white rounded-lg p-8 flex flex-col items-center space-y-4 min-w-[300px]">
      <svg
        class="w-12 h-12 text-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <p class="text-slate-700 font-medium text-lg">{{ $t("pdf-generation-failed") || "PDF Generation Failed" }}</p>
      <p class="text-slate-600 font-normal text-sm text-center">
        {{ pdfError.message }}
        <span v-if="pdfError.pageNumber" class="block mt-1">
          {{ $t("pdf-page-failed", [pdfError.pageNumber]) || `Page ${pdfError.pageNumber} failed` }}
        </span>
      </p>
      <div class="flex space-x-3 mt-2">
        <button
          @click="pdfError = null"
          class="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-md transition-colors"
        >
          {{ $t("close") || "Close" }}
        </button>
        <button
          @click="() => { const error = pdfError; pdfError = null; if (error && previewConfig.isOriginal !== undefined) { downloadAsPdfWithFormatting(previewConfig.isOriginal, previewText, previewFormatting || []); } }"
          class="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md transition-colors"
        >
          {{ $t("pdf-retry-button") || "Retry" }}
        </button>
      </div>
    </div>
  </div>

  <!-- user consume solde -->
  <div
    v-if="showPaymentModal"
    class="overlay bg-gray-600 bg-opacity-50 flex items-center justify-center z-50"
  >
    <div class="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
      <div class="flex flex-row text-xl items-center mb-4 space-x-1">
        <i class="pi pi-credit-card text-blue-500 text-center"></i>
        <h3 class="font-semibold">{{ $t("complete-your-translation") }}</h3>
      </div>
      <p class="text-gray-700 mb-6">{{ modalMessage }}</p>
      <div class="flex justify-end space-x-4">
        <button
          @click="handleModalResponse(false)"
          class="mt-4 bg-white text-slate-900 border-slate-400 border-[1px] h-9 py-1 px-10 rounded-md font-normal text-base"
        >
          {{ t("cancel") }}
        </button>
        <button
          @click="handleModalResponse(true)"
          class="mt-4 text-white bg-slate-900 h-9 py-1 px-10 rounded-md font-normal text-base flex items-center space-x-2"
        >
          <p>{{ $t("continue") }}</p>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.drag-drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

.text-overlay {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px;
  z-index: 999;
}
.videoplay {
  width: 70%;
  height: 100%;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-height: 80vh;
  overflow-y: auto;
  z-index: 51;
}

/* Language picker: inner panels scroll; avoid one giant list height eating the modal */
.overlay-content.is-language-picker-overlay {
  overflow: hidden !important;
}
</style>

<script setup lang="ts">
import { computed, onMounted, ref, watch, onBeforeMount, nextTick, onUnmounted } from "vue";
import {
  languages,
  Language,
  unsupportedCloudTts,
  languageCodeMappings,
} from "../../../utils/languageList";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { SelectedAudio } from "../../../utils/selectedAudio";
import {
  API_BASE_URL,
  TRANSLATE_TEXT,
  TRANSLATE_TEXT_BULK,
  GETPRICES,
  SPEAKTEXT,
  TRANSLATE_CAPTIONS,
  GETTRANSLATEDTEXT,
  GETTRANSAUDIOFILE,
  SUMMARIZETEXT,
  STREAMTEXT,
  TRANSLATE_TEXT_GPT,
  TRANSLATE_TEXT_BULK_GPT,
} from "../../../utils/appConst";
import { openDB, IDBPDatabase } from "idb";
import { toRaw } from "vue";
import { useAuthStore } from "../../../store/auth";
import { useAudioStore } from "../../../store/audioStore";
import { useRoute, useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useUserProfile } from "../../../store/userProfile";
import { useI18n } from "vue-i18n";
import { useUserActivities } from "../../../store/userActivities";
import { ColorPicker } from "vue3-colorpicker";
import { SubscriptionType } from "../../../utils/subscriptionModel";
import { loadFontBase } from "../../../utils/loadFontBase64";
import { CaptionModel } from "../../../utils/captionModel";
import {
  extractWebVttCaptionTexts,
  hasWebVttCaptions,
} from "../../../utils/webvtt";
import servicesPricing from "../../../utils/servicesPricing";
import { useFontStore } from "../../../store/fontsStore";
import { loadGoogleFont } from "../../../utils/loadFont";
import { getDocxExportFontSizeHalfPoints } from "../../../utils/docxExport";
import { useUserPreference } from "../../../store/userPreferences";
import { useHead } from "@vueuse/head";
import FindReplaceDialog from "../../common/FindReplaceDialog.vue";
import PdfPreviewModal from "../../common/PdfPreviewModal.vue";

const route = useRoute();
const router = useRouter();
const activitesStore = useUserActivities();
const as = useAudioStore();
const authStore = useAuthStore();
const profileStore = useUserProfile();
const prefStore = useUserPreference();
const fontStore = useFontStore();
const playOriginalAudio = ref(true);
const playTranslationAudio = ref(true);
const isOpen = ref(false);
const showDownloadTranslatedTypes = ref(false);
const isPlaying = ref(false);
const isAudioLoading = ref(false);
const isAudioDownloading = ref(false);
const isTranslatingCaptions = ref(false);
const isPdfGenerating = ref(false);
const pdfProgress = ref({
  currentPage: 0,
  totalPages: 0,
  percentage: 0,
  status: 'initializing' as 'initializing' | 'rendering' | 'converting' | 'complete' | 'error'
});
const pdfCancelled = ref(false);
const pdfError = ref<{
  message: string,
  pageNumber?: number,
  technical?: string
} | null>(null);
const fontLoadingCache = new Map<string, boolean>();
let html2canvasLoadPromise: Promise<void> | null = null;
const fontSizeNumber = ref(12);
const fontSizeClass = ref("text-lg");
const translatedChecked = ref(true);
const showDownloadTranslatedSRTTypes = ref(false);
const audioElement = ref<HTMLAudioElement | null>(null);
const audioElementTranslated = ref<HTMLAudioElement | null>(null);
const webvttTextArea1 = ref<HTMLTextAreaElement | null>(null);
const webvttTextArea2 = ref<HTMLTextAreaElement | null>(null);
const editingTexts = ref(false);
const editingSubtitles = ref(false);
const showSavedText = ref(false);
const showSubtitlesText = ref(false);
const downloadOnlySentencesSrt = ref(false);
const selectedPreviewFont = ref<string>("");
const translationHint = ref<string>("");
const showHintInput = ref(false);
const showHintPopup = ref(false);

// Find/Replace state
const showFindReplace = ref(false);
const findReplaceTarget = ref<"original" | "translated">("original");
const findReplaceMode = ref<"text" | "caption">("text");
const findReplaceDialogRef = ref<InstanceType<typeof FindReplaceDialog> | null>(null);
const findReplaceMatches = ref<number[]>([]);
const currentFindMatchIndex = ref(-1);
const findReplaceSearchTerm = ref("");
const originalTextAreaRef = ref<HTMLTextAreaElement | null>(null);
const originalSummarizedTextAreaRef = ref<HTMLTextAreaElement | null>(null);
const translatedTextAreaRef = ref<HTMLTextAreaElement | null>(null);
const translatedSummarizedTextAreaRef = ref<HTMLTextAreaElement | null>(null);

// PDF Preview state
const showPdfPreview = ref(false);
const previewText = ref("");
const previewConfig = ref<{
  isOriginal: boolean;
  fontFamily: string;
  fontSize: number;
  color: string;
  isRtl: boolean;
}>({
  isOriginal: true,
  fontFamily: "",
  fontSize: 12,
  color: "#000000",
  isRtl: false,
});

interface ParagraphFormat {
  text: string;
  alignment: 'left' | 'center' | 'right' | 'justify';
  bold: boolean;
  italic: boolean;
  underline: boolean;
}

const previewFormatting = ref<ParagraphFormat[]>([]);

// Toggle for speaker diarization panel visibility (default: visible)
const showSpeakerDiarization = ref(true);
// Toggle for translated speaker diarization panel visibility (default: visible)
const showTranslatedSpeakerDiarization = ref(true);
// Toggle for speaker color controls
const showSpeakerColorControls = ref(false);
// Toggle for translated speaker color controls
const showTranslatedSpeakerColorControls = ref(false);
// Editable speaker colors (reactive)
const speakerColors = ref<Record<number, string>>({
  1: '#4867D3',  // Primary blue
  2: '#10B981',  // Green
  3: '#F59E0B',  // Orange
  4: '#EF4444',  // Red
  5: '#8B5CF6',  // Purple
  6: '#EC4899',  // Pink
  7: '#06B6D4',  // Cyan
  8: '#84CC16',  // Lime
  9: '#F97316',  // Orange-red
  10: '#6366F1'  // Indigo
});
// Speaker color configuration for diarization
const SPEAKER_COLORS: Record<number, string> = {
  1: '#4867D3',  // Primary blue
  2: '#10B981',  // Green
  3: '#F59E0B',  // Orange
  4: '#EF4444',  // Red
  5: '#8B5CF6',  // Purple
  6: '#EC4899',  // Pink
  7: '#06B6D4',  // Cyan
  8: '#84CC16',  // Lime
  9: '#F97316',  // Orange-red
  10: '#6366F1'  // Indigo
};

// Fallback color if speaker tag is missing
const DEFAULT_SPEAKER_COLOR = '#1E293B'; // Dark gray

const contextExamples = [
  "Medical document",
  "Legal contract",
  "Technical manual",
  "Business presentation",
  "Marketing content",
  "Educational material",
  "News article",
  "Scientific paper",
  "User manual",
  "Financial report"
];

// Handle hint input - auto-expand if user starts typing
const handleHintInput = () => {
  if (translationHint.value && translationHint.value.trim().length > 0 && !showHintInput.value) {
    showHintInput.value = true;
  }
};

// Save hint and close popup
const saveHintAndClose = () => {
  if (translationHint.value && translationHint.value.trim().length > 0) {
    showHintPopup.value = false;
    toast(
      t("context-hint-saved") || `Context hint saved: "${translationHint.value.trim()}"`,
      {
        autoClose: 2000,
        type: "success",
        theme: "light",
      }
    );
  }
};

let timeoutTextId: ReturnType<typeof setTimeout> | null = null;
let timeoutSubtitleId: ReturnType<typeof setTimeout> | null = null;
const translateCpationUrl = `${API_BASE_URL}${TRANSLATE_CAPTIONS}`;
const getTranslatedFileUrl = `${API_BASE_URL}${GETTRANSLATEDTEXT}`;
const getTranscriptionFile = `${API_BASE_URL}${GETTRANSAUDIOFILE}`;
const showDownloadSRTTypes = ref(false);
const summarizingOriginalText = ref(false);
const summarizingTranslatedText = ref(false);
const isSummarizedLangsDropOpen = ref(false);
const isTranslationLangDropOpen = ref(false);
const showPaymentModal = ref(false);
const modalMessage = ref("");
const modalResolve = ref<any>(null);
const audioBlob = ref<Blob | null>(null);
const playbackSpeed = ref(1);
const playbackSpeedTranslated = ref(1);
const minTokens = 50;
const maxTokens = 500;
const handleModalResponse = (confirmed: any) => {
  if (modalResolve.value) {
    modalResolve.value(confirmed);
    modalResolve.value = null;
  }
};
const filteredFonts = computed<any[]>(() => {
  return fontStore.fonts.filter((font:any) =>
    font.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
})
const originSliderStyle = computed(() => {
  const percentage =
    ((origineTokenValue.value - minTokens) / (maxTokens - minTokens)) * 100;
  return locale.value === "ar"
    ? {
        background: `linear-gradient(to left, #000000 ${percentage}%, #d1d5db ${percentage}%)`,
      }
    : {
        background: `linear-gradient(to right, #000000 ${percentage}%, #d1d5db ${percentage}%)`,
      };
});
const translatedSliderStyle = computed(() => {
  const percentage =
    ((translatedTokenValue.value - minTokens) / (maxTokens - minTokens)) * 100;
  return locale.value === "ar"
    ? {
        background: `linear-gradient(to left, #000000 ${percentage}%, #d1d5db ${percentage}%)`,
      }
    : {
        background: `linear-gradient(to right, #000000 ${percentage}%, #d1d5db ${percentage}%)`,
      };
});
const originalSummPercentage = computed(() => {
  const range = maxTokens - minTokens;
  const value = origineTokenValue.value - minTokens;
  return Math.round(25 + (value / range) * 60);
});
const translatedSummPercentage = computed(() => {
  const range = maxTokens - minTokens;
  const value = translatedTokenValue.value - minTokens;
  return Math.round(25 + (value / range) * 60);
});
const pickedColor = computed({
  get: () => as.pickedColor,
  set: (value) => (as.pickedColor = value),
});
const latestTranslationTarget = computed({
  get: () => as.latestTranslationTarget,
  set: (value) => (as.latestTranslationTarget = value),
});
const originalJsonContent = computed({
  get: () => as.originalJsonContent,
  set: (value) => (as.originalJsonContent = value),
});
const receivedCaption = computed({
  get: () => as.receivedCaption,
  set: (value) => (as.receivedCaption = value),
});
const processingStarted = computed({
  get: () => as.processingStarted,
  set: (value) => (as.processingStarted = value),
});
const notReadyYet = computed({
  get: () => as.notReadyYet,
  set: (value) => (as.notReadyYet = value),
});
const isFromNotification = computed({
  get: () => as.isFromNotification,
  set: (value) => (as.isFromNotification = value),
});
const isTargetListOpen = computed({
  get: () => as.isTargetListOpen,
  set: (value) => (as.isTargetListOpen = value),
});
const isTranslationPreview = computed({
  get: () => as.isTranslationPreview,
  set: (value) => (as.isTranslationPreview = value),
});
const myLanguagesList = computed({
  get: () => as.myLanguagesList,
  set: (value) => (as.myLanguagesList = value),
});
const searchQuery = computed({
  get: () => as.searchQuery,
  set: (value) => (as.searchQuery = value),
});
const computePricing = computed({
  get: () => as.computePricing,
  set: (value) => (as.computePricing = value),
});
const balanceNotEnough = computed({
  get: () => as.balanceNotEnough,
  set: (value) => (as.balanceNotEnough = value),
});
const originalLanguage = computed({
  get: () => as.originalLanguage,
  set: (value) => (as.originalLanguage = value),
});
const isTargetLanguageSelected = computed({
  get: () => as.isTargetLanguageSelected,
  set: (value) => (as.isTargetLanguageSelected = value),
});
const textTranslationPrice = computed({
  get: () => as.textTranslationPrice,
  set: (value) => (as.textTranslationPrice = value),
});
const translatedText = computed({
  get: () => as.translatedText,
  set: (value) => (as.translatedText = value),
});
const showDownloadTypes = computed({
  get: () => as.showDownloadTypes,
  set: (value) => (as.showDownloadTypes = value),
});
const fontFamily = computed({
  get: () => as.fontFamily,
  set: (value) => (as.fontFamily = value),
});
const fileName = computed({
  get: () => as.fileName,
  set: (value) => (as.fileName = value),
});
const selectedAudio = computed({
  get: () => as.selectedAudio,
  set: (value) => (as.selectedAudio = value),
});
const originalText = computed({
  get: () => as.originalText,
  set: (value) => (as.originalText = value),
});
const fontSizePercent = computed({
  get: () => as.fontSizePercent,
  set: (value) => (as.fontSizePercent = value),
});
const fontFamilyListShow = computed({
  get: () => as.fontFamilyListShow,
  set: (value) => (as.fontFamilyListShow = value),
});
const translationLanguage = computed({
  get: () => as.translationLanguage,
  set: (value) => (as.translationLanguage = value),
});
const audioContent = computed({
  get: () => as.audioContent,
  set: (value) => (as.audioContent = value),
});
const audioContentTranslated = computed({
  get: () => as.audioContentTranslated,
  set: (value) => (as.audioContentTranslated = value),
});
const selectedVoice = computed({
  get: () => as.selectedVoice,
  set: (value) => (as.selectedVoice = value),
});
const selectedVoiceTranslated = computed({
  get: () => as.selectedVoiceTranslated,
  set: (value) => (as.selectedVoiceTranslated = value),
});
const showTextTab = computed({
  get: () => as.showTextTab,
  set: (value) => (as.showTextTab = value),
});
const userInputAudioLink = computed({
  get: () => as.userInputAudioLink,
  set: (value) => (as.userInputAudioLink = value),
});
const defaultOriginalText = computed({
  get: () => as.defaultOriginalText,
  set: (value) => (as.defaultOriginalText = value),
});
const defaultTranslatedText = computed({
  get: () => as.defaultTranslatedText,
  set: (value) => (as.defaultTranslatedText = value),
});
const translatedAudioSubtitle = computed({
  get: () => as.translatedAudioSubtitle,
  set: (value) => (as.translatedAudioSubtitle = value),
});
const originalAudioSubtitle = computed({
  get: () => as.originalAudioSubtitle,
  set: (value) => (as.originalAudioSubtitle = value),
});

const parsedCaptionsWithSpeakers = computed(() => as.parsedCaptionsWithSpeakers);

// Parse translated WebVTT and match with original captions to get speaker info
const translatedCaptionsWithSpeakers = computed((): CaptionModel[] => {
  if (!translatedAudioSubtitle.value || parsedCaptionsWithSpeakers.value.length === 0) {
    return [];
  }

  try {
    const lines = translatedAudioSubtitle.value.split("\n");
    const translatedCaptions: CaptionModel[] = [];
    let currentIndex = "";
    let currentTimestamp = "";
    let currentText = "";
    let isCaptionsSection = false;

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      // Check if it's a timestamp line
      const timestampMatch = line.match(/(\d{2}:\d{2}:\d{2}\.\d{3})\s*-->\s*(\d{2}:\d{2}:\d{2}\.\d{3})/);
      
      if (timestampMatch) {
        // Save previous caption if exists
        if (currentIndex && currentTimestamp && currentText) {
          const [start, dur] = currentTimestamp.split(" --> ");
          // Find matching original caption by timestamp
          const matchingOriginal = parsedCaptionsWithSpeakers.value.find(
            (orig) => orig.start === start && orig.dur === dur
          ) || parsedCaptionsWithSpeakers.value.find(
            (orig) => orig.start === start
          );

          if (matchingOriginal) {
            translatedCaptions.push({
              start: start,
              dur: dur,
              text: currentText.trim(),
              speakerTag: matchingOriginal.speakerTag,
              words: matchingOriginal.words ? matchingOriginal.words.map((word) => ({
                word: word.word, // Keep original word structure, speaker info is what matters
                speakerTag: word.speakerTag,
                startTime: word.startTime
              })) : undefined
            });
          } else {
            // If no match found, create caption without speaker info
            translatedCaptions.push({
              start: start,
              dur: dur,
              text: currentText.trim()
            });
          }
        }

        // Start new caption
        currentTimestamp = line;
        currentText = "";
        isCaptionsSection = true;
      } else if (/^\d+$/.test(line)) {
        // Caption index
        currentIndex = line;
      } else if (isCaptionsSection && line !== "") {
        // Caption text
        currentText += (currentText ? " " : "") + line;
      }
    }

    // Handle last caption
    if (currentIndex && currentTimestamp && currentText) {
      const [start, dur] = currentTimestamp.split(" --> ");
      const matchingOriginal = parsedCaptionsWithSpeakers.value.find(
        (orig) => orig.start === start && orig.dur === dur
      ) || parsedCaptionsWithSpeakers.value.find(
        (orig) => orig.start === start
      );

      if (matchingOriginal) {
        translatedCaptions.push({
          start: start,
          dur: dur,
          text: currentText.trim(),
          speakerTag: matchingOriginal.speakerTag,
          words: matchingOriginal.words ? matchingOriginal.words.map((word) => ({
            word: word.word, // Keep original word structure, speaker info is what matters
            speakerTag: word.speakerTag,
            startTime: word.startTime
          })) : undefined
        });
      } else {
        translatedCaptions.push({
          start: start,
          dur: dur,
          text: currentText.trim()
        });
      }
    }

    return translatedCaptions;
  } catch (error) {
    console.error("Error parsing translated captions with speakers:", error);
    return [];
  }
});

// Helper function to get speaker color
const getSpeakerColor = (speakerTag: number | null | undefined): string => {
  if (!speakerTag) return DEFAULT_SPEAKER_COLOR;
  // Use editable colors if available, fallback to default
  return speakerColors.value[speakerTag] || SPEAKER_COLORS[speakerTag] || DEFAULT_SPEAKER_COLOR;
};

// Function to update speaker color
const updateSpeakerColor = (speakerTag: number, color: string) => {
  speakerColors.value[speakerTag] = color;
};
const defaultOriginalAudioSubtitle = computed({
  get: () => as.defaultOriginalAudioSubtitle,
  set: (value) => (as.defaultOriginalAudioSubtitle = value),
});
const prebuildAudioSubtitle = computed({
  get: () => as.prebuildAudioSubtitle,
  set: (value) => (as.prebuildAudioSubtitle = value),
});
const defaultTranslatedAudioSubtitle = computed({
  get: () => as.defaultTranslatedAudioSubtitle,
  set: (value) => (as.defaultTranslatedAudioSubtitle = value),
});
const processingLink = computed({
  get: () => as.processingLink,
  set: (value) => (as.processingLink = value),
});
const processingStatus = computed({
  get: () => as.processingStatus,
  set: (value) => (as.processingStatus = value),
});
const origineTokenValue = computed({
  get: () => as.origineTokenValue,
  set: (value) => (as.origineTokenValue = value),
});
const translatedTokenValue = computed({
  get: () => as.translatedTokenValue,
  set: (value) => (as.translatedTokenValue = value),
});
const showOriginalSummarized = computed({
  get: () => as.showOriginalSummarized,
  set: (value) => (as.showOriginalSummarized = value),
});
const showTranslatedSummarized = computed({
  get: () => as.showTranslatedSummarized,
  set: (value) => (as.showTranslatedSummarized = value),
});
const originalSummarizedText = computed({
  get: () => as.originalSummarizedText,
  set: (value) => (as.originalSummarizedText = value),
});
const translatedSummarizedText = computed({
  get: () => as.translatedSummarizedText,
  set: (value) => (as.translatedSummarizedText = value),
});
const currentRequestId = computed({
  get: () => as.currentRequestId,
  set: (value) => (as.currentRequestId = value),
});
const summarizesData = computed({
  get: () => as.summarizesData,
  set: (value) => (as.summarizesData = value),
});
const selectedSummarizedLanguage = computed({
  get: () => as.selectedSummarizedLanguage,
  set: (value) => (as.selectedSummarizedLanguage = value),
});
const translatedSummarizesLangs = computed({
  get: () => as.translatedSummarizesLangs,
  set: (value) => (as.translatedSummarizesLangs = value),
});
const latestTranslationId = computed({
  get: () => as.latestTranslationId,
  set: (value) => (as.latestTranslationId = value),
});
const audioSource = computed({
  get: () => as.audioSource,
  set: (value) => (as.audioSource = value),
});
const audioSourceTranslated = computed({
  get: () => as.audioSourceTranslated,
  set: (value) => (as.audioSourceTranslated = value),
});
const computedOriginalClass = computed(() => {
  return [fontSizeClass.value];
});
const computedTranslatedClass = computed(() => {
  return [fontSizeClass.value];
});

// Multi-language selection computed properties
const isMultiLanguageMode = computed({
  get: () => as.isMultiLanguageMode,
  set: (value) => (as.isMultiLanguageMode = value),
});
const selectedTargetLanguages = computed({
  get: () => as.selectedTargetLanguages,
  set: (value) => (as.selectedTargetLanguages = value),
});
const bulkTextTranslations = computed({
  get: () => as.bulkTextTranslations,
  set: (value) => (as.bulkTextTranslations = value),
});
const currentDisplayLanguage = computed({
  get: () => as.currentDisplayLanguage,
  set: (value) => (as.currentDisplayLanguage = value),
});

// Computed property for languages with translations (for quick access)
const availableTranslatedLanguages = computed(() => {
  const langCodes = Object.keys(bulkTextTranslations.value);
  // Also include current translation language if it has a translation
  if (translatedText.value && translationLanguage.value?.langCode && !langCodes.includes(translationLanguage.value.langCode)) {
    langCodes.push(translationLanguage.value.langCode);
  }
  return languages.filter((lang) => langCodes.includes(lang.langCode));
});

// Helper function to check if language has translation
const hasTranslation = (langCode: string): boolean => {
  // Check bulk translations first
  if (bulkTextTranslations.value[langCode]) {
    return true;
  }
  // Also check if current translation matches this language
  if (translationLanguage.value?.langCode === langCode && translatedText.value && translatedText.value.length > 0) {
    return true;
  }
  return false;
};

const translateTextUrl = `${API_BASE_URL}${TRANSLATE_TEXT}`;
const translateTextBulkUrl = `${API_BASE_URL}${TRANSLATE_TEXT_BULK}`;
const translateTextGPTUrl = `${API_BASE_URL}${TRANSLATE_TEXT_GPT}`;
const translateTextBulkGPTUrl = `${API_BASE_URL}${TRANSLATE_TEXT_BULK_GPT}`;
const getPrices = `${API_BASE_URL}${GETPRICES}`;
const speakTextUrl = `${API_BASE_URL}${SPEAKTEXT}`;
const streamTextUrl = `${API_BASE_URL}${STREAMTEXT}`;
const summarizeTextUrl = `${API_BASE_URL}${SUMMARIZETEXT}`;
const { t, locale } = useI18n();

// Keyboard shortcuts for find/replace (must be defined before onMounted)
const handleKeyboardShortcuts = (event: KeyboardEvent) => {
  // Ctrl+F or Cmd+F - Open find/replace
  if ((event.ctrlKey || event.metaKey) && event.key === 'f' && !showFindReplace.value) {
    event.preventDefault();
    // Determine mode and target based on current view
    const mode = 'text'; // Default to text mode for audio
    const target = 'original'; // Default to original, user can change in dialog
    openFindReplace(mode, target);
  }
  
  // F3 - Find next (only when dialog is open)
  if (event.key === 'F3' && !event.shiftKey && showFindReplace.value) {
    event.preventDefault();
    findNextMatch();
  }
  
  // Shift+F3 - Find previous (only when dialog is open)
  if (event.key === 'F3' && event.shiftKey && showFindReplace.value) {
    event.preventDefault();
    findPreviousMatch();
  }
  
  // Escape - Close dialog
  if (event.key === 'Escape' && showFindReplace.value) {
    event.preventDefault();
    closeFindReplace();
  }
};

function setAudioSourceFromContent(
  content: string,
  sourceRef: { value: HTMLSourceElement | null },
  elementRef: { value: HTMLAudioElement | null }
) {
  if (!content || !sourceRef?.value) return;
  const isUrl = content.startsWith("http://") || content.startsWith("https://");
  sourceRef.value.src = isUrl ? content : `data:audio/mpeg;base64,${content}`;
  elementRef?.value?.load();
}

onMounted(async () => {
  if (audioContent.value) {
    setAudioSourceFromContent(audioContent.value, audioSource as { value: HTMLSourceElement | null }, audioElement as { value: HTMLAudioElement | null });
  }
  if (audioContentTranslated.value) {
    nextTick(() => {
      setAudioSourceFromContent(audioContentTranslated.value, audioSourceTranslated as { value: HTMLSourceElement | null }, audioElementTranslated as { value: HTMLAudioElement | null });
    });
  }
  // Cooldown is disabled in fontStore.fetchGoogleFonts() - see src/store/fontsStore.ts
  await fontStore.fetchGoogleFonts(authStore.token!);
  nextTick().then(() => {
    const dbRequest = indexedDB.open("FontCacheDB", 1);
    dbRequest.onsuccess = (event: any) => {
      const db = event.target.result;
      const tx = db.transaction("fonts", "readonly");
      const store = tx.objectStore("fonts");
      const getAllKeysRequest = store.getAllKeys();

      getAllKeysRequest.onsuccess = () => {
        const cachedKeys = getAllKeysRequest.result;
        fontStore.fonts.forEach((font: any) => {
          if (cachedKeys.includes(font.name)) {
            console.log("Font found in cache: ", font.name);
            loadGoogleFont(font.name, font.files.regular, () => {});
          }
        });
      };

      getAllKeysRequest.onerror = () => {
        console.warn("Failed to get font keys from IndexedDB", getAllKeysRequest.error);
      };
    };

    dbRequest.onerror = (e: any) => {
      console.warn("IndexedDB open error", e);
    };
    fontFamily.value = prefStore.selectedFont != null ? prefStore.selectedFont.name : "";
  });
  // Add keyboard shortcuts
  window.addEventListener('keydown', handleKeyboardShortcuts);
});

onUnmounted(() => {
  // Remove keyboard shortcuts
  window.removeEventListener('keydown', handleKeyboardShortcuts);
});

router.beforeEach((to, from, next) => {
  if (audioElement.value) {
    audioElement.value!.pause();
  }
  if (audioElementTranslated.value) {
    audioElementTranslated.value!.pause();
  }
  next();
});

watch(audioContent, (val) => {
  if (val && audioSource.value && audioElement.value) {
    setAudioSourceFromContent(val, audioSource as { value: HTMLSourceElement | null }, audioElement as { value: HTMLAudioElement | null });
  }
});
watch(audioContentTranslated, (val) => {
  if (!val) return;
  nextTick(() => {
    if (audioSourceTranslated.value && audioElementTranslated.value) {
      setAudioSourceFromContent(val, audioSourceTranslated as { value: HTMLSourceElement | null }, audioElementTranslated as { value: HTMLAudioElement | null });
    }
  });
}, { immediate: true });

watch(showTextTab, (isTextTab) => {
  if (isTextTab && audioContentTranslated.value) {
    nextTick(() => {
      if (audioSourceTranslated.value && audioElementTranslated.value) {
        setAudioSourceFromContent(audioContentTranslated.value, audioSourceTranslated as { value: HTMLSourceElement | null }, audioElementTranslated as { value: HTMLAudioElement | null });
      }
    });
  }
});

function consumePendingHelpScroll() {
  const id = as.pendingHelpScrollSectionId;
  if (!id || !receivedCaption.value) return;
  const attempt = (): boolean => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      as.pendingHelpScrollSectionId = null;
      return true;
    }
    return false;
  };
  if (attempt()) return;
  requestAnimationFrame(() => {
    if (attempt()) return;
    setTimeout(() => {
      if (!attempt()) {
        as.pendingHelpScrollSectionId = null;
      }
    }, 450);
  });
}

watch(
  receivedCaption,
  (ready) => {
    nextTick(() => {
      if (!ready) return;
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox: any) => {
        const checkboxId = `${selectedVoice.value}-checkbox`;
        if (checkbox.id === checkboxId) {
          checkbox.checked = true;
        }
        const checkboxIdtranslated = `${selectedVoiceTranslated.value}-checkbox-translated`;
        if (checkbox.id === checkboxIdtranslated) {
          checkbox.checked = true;
        }
      });
      consumePendingHelpScroll();
    });
  },
  { immediate: true }
);

watch(summarizesData, () => {
  translatedSummarizesLangs.value = summarizesData.value
    .filter((e: any) => e.lang !== originalLanguage.value.langCode)
    .map((item) => item.lang);
});

// Watch for mode toggle to handle state properly
watch(
  () => isMultiLanguageMode.value,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      // When switching to single-select mode, clear multi-select selections
      if (!newValue) {
        // Keep the current translation language if it exists
        if (translationLanguage.value?.langCode) {
          // Check if translation exists for current language
          if (bulkTextTranslations.value[translationLanguage.value.langCode]) {
            translatedText.value = bulkTextTranslations.value[translationLanguage.value.langCode];
            defaultTranslatedText.value = bulkTextTranslations.value[translationLanguage.value.langCode];
          }
        }
        // Clear selected languages array but keep current translation language
        selectedTargetLanguages.value = [];
      } else {
        // When switching to multi-select mode, add current translation language to selection if it exists
        if (translationLanguage.value?.langCode && translatedText.value && translatedText.value.length > 0) {
          const currentLang = languages.find((l) => l.langCode === translationLanguage.value.langCode);
          if (currentLang && !selectedTargetLanguages.value.find((l) => l.langCode === currentLang.langCode)) {
            selectedTargetLanguages.value.push({ ...currentLang });
          }
        }
      }
    }
  }
);

const base64ToBlob = (base64: any, mime: any) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
};

const toggleDownloadSRTTypes = () => {
  if (originalAudioSubtitle.value.length === 0) return;
  showDownloadSRTTypes.value = !showDownloadSRTTypes.value;
};

watch(originalText, () => {
  if (!editingTexts.value) {
    editingTexts.value = true;
  }
  if (timeoutTextId) {
    clearTimeout(timeoutTextId);
  }
  timeoutTextId = setTimeout(async () => {
    editingTexts.value = false;
    showSavedText.value = true;
    timeoutTextId = null;
    await new Promise((f) => setTimeout(f, 3000));
    showSavedText.value = false;
  }, 1000);
});

watch(translatedText, () => {
  if (!editingTexts.value) {
    editingTexts.value = true;
  }
  if (timeoutTextId) {
    clearTimeout(timeoutTextId);
  }
  timeoutTextId = setTimeout(async () => {
    editingTexts.value = false;
    showSavedText.value = true;
    timeoutTextId = null;
    await new Promise((f) => setTimeout(f, 3000));
    showSavedText.value = false;
  }, 1000);
});

watch(originalAudioSubtitle, () => {
  if (!editingSubtitles.value) {
    editingSubtitles.value = true;
  }
  if (timeoutSubtitleId) {
    clearTimeout(timeoutSubtitleId);
  }
  timeoutSubtitleId = setTimeout(async () => {
    editingSubtitles.value = false;
    timeoutSubtitleId = null;
    showSubtitlesText.value = true;
    if (translatedAudioSubtitle.value.length != 0) {
      const { original: paddedOriginal, translated: paddedTranslated } =
        padCaptionsToEqualLines(
          originalAudioSubtitle.value,
          translatedAudioSubtitle.value
        );
      translatedAudioSubtitle.value = paddedTranslated;
    }
    await new Promise((f) => setTimeout(f, 3000));
    showSubtitlesText.value = false;
  }, 1000);
});

watch(translatedAudioSubtitle, () => {
  if (!editingSubtitles.value) {
    editingSubtitles.value = true;
  }
  if (timeoutSubtitleId) {
    clearTimeout(timeoutSubtitleId);
  }
  timeoutSubtitleId = setTimeout(async () => {
    editingSubtitles.value = false;
    showSubtitlesText.value = true;
    timeoutSubtitleId = null;
    const { original: paddedOriginal, translated: paddedTranslated } =
      padCaptionsToEqualLines(
        originalAudioSubtitle.value,
        translatedAudioSubtitle.value
      );
    originalAudioSubtitle.value = paddedOriginal;
    await new Promise((f) => setTimeout(f, 3000));
    showSubtitlesText.value = false;
  }, 1000);
});

watch(
  () => showTextTab.value,
  () => {
    nextTick(() => {
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox: any) => {
        const checkboxId = `${selectedVoice.value}-checkbox`;
        if (checkbox.id === checkboxId) {
          checkbox.checked = true;
        }
        const checkboxIdtranslated = `${selectedVoiceTranslated.value}-checkbox-translated`;
        if (checkbox.id === checkboxIdtranslated) {
          checkbox.checked = true;
        }
      });
    });
  }
);

watch(
  () => route.query.req,
  async () => {
    if (!route.query.req) return;
    const queryType = route.query.type?.toString();
    if (queryType === "onetime_upload" || queryType === "onetime_result") return;
    console.log("watch ----------------------");
    notReadyYet.value = true;
    // Clear translations before processing new audio
    bulkTextTranslations.value = {};
    selectedTargetLanguages.value = [];
    processNewAudio();
    if (route.query.req) {
      const reqId = route.query.req.toString();
      const audioType = route.query.link ? "EXTAUDIO" : "AUDIO";
      await fetchTranscription(reqId, audioType);
      await fetchSummarizedText();
      // Load cached text translations for the new request
      await loadCachedTextTranslations();
      isFromNotification.value = true;
      if (route.query.link) {
        userInputAudioLink.value = route.query.link.toString();
      }
    } else if (route.query.text) {
      // Clear translations before processing new text translation
      bulkTextTranslations.value = {};
      selectedTargetLanguages.value = [];
      const reqId = route.query.text.toString();
      isTranslationPreview.value = true;
      await getTranslatedFile(reqId);
      // Load cached text translations for the new request
      await loadCachedTextTranslations();
      isFromNotification.value = true;
      receivedCaption.value = true;
    }
  }
);

onBeforeMount(async () => {
  const queryType = route.query.type?.toString();
  if (queryType === "onetime_upload" || queryType === "onetime_result") return;
  notReadyYet.value = true;
  if (route.query.req) {
    // Clear translations before processing new audio
    bulkTextTranslations.value = {};
    selectedTargetLanguages.value = [];
    processNewAudio();
    const reqId = route.query.req.toString();
    const audioType = route.query.link ? "EXTAUDIO" : "AUDIO";
    await fetchTranscription(reqId, audioType);
    await fetchSummarizedText();
    // Load cached text translations for the new request
    await loadCachedTextTranslations();
    isFromNotification.value = true;
    if (route.query.link) {
      userInputAudioLink.value = route.query.link.toString();
    }
  } else if (route.query.text) {
    // Clear translations before processing new text translation
    bulkTextTranslations.value = {};
    selectedTargetLanguages.value = [];
    const reqId = route.query.text.toString();
    isTranslationPreview.value = true;
    await getTranslatedFile(reqId);
    // Load cached text translations for the new request
    await loadCachedTextTranslations();
    isFromNotification.value = true;
    receivedCaption.value = true;
  }
});

const processNewAudio = () => {
  if (notReadyYet.value) {
    receivedCaption.value = false;
    processingStarted.value = false;
    notReadyYet.value = false;
    originalText.value = "";
    translatedText.value = "";
    defaultOriginalText.value = "";
    defaultTranslatedText.value = "";
    selectedAudio.value.name = "";
    userInputAudioLink.value = "";
    originalAudioSubtitle.value = "";
    translatedAudioSubtitle.value = "";
    prebuildAudioSubtitle.value = "";
    defaultOriginalAudioSubtitle.value = "";
    defaultTranslatedAudioSubtitle.value = "";
    latestTranslationId.value = "";
    isFromNotification.value = false;
    isTargetLanguageSelected.value = false;
    // Clear translations when switching to a new audio file
    bulkTextTranslations.value = {};
    selectedTargetLanguages.value = [];
  }
  audioContent.value = "";
  audioContentTranslated.value = "";
};

const getTranslatedFile = async (fileId: string) => {
  try {
    if (!fileId) {
      return;
    }
    const response = await fetch(getTranslatedFileUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        reqId: fileId,
      }),
    });
    const r = await response.json();
    if (!response.ok) {
      switch (r.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        default:
          break;
      }
      return;
    }
    originalText.value = r.translatedText.originalText;
    defaultOriginalText.value = r.translatedText.originalText;
    const orLang = languages.find(
      (language) => language.langCode === r.originalLanguage
    ) || {
      langName: "English",
      langCode: "en",
      countryCode: "us",
    };
    originalLanguage.value = orLang;
    const trLang = languages.find(
      (language) => language.langCode === r.targetLamguage
    ) || {
      langName: "Arabic",
      langCode: "ar",
      countryCode: "sa",
    };
    translationLanguage.value = trLang;
    translatedText.value = r.translatedText.translatedText;
    defaultTranslatedText.value = r.translatedText.translatedText;
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};

const fetchTranscription = async (reqId: string, audioType: string) => {
  try {
    processingStarted.value = true;
    // Clear translations when request ID changes
    if (currentRequestId.value !== reqId) {
      bulkTextTranslations.value = {};
      selectedTargetLanguages.value = [];
    }
    currentRequestId.value = reqId;
    notReadyYet.value = false;
    processingLink.value = true;
    processingStatus.value = t("retrieving-captions");
    const getData = await fetch(getTranscriptionFile, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        reqId: reqId,
        type: audioType,
      }),
    });
    const data = await getData.json();
    
    // Log transcription file loading status and format
    
    if (!getData.ok) {
      switch (data.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          return;
        default:
          processNewAudio();
          receivedCaption.value = false;
          break;
      }
    }

    // Handle both array and single object formats
    if (Array.isArray(data.result) || (data.result && typeof data.result === 'object')) {
      // Normalize result to always work with the actual data
      let resultData = data.result;
      if (Array.isArray(data.result)) {
        if (data.result.length > 0) {
          resultData = data.result[0];
        }
      }
      
      receivedCaption.value = true;
      fileName.value = data.fileTitle;
      originalJsonContent.value = JSON.stringify(data.result);
      
      // Extract text based on format
      if (isSonioxFormat(resultData)) {
        // Use new Soniox-specific extraction method
        originalText.value = extractTextFromSoniox(resultData);
        defaultOriginalText.value = extractTextFromSoniox(resultData);
      } else {
        // Use original method for Google Cloud format
        const extractData = Array.isArray(data.result) ? data.result : [data.result];
        originalText.value = extractText(extractData);
        defaultOriginalText.value = extractText(extractData);
      }
      
      // Detect format and use appropriate parser
      if (isSonioxFormat(resultData)) {
        try {
          prebuildAudioSubtitle.value = subtitleGenerationSoniox(resultData);
          originalAudioSubtitle.value = subtitleGenerationSoniox(resultData);
          defaultOriginalAudioSubtitle.value = subtitleGenerationSoniox(resultData);
          as.parsedCaptionsWithSpeakers = parseSonioxTranscription(resultData);
        } catch (error) {
          console.error("Error parsing Soniox format:", error);
        }
      } else {
        try {
          // Google Cloud format expects an array
          const googleData = Array.isArray(data.result) ? data.result : [data.result];
          prebuildAudioSubtitle.value = subtitleGeneration(googleData);
          originalAudioSubtitle.value = subtitleGeneration(googleData);
          defaultOriginalAudioSubtitle.value = subtitleGeneration(googleData);
          as.parsedCaptionsWithSpeakers = parseTranscriptionWithSpeakers(googleData);
        } catch (error) {
          console.error("Error parsing Google Cloud format:", error);
        }
      }
      const orLang = languages.find(
        (language) => language.langCode === data.originalLang
      ) || {
        langName: "English",
        langCode: "en",
        countryCode: "us",
      };
      originalLanguage.value = orLang;
      if (data.originalLang === translationLanguage.value.langCode) {
        if (data.originalLang === "ar") {
          translationLanguage.value = {
            langName: "English",
            langCode: "en",
            countryCode: "us",
          };
        } else {
          translationLanguage.value = {
            langName: "Arabic",
            langCode: "ar",
            countryCode: "sa",
          };
        }
      }
    }
    // Load cached text translations after fetching transcription
    await loadCachedTextTranslations();
    processingStarted.value = false;
    processingLink.value = false;
  } catch (error) {
    console.log(`fetchTranscription: ${error}`);
    processingStarted.value = false;
    processingLink.value = false;
  }
};

function parseTranscriptionWithSpeakers(speechToTextResponse: any): CaptionModel[] {
  try {
    const captions: CaptionModel[] = [];
    const minBinSize = 3.5;
    const maxBinSize = 4.5;
    
    if (speechToTextResponse[0]?.results) {
      speechToTextResponse[0].results.forEach((result: any) => {
        let currentSpeaker: number | null = null;
        let currentStartTime = 0;
        let transcript = "";
        let speakerSegments: Array<{
          word: string;
          speakerTag: number | null;
          startTime: number;
        }> = [];

        result.alternatives[0].words.forEach((wordData: any, i: number) => {
          const wordStartSeconds = parseFloat(wordData.startTime?.seconds || 0);
          const nextWord = result.alternatives[0].words[i + 1];
          const nextWordStartSeconds = nextWord 
            ? (parseFloat(nextWord.startTime?.seconds || 0)) 
            : null;
          
          const wordText = wordData.word;
          const speakerTag = wordData.speakerTag || null;

          // Initialize start time for new caption
          if (transcript.trim() === "") {
            currentStartTime = wordStartSeconds;
            currentSpeaker = speakerTag;
          }

          // Add word to transcript
          transcript = transcript + " " + wordText;
          
          // Store word with speaker info for this segment
          speakerSegments.push({
            word: wordText,
            speakerTag: speakerTag,
            startTime: wordStartSeconds
          });

          // Check if we should create a caption chunk
          if (nextWordStartSeconds !== null) {
            const duration = nextWordStartSeconds - currentStartTime;
            const ndnextWord = result.alternatives[0].words[i + 2];
            const ndnextWordStartSeconds = ndnextWord 
              ? (parseFloat(ndnextWord.startTime?.seconds || 0)) 
              : null;
            const ndDuration = ndnextWordStartSeconds 
              ? (ndnextWordStartSeconds - nextWordStartSeconds + duration) 
              : null;

            if (
              (minBinSize <= duration && duration <= maxBinSize) ||
              (ndDuration && ndDuration > maxBinSize)
            ) {
              const newCaption: CaptionModel = {
                start: formatTime(currentStartTime),
                dur: formatTime(nextWordStartSeconds),
                text: transcript.trim(),
                speakerTag: currentSpeaker,
                words: [...speakerSegments]
              };

              captions.push(newCaption);

              // Reset for next caption
              currentStartTime = nextWordStartSeconds;
              transcript = "";
              speakerSegments = [];
            }
          }
        });

        // Handle remaining transcript
        if (transcript.trim() !== "") {
          const lastWord = result.alternatives[0].words[result.alternatives[0].words.length - 1];
          const lastWordEndSeconds = parseFloat(lastWord.endTime?.seconds || 0);
          const duration = lastWordEndSeconds - currentStartTime;

          if (duration > 0) {
            const newCaption: CaptionModel = {
              start: formatTime(currentStartTime),
              dur: formatTime(lastWordEndSeconds),
              text: transcript.trim(),
              speakerTag: currentSpeaker,
              words: [...speakerSegments]
            };
            captions.push(newCaption);
          }
        }
      });
    }

    return captions;
  } catch (error) {
    console.error("Error parsing transcription with speakers:", error);
    return [];
  }
}

function subtitleGeneration(speechToTextResponse: any): string {
  try {
    const captions: CaptionModel[] = [];
    const minBinSize = 2.5;
    const maxBinSize = 3.5;
    if (speechToTextResponse[0].results) {
      speechToTextResponse[0].results.forEach((result: any) => {
        let currentStartTime = 0;
        let transcript = "";

        for (let i = 0; i < result.alternatives[0].words.length; i++) {
          const word = result.alternatives[0].words[i].word;
          const wordStartSeconds =
            result.alternatives[0].words[i].startTime.seconds || 0;
          const nextWordStartSeconds =
            result.alternatives[0].words[i + 1]?.startTime.seconds || 0;
          const ndnextWordStartSeconds =
            result.alternatives[0].words[i + 2]?.startTime.seconds || 0;

          if (transcript.trim() === "") {
            currentStartTime = wordStartSeconds;
          }

          transcript = transcript + " " + word;

          const duration = nextWordStartSeconds - currentStartTime;
          const ndDuration =
            ndnextWordStartSeconds - nextWordStartSeconds + duration;

          if (
            (minBinSize <= duration && duration <= maxBinSize) ||
            ndDuration > maxBinSize
          ) {
            const newCaption: CaptionModel = {
              start: formatTime(currentStartTime),
              dur: formatTime(nextWordStartSeconds),
              text: transcript.trim(),
            };
            captions.push(newCaption);
            currentStartTime = nextWordStartSeconds;
            transcript = "";
          }
        }

        if (transcript.trim() !== "") {
          const lastWordEndSeconds =
            result.alternatives[0].words[
              result.alternatives[0].words.length - 1
            ].endTime.seconds;
          const duration = lastWordEndSeconds - currentStartTime;

          if (duration > 0) {
            const newCaption: CaptionModel = {
              start: formatTime(currentStartTime),
              dur: formatTime(lastWordEndSeconds),
              text: transcript.trim(),
            };
            captions.push(newCaption);
          }
        }
      });
    }
    // Format captions into WebVTT
    let webvttContent = "WEBVTT\n\n";
    captions.forEach((caption, index) => {
      webvttContent += `${index + 1}\n${caption.start} --> ${caption.dur}\n${
        caption.text
      }\n\n`;
    });

    return webvttContent;
  } catch (error) {
    console.error("Error processing captions:", error);
    return "";
  }
}

function formatTime(seconds: number): string {
  const date = new Date(seconds * 1000);
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  const secondsFormatted = date.getSeconds().toString().padStart(2, "0");
  const milliseconds = (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5);
  return `${hours}:${minutes}:${secondsFormatted}.${milliseconds}`;
}

const downloadAudioFile = async (translated: boolean) => {
  try {
    if (isAudioDownloading.value) return;
    if (translated) {
      if (showTranslatedSummarized.value) return;
    } else {
      if (showOriginalSummarized.value) return;
    }
    if (
      (translated && translatedText.value.length == 0) ||
      (!translated && originalText.value.length == 0)
    ) {
      toast(t("text-to-speech-cannot-be-used-with"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (
      (translated &&
        unsupportedCloudTts.includes(translationLanguage.value.langCode)) ||
      (!translated &&
        unsupportedCloudTts.includes(originalLanguage.value.langCode))
    ) {
      toast(t("the-selected-language-is-currently"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }
    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }

    const lengthText = translated
      ? translatedText.value.length
      : originalText.value.length;

    const canProceed = await computeTtsCost(userSubscription, lengthText);
    if (!canProceed) {
      return;
    }

    isAudioDownloading.value = true;
    playOriginalAudio.value = !translated;
    playTranslationAudio.value = translated;
    const response = await fetch(speakTextUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        text: translated ? translatedText.value : originalText.value,
        language: translated
          ? translationLanguage.value.langCode
          : originalLanguage.value.langCode,
        gender: translated
          ? selectedVoiceTranslated.value
          : selectedVoice.value,
      }),
    });
    const result = await response.json();
    if (!response.ok) {
      switch (result.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          return;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "This combination of language and gender is not supported":
          toast(t("this-combination-of-language-and"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return;
    }
    console.log(result);
    if (result.audioContent) {
      audioContent.value = result.audioContent;
      isAudioDownloading.value = false;
    } else {
      isAudioDownloading.value = false;
    }
    const audioBlob = base64ToBlob(audioContent.value, "audio/mp3");
    const url = URL.createObjectURL(audioBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${generateFileName(!translated)}.mp3`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.log("downloadAudioFile:", error);
  }
};

function generateFileName(source: boolean): string {
  let _fileName: string = `Subtitles.tech-audio_${
    fileName.value || selectedAudio.value.name || "audio"
  }_`;
  if (source) {
    _fileName += `${originalLanguage.value.langName}`;
  } else {
    _fileName += `${translationLanguage.value.langName}`;
  }
  return _fileName;
}

const toggleDownloadTranslatedTypes = () => {
  if (translatedText.value.length === 0) return;
  showDownloadTranslatedTypes.value = !showDownloadTranslatedTypes.value;
};

const setPlaybackSpeed = (speed: number) => {
  playbackSpeed.value = speed;
  if (audioElement.value) {
    audioElement.value.playbackRate = speed;
  }
};
const setPlaybackSpeedTranslated = (speed: number) => {
  playbackSpeedTranslated.value = speed;
  if (audioElementTranslated.value) {
    audioElementTranslated.value.playbackRate = speed;
  }
};

const speakText = async (translated: boolean) => {
  try {
    if (isAudioLoading.value) return;
    if (isPlaying.value) {
      audioElement.value?.pause();
      audioElementTranslated.value?.pause();
      isPlaying.value = false;
      playOriginalAudio.value = false;
      playTranslationAudio.value = false;
      return;
    }
    if (translated) {
      if (showTranslatedSummarized.value) return;
    } else {
      if (showOriginalSummarized.value) return;
    }
    if (
      (translated && translatedText.value.length === 0) ||
      (!translated && originalText.value.length === 0)
    ) {
      toast(t("text-to-speech-cannot-be-used-with"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }

    if (
      (translated &&
        unsupportedCloudTts.includes(translationLanguage.value.langCode)) ||
      (!translated &&
        unsupportedCloudTts.includes(originalLanguage.value.langCode))
    ) {
      toast(t("the-selected-language-is-currently"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }

    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription !== "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date();
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }

    playOriginalAudio.value = !translated;
    playTranslationAudio.value = translated;
    const lengthText = translated
      ? translatedText.value.length
      : originalText.value.length;

    const canProceed = await computeTtsCost(userSubscription, lengthText);
    if (!canProceed) {
      return;
    }

    let langCode = translated
      ? translationLanguage.value.langCode
      : originalLanguage.value.langCode;
    langCode = languageCodeMappings.tts[langCode] || langCode;

    isAudioLoading.value = true;

    const response = await fetch(speakTextUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        text: translated ? translatedText.value : originalText.value,
        language: langCode,
        gender: translated
          ? selectedVoiceTranslated.value
          : selectedVoice.value,
      }),
    });

    const result = await response.json();
    console.log(`[${new Date().toISOString()}] Server response:`, result);

    if (response.ok && result.audioContent) {
      if (translated) {
        if (audioSourceTranslated.value && audioElementTranslated.value) {
          audioSourceTranslated.value.src = `data:audio/mpeg;base64,${result.audioContent}`;
          audioElementTranslated.value.load();
        }
        audioElementTranslated.value!.playbackRate =
          playbackSpeedTranslated.value;

        audioElementTranslated.value!.onplay = () => {
          console.log(`[${new Date().toISOString()}] Audio playback started`);
          isPlaying.value = true;
          isAudioLoading.value = false;
        };

        audioElementTranslated.value!.onpause = () => {
          console.log(`[${new Date().toISOString()}] Audio playback paused`);
          isPlaying.value = false;
          playOriginalAudio.value = false;
          playTranslationAudio.value = false;
        };

        audioElementTranslated.value!.onended = () => {
          console.log(`[${new Date().toISOString()}] Audio playback ended`);
          isPlaying.value = false;
          playOriginalAudio.value = false;
          playTranslationAudio.value = false;
          isAudioLoading.value = false;
        };

        audioElementTranslated.value!.onerror = () => {
          console.error(
            `[${new Date().toISOString()}] Audio element error, code=${
              audioElementTranslated.value!.error?.code
            }, message=${audioElementTranslated.value!.error?.message}`
          );
          isPlaying.value = false;
          isAudioLoading.value = false;
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 1500,
            type: "error",
            theme: "light",
          });
        };

        const playWhenReady = () => {
          audioElementTranslated.value!.play().catch((err) => {
            console.error(
              `[${new Date().toISOString()}] Play error:`,
              err.message
            );
            isAudioLoading.value = false;
            toast(t("were-fixing-a-technical-issue-so-please-try"), {
              autoClose: 1500,
              type: "error",
              theme: "light",
            });
          });
        };
        if (audioElementTranslated.value!.readyState >= 2) {
          playWhenReady();
        } else {
          audioElementTranslated.value!.addEventListener("canplay", playWhenReady, { once: true });
        }
      } else {
        if (audioSource.value && audioElement.value) {
          audioSource.value.src = `data:audio/mpeg;base64,${result.audioContent}`;
          audioElement.value.load();
        }
        audioElement.value!.playbackRate = playbackSpeed.value;

        audioElement.value!.onplay = () => {
          console.log(`[${new Date().toISOString()}] Audio playback started`);
          isPlaying.value = true;
          isAudioLoading.value = false;
        };

        audioElement.value!.onpause = () => {
          console.log(`[${new Date().toISOString()}] Audio playback paused`);
          isPlaying.value = false;
          playOriginalAudio.value = false;
          playTranslationAudio.value = false;
        };

        audioElement.value!.onended = () => {
          console.log(`[${new Date().toISOString()}] Audio playback ended`);
          isPlaying.value = false;
          playOriginalAudio.value = false;
          playTranslationAudio.value = false;
          isAudioLoading.value = false;
        };

        audioElement.value!.onerror = () => {
          console.error(
            `[${new Date().toISOString()}] Audio element error, code=${
              audioElement.value!.error?.code
            }, message=${audioElement.value!.error?.message}`
          );
          isPlaying.value = false;
          isAudioLoading.value = false;
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 1500,
            type: "error",
            theme: "light",
          });
        };

        const playWhenReadyOriginal = () => {
          audioElement.value!.play().catch((err) => {
            console.error(
              `[${new Date().toISOString()}] Play error:`,
              err.message
            );
            isAudioLoading.value = false;
            toast(t("were-fixing-a-technical-issue-so-please-try"), {
              autoClose: 1500,
              type: "error",
              theme: "light",
            });
          });
        };
        if (audioElement.value!.readyState >= 2) {
          playWhenReadyOriginal();
        } else {
          audioElement.value!.addEventListener("canplay", playWhenReadyOriginal, { once: true });
        }
      }
    } else {
      let errorMessage = t("something-went-wrong");
      if (result.error) {
        switch (result.error) {
          case "Subscription required. Please upgrade your plan.":
            errorMessage = t("subscription-required-please-upgrade-your-plan");
            break;
          case "Your subscription has expired. Please renew your subscription.":
            errorMessage = t(
              "your-subscription-has-expired-please-renew-your-subscription"
            );
            break;
          case "This combination of language and gender is not supported":
            errorMessage = t("this-combination-of-language-and");
            break;
          case "The balance is insufficient":
            errorMessage = t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            );
            break;
          case "Invalid token":
          case "Authorization header missing":
            toast(
              t("your-session-has-expired-please-log-in-again-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            await new Promise((resolve) => setTimeout(resolve, 2500));
            authStore.logout();
            router.push("/signing");
            return;
          default:
            errorMessage = t("were-fixing-a-technical-issue-so-please-try");
            break;
        }
      }
      toast(errorMessage, { autoClose: 1500, type: "error", theme: "light" });
      isAudioLoading.value = false;
    }
  } catch (error: any) {
    console.error(
      `[${new Date().toISOString()}] SpeakText error:`,
      error.message
    );
    isAudioLoading.value = false;
    toast(t("something-went-wrong"), {
      autoClose: 1500,
      type: "error",
      theme: "light",
    });
  }
};

function ttsCostFromDeposit(textLength: number) {
  return textLength * servicesPricing.textToSpeech;
}

function translationCostFromDeposit(textLength: number) {
  return textLength * servicesPricing.textTranslation;
}

const selectOnlyThis = (event: Event) => {
  try {
    const target = event.target as HTMLInputElement;
    if (!target) return;
    const checkboxes = Array.from(
      document.querySelectorAll('input[type="checkbox"]')
    ).filter(
      (checkbox) => !(checkbox as HTMLInputElement).id.includes("-translated")
    );

    const checkedCount = checkboxes.filter(
      (checkbox) => (checkbox as HTMLInputElement).checked
    ).length;

    if (checkedCount === 0 && target.checked === false) {
      target.checked = true;
      return;
    }

    checkboxes.forEach((checkbox: any) => {
      if (checkbox !== event.target) {
        checkbox.checked = false;
      }
    });
    selectedVoice.value = target.value;
  } catch (error) {
    console.log("selectOnlyThis:", error);
  }
};

const selectOnlyThisTranslation = (event: Event) => {
  try {
    const target = event.target as HTMLInputElement;
    if (!target) return;
    const checkboxes = Array.from(
      document.querySelectorAll('input[type="checkbox"]')
    ).filter((checkbox) =>
      (checkbox as HTMLInputElement).id.includes("-translated")
    );

    const checkedCount = checkboxes.filter(
      (checkbox) => (checkbox as HTMLInputElement).checked
    ).length;

    if (checkedCount === 0 && target.checked === false) {
      target.checked = true;
      return;
    }

    checkboxes.forEach((checkbox: any) => {
      if (checkbox !== event.target) {
        checkbox.checked = false;
      }
    });
    selectedVoiceTranslated.value = target.value;
  } catch (error) {
    console.log("selectOnlyThis:", error);
  }
};

const handleTranslatedCheckbox = (event: any) => {
  try {
    translatedChecked.value = event.target.checked;
  } catch (error) {
    console.log("handleTranslatedCheckbox:", error);
  }
};

const toggleDownloadTypes = () => {
  if (originalText.value.length === 0) return;
  showDownloadTypes.value = !showDownloadTypes.value;
};

const filteredLanguages = () => {
  if (searchQuery.value.length == 0) {
    myLanguagesList.value = languages;
  } else {
    const lowerCaseQuery = searchQuery.value.toLowerCase();
    myLanguagesList.value = languages.filter((langs) =>
      langs.langName.toLowerCase().includes(lowerCaseQuery)
    );
  }
};

const resetFilter = () => {
  searchQuery.value = "";
  myLanguagesList.value = languages;
};

const parseWebVTT = () => extractWebVttCaptionTexts(originalAudioSubtitle.value);

const computeTranslationCost = async (
  translateText: boolean
): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    try {
      computePricing.value = true;
      balanceNotEnough.value = false;
      let totalLength = 0;
      if (translateText) {
        totalLength = originalText.value.length;
      } else {
        const captionLines = parseWebVTT();
        if (captionLines.length === 0) {
          toast(t("no-captions-available"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          computePricing.value = false;
          resolve(false);
          return;
        }
        captionLines.forEach((caption) => {
          totalLength += caption.length;
        });
      }
      const userSubscription = profileStore.subscriptionType;
      const currentTimestamp = new Date();
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);

      if (userSubscription === "CONSUMEASYOUPAY") {
        const cost = translationCostFromDeposit(totalLength);
        if (cost <= profileStore.userDeposit) {
          computePricing.value = false;
          resolve(true);
        } else {
          // Check alternative: textTranslationVolume
          if (currentTimestamp > subscriptionEndDate) {
            balanceNotEnough.value = true;
            toast(
              t("your-balance-is-insufficient-please-recharge-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            computePricing.value = false;
            resolve(false);
          }
          const shortfallCost = cost - profileStore.userDeposit;
          const shortfallChars = Math.ceil(
            shortfallCost / servicesPricing.textTranslation
          );
          if (shortfallChars > profileStore.textTranslationVolume) {
            balanceNotEnough.value = true;
            toast(
              t("your-balance-is-insufficient-please-recharge-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            computePricing.value = false;
            resolve(false);
          } else {
            // Show native confirmation dialog
            modalMessage.value = t("your-deposit-balance-is-not-enough");
            showPaymentModal.value = true;
            modalResolve.value = (confirmed: any) => {
              computePricing.value = false;
              showPaymentModal.value = false;
              if (confirmed) {
                resolve(true);
              } else {
                balanceNotEnough.value = true;
                resolve(false);
              }
            };
          }
        }
      } else {
        if (totalLength <= profileStore.textTranslationVolume) {
          computePricing.value = false;
          resolve(true); // Primary balance sufficient
        } else {
          // Check alternative: userDeposit
          const shortfallChars =
            totalLength - profileStore.textTranslationVolume;
          const shortfallCost = translationCostFromDeposit(shortfallChars);
          if (shortfallCost > profileStore.userDeposit) {
            balanceNotEnough.value = true;
            toast(
              t("your-balance-is-insufficient-please-recharge-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            computePricing.value = false;
            resolve(false);
          } else {
            // Show native confirmation dialog
            modalMessage.value = t("your-subscription-balance-is-not");
            showPaymentModal.value = true;
            modalResolve.value = (confirmed: any) => {
              computePricing.value = false;
              showPaymentModal.value = false;
              if (confirmed) {
                resolve(true);
              } else {
                balanceNotEnough.value = true;
                resolve(false);
              }
            };
          }
        }
      }
    } catch (error) {
      console.log(error);
      computePricing.value = false;
      balanceNotEnough.value = false;
      reject(error);
    }
  });
};

const computeTtsCost = async (
  userSubscription: any,
  lengthText: number
): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    computePricing.value = true;
    balanceNotEnough.value = false;
    if (userSubscription === "CONSUMEASYOUPAY") {
      const cost = ttsCostFromDeposit(lengthText);
      if (profileStore.userDeposit < cost) {
        const currentTimestamp = new Date(new Date().toISOString());
        const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
        if (currentTimestamp > subscriptionEndDate) {
          balanceNotEnough.value = true;
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          resolve(false);
        }

        const shortfallCost = cost - profileStore.userDeposit;
        const shortfallChars = Math.ceil(
          shortfallCost / servicesPricing.textToSpeech
        );
        if (shortfallChars > profileStore.textToSpeechVolume) {
          balanceNotEnough.value = true;
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          resolve(false);
        }

        modalMessage.value = t("your-deposit-balance-is-not-enough");
        showPaymentModal.value = true;
        modalResolve.value = (confirmed: any) => {
          computePricing.value = false;
          showPaymentModal.value = false;
          if (confirmed) {
            resolve(true);
          } else {
            balanceNotEnough.value = true;
            resolve(false);
          }
        };
      } else {
        resolve(true);
      }
    } else {
      if (profileStore.textToSpeechVolume < lengthText) {
        const shortfallCost = lengthText - profileStore.textToSpeechVolume;
        const shortfallChars = ttsCostFromDeposit(shortfallCost);
        if (shortfallChars > profileStore.userDeposit) {
          balanceNotEnough.value = true;
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          resolve(false);
        }

        modalMessage.value = t("your-subscription-balance-is-not");
        showPaymentModal.value = true;
        modalResolve.value = (confirmed: any) => {
          computePricing.value = false;
          showPaymentModal.value = false;
          if (confirmed) {
            resolve(true);
          } else {
            balanceNotEnough.value = true;
            resolve(false);
          }
        };
      } else {
        resolve(true);
      }
    }
  });
};

const copyText = (isOriginal: boolean) => {
  let isValueEmpty = false;
  let textToCopy = "";
  if (isOriginal) {
    if (showOriginalSummarized.value) {
      isValueEmpty = originalSummarizedText.value.length == 0;
      textToCopy = originalSummarizedText.value;
    } else {
      isValueEmpty = originalText.value.length == 0;
      textToCopy = originalText.value;
    }
  } else {
    if (showTranslatedSummarized.value) {
      isValueEmpty = translatedSummarizedText.value.length == 0;
      textToCopy = translatedSummarizedText.value;
    } else {
      isValueEmpty = translatedText.value.length == 0;
      textToCopy = translatedText.value;
    }
  }
  if (isValueEmpty) {
    return;
  }
  navigator.clipboard
    .writeText(textToCopy)
    .then(() => {
      toast(t("text-copied-to-clipboard"), {
        autoClose: 1500,
        type: "success",
        theme: "light",
      });
    })
    .catch((error) => {
      toast(t("failed-to-copy-text-please-try-again"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      console.error("Error copying text:", error);
    });
};

const fetchTranslationPrice = async () => {
  try {
    const response = await fetch(getPrices, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
    });
    const result = await response.json();
    if (result.error) {
      computePricing.value = false;
      return;
    }
    if (result.message == "Success" && result.Prices) {
      textTranslationPrice.value = result.Prices.text_per_1000_char;
    }
  } catch (error) {
    console.log(error);
  }
};

const closeList = () => {
  isOpen.value = false;
  isTargetListOpen.value = false;
  resetFilter();
};

// IndexedDB caching for text translations
interface TextCacheEntry {
  id?: number; // Auto-increment ID from IndexedDB
  requestId?: string;
  inputLink?: string;
  languages: Record<string, { textTranslations: string }>;
  created?: number;
}

async function initTextCacheDB(): Promise<IDBPDatabase> {
  return openDB("subtitle_audioTextCache", 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("textCache")) {
        db.createObjectStore("textCache", { keyPath: "id", autoIncrement: true });
      }
    },
  });
}

async function saveTextTranslationsToCache(
  translations: Record<string, string>,
  langCodes: string[],
  requestId?: string,
  inputLink?: string
) {
  try {
    const db = await initTextCacheDB();
    const tx = db.transaction("textCache", "readwrite");
    const store = tx.objectStore("textCache");

    let cache: TextCacheEntry[] = [];
    try {
      cache = (await store.getAll()) || [];
    } catch (e) {
      console.error("Failed to load cache from IndexedDB:", e);
    }

    const entryIndex = cache.findIndex(
      (item) =>
        (requestId && item.requestId === requestId) ||
        (inputLink && item.inputLink === inputLink)
    );
    const entry: TextCacheEntry =
      entryIndex >= 0
        ? cache[entryIndex]
        : { requestId, inputLink, languages: {}, created: Date.now() };

    // Update language data with text translations
    langCodes.forEach((langCode) => {
      if (translations[langCode]) {
        if (!entry.languages[langCode]) {
          entry.languages[langCode] = { textTranslations: "" };
        }
        entry.languages[langCode].textTranslations = translations[langCode];
      }
    });

    // Use put() to update existing entry or add new one
    // This is more efficient than clear() + add() and avoids potential race conditions
    if (entryIndex >= 0 && cache[entryIndex].id) {
      // Update existing entry
      entry.id = cache[entryIndex].id; // Preserve the ID for update
      await store.put(entry);
    } else {
      // Add new entry (ID will be auto-generated)
      await store.add(entry);
    }
    await tx.done;
  } catch (e) {
    console.error("Failed to save text translations to IndexedDB:", e);
  }
}

async function loadCachedTextTranslations() {
  // Wait a bit to ensure currentRequestId is set (handles race conditions)
  await new Promise(resolve => setTimeout(resolve, 100));
  
  if (!currentRequestId?.value && !userInputAudioLink?.value) {
    console.log("No requestId or inputLink provided, skipping text cache load");
    return;
  }

  let db: IDBPDatabase;
  try {
    db = await initTextCacheDB();
  } catch (e) {
    console.error("Failed to initialize IndexedDB:", e);
    return;
  }
  let cache: TextCacheEntry[] = [];
  try {
    cache = (await db.transaction("textCache").objectStore("textCache").getAll()) || [];
  } catch (e) {
    console.error("Failed to load cache from IndexedDB:", e);
    return;
  }
  const entry = cache.find(
    (item) =>
      (currentRequestId.value && item.requestId === currentRequestId.value) ||
      (userInputAudioLink.value && item.inputLink === userInputAudioLink.value)
  );

  if (!entry) {
    console.log("No cached text translations found");
    // Clear translations if no cache found for this request
    bulkTextTranslations.value = {};
    return;
  }

  // Load all cached translations into bulkTextTranslations
  const cachedTranslations: Record<string, string> = {};
  Object.keys(entry.languages).forEach((langCode) => {
    if (entry.languages[langCode]?.textTranslations) {
      cachedTranslations[langCode] = entry.languages[langCode].textTranslations;
    }
  });

  if (Object.keys(cachedTranslations).length > 0) {
    // Replace with cached translations (don't merge - this is a fresh load for a specific request)
    bulkTextTranslations.value = cachedTranslations;
    
    // Preserve current display language if it has a cached translation, otherwise use first available
    const currentLangCode = currentDisplayLanguage.value?.langCode;
    const langToDisplay = (currentLangCode && cachedTranslations[currentLangCode])
      ? languages.find((l) => l.langCode === currentLangCode)
      : languages.find((l) => l.langCode === Object.keys(cachedTranslations)[0]);
    
    if (langToDisplay) {
      currentDisplayLanguage.value = langToDisplay;
      translationLanguage.value = langToDisplay;
      translatedText.value = cachedTranslations[langToDisplay.langCode];
      defaultTranslatedText.value = cachedTranslations[langToDisplay.langCode];
    }
  } else {
    // Clear translations if no cache found for this request
    bulkTextTranslations.value = {};
  }
}

const selectTargetLanguage = async (lang: Language) => {
  if (originalLanguage.value?.langCode && lang.langCode == originalLanguage.value.langCode) {
    toast(t("original-and-translation-languages-must-be-different"), {
      autoClose: 1500,
      type: "error",
      theme: "light",
    });
    return;
  }

  if (isMultiLanguageMode.value) {
    // Multi-select mode: toggle language selection
    const index = selectedTargetLanguages.value.findIndex(
      (l) => l.langCode === lang.langCode
    );
    if (index >= 0) {
      // Deselect
      selectedTargetLanguages.value.splice(index, 1);
    } else {
      // Select
      selectedTargetLanguages.value.push({ ...lang });
    }
    // Update translationLanguage to the first selected or current display language
    if (selectedTargetLanguages.value.length > 0) {
      const displayLang = currentDisplayLanguage.value?.langCode
        ? currentDisplayLanguage.value
        : selectedTargetLanguages.value[0];
      translationLanguage.value = displayLang;
      // If translation exists in cache or bulk translations, show it
      if (bulkTextTranslations.value[displayLang.langCode]) {
        translatedText.value = bulkTextTranslations.value[displayLang.langCode];
        defaultTranslatedText.value = bulkTextTranslations.value[displayLang.langCode];
      } else {
        // Clear translation if switching to a language without translation
        translatedText.value = "";
        defaultTranslatedText.value = "";
      }
    } else {
      translationLanguage.value = {
        langName: "Arabic",
        langCode: "ar",
        countryCode: "sa",
      };
      translatedText.value = "";
      defaultTranslatedText.value = "";
    }
    isTargetLanguageSelected.value = selectedTargetLanguages.value.length > 0;
  } else {
    // Single-select mode: original behavior
    translationLanguage.value = { ...lang };
    isTargetLanguageSelected.value = true;
    
    // Check if translation exists for this language
    if (bulkTextTranslations.value[lang.langCode]) {
      translatedText.value = bulkTextTranslations.value[lang.langCode];
      defaultTranslatedText.value = bulkTextTranslations.value[lang.langCode];
    } else if (translationLanguage.value?.langCode === lang.langCode && translatedText.value && translatedText.value.length > 0) {
      // Keep current translation if it's for the selected language
      // Do nothing, translation already displayed
    } else {
      // Clear translation if switching to a different language without translation
      translatedText.value = "";
      defaultTranslatedText.value = "";
    }
    
    isTargetListOpen.value = false;
    closeList();
  }
};

const switchDisplayLanguage = (lang: Language) => {
  currentDisplayLanguage.value = { ...lang };
  translationLanguage.value = { ...lang };
  if (bulkTextTranslations.value[lang.langCode]) {
    translatedText.value = bulkTextTranslations.value[lang.langCode];
    defaultTranslatedText.value = bulkTextTranslations.value[lang.langCode];
  } else {
    translatedText.value = "";
    defaultTranslatedText.value = "";
  }
};

// Load translation directly from cache when clicking quick access language
const loadTranslationDirectly = (lang: Language) => {
  if (bulkTextTranslations.value[lang.langCode]) {
    currentDisplayLanguage.value = { ...lang };
    translationLanguage.value = { ...lang };
    translatedText.value = bulkTextTranslations.value[lang.langCode];
    defaultTranslatedText.value = bulkTextTranslations.value[lang.langCode];
    // Close the popup
    isTargetListOpen.value = false;
    closeList();
    toast(t("translation-loaded") || "Translation loaded", {
      autoClose: 1500,
      type: "success",
      theme: "light",
    });
  } else {
    toast(t("translation-not-available") || "Translation not available", {
      autoClose: 2000,
      type: "error",
      theme: "light",
    });
  }
};

// Helper function to detect if response is Soniox format
function isSonioxFormat(data: any): boolean {
  // Soniox format has: id, text, tokens array
  // Google Cloud format has: results array with alternatives
  if (!data || typeof data !== 'object') {
    return false;
  }
  
  // Check if it's Soniox format (has id, text, and tokens array)
  if (data.id !== undefined && data.text !== undefined && Array.isArray(data.tokens)) {
    console.log("✅ Detected Soniox format: has id, text, and tokens");
    return true;
  }
  
  // Check if it's Google Cloud format (has results array with alternatives)
  if (data.results && Array.isArray(data.results) && data.results.length > 0) {
    if (data.results[0].alternatives && Array.isArray(data.results[0].alternatives)) {
      console.log("✅ Detected Google Cloud format: has results.alternatives");
      return false;
    }
  }
  
  // Check if it's Google Cloud format (array with results)
  if (Array.isArray(data) && data.length > 0 && data[0].results) {
    console.log("✅ Detected Google Cloud format: array with results");
    return false;
  }
  
  return false;
}

// Parse Soniox transcription format
function parseSonioxTranscription(sonioxResponse: any): CaptionModel[] {
  try {
    const captions: CaptionModel[] = [];
    const minBinSize = 3.5;
    const maxBinSize = 4.5;
    
    if (!sonioxResponse.tokens || !Array.isArray(sonioxResponse.tokens)) {
      console.warn("Soniox response missing tokens array");
      return captions;
    }

    let currentSpeaker: number | null = null;
    let currentStartTime = 0;
    let transcript = "";
    let speakerSegments: Array<{
      word: string;
      speakerTag: number | null;
      startTime: number;
    }> = [];

    // Group tokens into words (tokens can be partial words like "S", "o,", " wh", "at")
    // Strategy: Tokens with leading spaces start new words, tokens without continue current word
    const words: Array<{
      text: string;
      startMs: number;
      endMs: number;
      speaker: number | null;
    }> = [];
    
    let currentWord = "";
    let wordStartMs = 0;
    let wordEndMs = 0;
    let wordSpeaker: number | null = null;

    sonioxResponse.tokens.forEach((token: any, index: number) => {
      const tokenText = token.text || "";
      const tokenStartMs = token.start_ms || 0;
      const tokenEndMs = token.end_ms || 0;
      const tokenSpeaker = token.speaker !== null && token.speaker !== undefined ? token.speaker : null;

      // Check if token has leading space (indicates new word starts)
      const hasLeadingSpace = tokenText.trimStart() !== tokenText;
      const trimmedTokenText = tokenText.trimStart();
      
      // If token has leading space, it means a new word is starting
      if (hasLeadingSpace) {
        // Save previous word if it exists
        if (currentWord.trim()) {
          words.push({
            text: currentWord.trim(),
            startMs: wordStartMs,
            endMs: wordEndMs,
            speaker: wordSpeaker
          });
        }
        // Start new word
        currentWord = trimmedTokenText;
        wordStartMs = tokenStartMs;
        wordEndMs = tokenEndMs;
        wordSpeaker = tokenSpeaker;
      } else {
        // Continue current word
        if (!currentWord) {
          // First token of a word
          wordStartMs = tokenStartMs;
          wordSpeaker = tokenSpeaker;
        }
        currentWord += tokenText;
        wordEndMs = tokenEndMs;
        // Update speaker if this token has one
        if (tokenSpeaker !== null) {
          wordSpeaker = tokenSpeaker;
        }
      }
    });

    // Handle last word if exists
    if (currentWord.trim()) {
      words.push({
        text: currentWord.trim(),
        startMs: wordStartMs,
        endMs: wordEndMs,
        speaker: wordSpeaker
      });
    }
    
    console.log("🔵 Soniox: Grouped tokens into words:", words.length, "words");
    if (words.length > 0) {
      console.log("First few words:", words.slice(0, 5));
    }

    // Helper function to determine the most common speaker in a segment
    const getMostCommonSpeaker = (segments: Array<{speakerTag: number | null}>): number | null => {
      const speakerCounts: Record<number, number> = {};
      let maxCount = 0;
      let mostCommonSpeaker: number | null = null;

      segments.forEach(segment => {
        if (segment.speakerTag !== null && segment.speakerTag !== undefined) {
          speakerCounts[segment.speakerTag] = (speakerCounts[segment.speakerTag] || 0) + 1;
          if (speakerCounts[segment.speakerTag] > maxCount) {
            maxCount = speakerCounts[segment.speakerTag];
            mostCommonSpeaker = segment.speakerTag;
          }
        }
      });

      // If no speaker found, try to get the first non-null speaker
      if (mostCommonSpeaker === null) {
        const firstSpeaker = segments.find(s => s.speakerTag !== null && s.speakerTag !== undefined);
        if (firstSpeaker) {
          mostCommonSpeaker = firstSpeaker.speakerTag;
        }
      }

      return mostCommonSpeaker;
    };

    // Now process words into captions (similar to Google Cloud logic)
    if (words.length === 0) {
      return captions;
    }
    
    
    words.forEach((word, i) => {
      const wordStartSeconds = word.startMs / 1000;
      const nextWord = words[i + 1];
      const nextWordStartSeconds = nextWord ? (nextWord.startMs / 1000) : null;
      
      const wordText = word.text;
      const speakerTag = word.speaker;

      // Initialize start time for new caption
      if (transcript.trim() === "") {
        currentStartTime = wordStartSeconds;
        currentSpeaker = speakerTag;
      }

      // Check if speaker changed BEFORE adding word (important for multi-speaker captions)
      const speakerChanged = currentSpeaker !== null && speakerTag !== null && currentSpeaker !== speakerTag;
      
      // If speaker changed and we have some content, split the caption immediately
      if (speakerChanged && transcript.trim() !== "" && speakerSegments.length > 0) {
        const duration = wordStartSeconds - currentStartTime;
        // Split immediately on speaker change if we have at least 0.3 seconds of content
        if (duration >= 0.3) {
          const captionSpeaker = getMostCommonSpeaker(speakerSegments);
          
          const newCaption: CaptionModel = {
            start: formatTime(currentStartTime),
            dur: formatTime(wordStartSeconds),
            text: transcript.trim(),
            speakerTag: captionSpeaker,
            words: [...speakerSegments]
          };

          captions.push(newCaption);

          // Reset for new speaker
          currentStartTime = wordStartSeconds;
          transcript = "";
          speakerSegments = [];
          currentSpeaker = speakerTag;
        }
      }

      // Add word to transcript
      transcript = transcript + " " + wordText;
      
      // Store word with speaker info for this segment
      speakerSegments.push({
        word: wordText,
        speakerTag: speakerTag,
        startTime: wordStartSeconds
      });

      // Update current speaker
      if (speakerTag !== null) {
        currentSpeaker = speakerTag;
      }
      
      // Check if we should create a caption chunk (based on duration)
      if (nextWordStartSeconds !== null) {
        const duration = nextWordStartSeconds - currentStartTime;
        const ndnextWord = words[i + 2];
        const ndnextWordStartSeconds = ndnextWord ? (ndnextWord.startMs / 1000) : null;
        const ndDuration = ndnextWordStartSeconds 
          ? (ndnextWordStartSeconds - nextWordStartSeconds + duration) 
          : null;

        // Split caption if:
        // 1. Duration is in the target range, OR
        // 2. Next duration would exceed max
        const shouldSplit = 
          (minBinSize <= duration && duration <= maxBinSize) ||
          (ndDuration && ndDuration > maxBinSize);

        if (shouldSplit) {
          // Determine the most common speaker for this caption
          const captionSpeaker = getMostCommonSpeaker(speakerSegments);
          
          const newCaption: CaptionModel = {
            start: formatTime(currentStartTime),
            dur: formatTime(nextWordStartSeconds),
            text: transcript.trim(),
            speakerTag: captionSpeaker,
            words: [...speakerSegments]
          };

          captions.push(newCaption);

          // Reset for next caption
          currentStartTime = nextWordStartSeconds;
          transcript = "";
          speakerSegments = [];
          currentSpeaker = speakerTag; // Set to new speaker
        }
      }
    });

    // Handle remaining transcript
    if (transcript.trim() !== "" && words.length > 0) {
      const lastWord = words[words.length - 1];
      const lastWordEndSeconds = lastWord.endMs / 1000;
      const duration = lastWordEndSeconds - currentStartTime;

      if (duration > 0) {
        // Determine the most common speaker for this caption
        const captionSpeaker = getMostCommonSpeaker(speakerSegments);
        
        const newCaption: CaptionModel = {
          start: formatTime(currentStartTime),
          dur: formatTime(lastWordEndSeconds),
          text: transcript.trim(),
          speakerTag: captionSpeaker,
          words: [...speakerSegments]
        };
        captions.push(newCaption);
      }
    }
    
    console.log("🔵 Soniox: Generated", captions.length, "captions");
    if (captions.length > 0) {
      console.log("First caption:", captions[0]);
      console.log("First caption details:", {
        start: captions[0].start,
        dur: captions[0].dur,
        text: captions[0].text,
        speakerTag: captions[0].speakerTag,
        wordsCount: captions[0].words?.length || 0
      });
    }
    
    // ========== LOG PARSING SUMMARY ==========
    console.log("═══════════════════════════════════════════════════════════");
    console.log("📊 SONIOX PARSING SUMMARY");
    console.log("═══════════════════════════════════════════════════════════");
    console.log("Total tokens processed:", sonioxResponse.tokens?.length || 0);
    console.log("Total words extracted:", words.length);
    console.log("Total captions generated:", captions.length);
    console.log("═══════════════════════════════════════════════════════════");

    return captions;
  } catch (error) {
    console.error("Error parsing Soniox transcription:", error);
    return [];
  }
}

// Generate WebVTT from Soniox format
function subtitleGenerationSoniox(sonioxResponse: any): string {
  try {
    const captions = parseSonioxTranscription(sonioxResponse);
    
    // Format captions into WebVTT
    let webvttContent = "WEBVTT\n\n";
    captions.forEach((caption, index) => {
      webvttContent += `${index + 1}\n${caption.start} --> ${caption.dur}\n${
        caption.text
      }\n\n`;
    });

    return webvttContent;
  } catch (error) {
    console.error("Error generating WebVTT from Soniox:", error);
    return "";
  }
}

// New method to extract text from Soniox format
const extractTextFromSoniox = (sonioxData: any): string => {
  try {
    // Soniox format has text field directly
    if (sonioxData && typeof sonioxData === 'object' && sonioxData.text) {
      return sonioxData.text || "";
    }
    
    // If text field is not available, try to reconstruct from tokens
    if (sonioxData && sonioxData.tokens && Array.isArray(sonioxData.tokens)) {
      let text = "";
      sonioxData.tokens.forEach((token: any) => {
        if (token.text) {
          text += token.text;
        }
      });
      return text.trim();
    }
    
    return "";
  } catch (error) {
    console.error("Error extracting text from Soniox:", error);
    return "";
  }
};

// Original extractText method - kept unchanged for Google Cloud format
const extractText = (data: any) => {
  try {
    let concatenatedTranscript = "";
    
    // Google Cloud format
    if (data[0]?.results) {
      data[0].results.forEach((result: any) => {
        result.alternatives.forEach((alternative: any) => {
          concatenatedTranscript += alternative.transcript + " ";
        });
      });
    }

    return concatenatedTranscript;
  } catch (error) {
    console.log("extractText");
    console.log(error);
    return "";
  }
};

const translateTextBulk = async () => {
  try {
    if (originalText.value.trim().length === 0) {
      toast(t("translation_empty"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (selectedTargetLanguages.value.length === 0) {
      toast(t("please-select-at-least-one-target-language"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    // Check if any selected language matches original
    const invalidLang = selectedTargetLanguages.value.find(
      (l) => l.langCode === originalLanguage.value.langCode
    );
    if (invalidLang) {
      toast(t("original-and-translation-languages-must-be-different"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }
    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }
    const canProceed = await computeTranslationCost(true);
    if (!canProceed) {
      return;
    }

    // Use GPT endpoint if context hint is provided
    const useGPT = translationHint.value && translationHint.value.trim().length > 0;
    const endpointUrl = useGPT ? translateTextBulkGPTUrl : translateTextBulkUrl;
    
    const targetLangCodes = selectedTargetLanguages.value.map((l) => l.langCode);
    const body = JSON.stringify({
      originalText: originalText.value,
      from: originalLanguage.value.langCode,
      to: targetLangCodes,
      isOriginalText: originalText.value === defaultOriginalText.value,
      externelLink: originalText.value === defaultOriginalText.value ? userInputAudioLink.value : undefined,
      ...(useGPT && { context: translationHint.value.trim() }),
    });

    const response = await fetch(endpointUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: body,
    });

    const results = await response.json();
    console.log(results);
    if (!response.ok) {
      switch (results.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return;
    }
    if (results.message === "Success" && results.translations) {
      // Merge new translations with existing ones (don't overwrite existing translations)
      bulkTextTranslations.value = {
        ...bulkTextTranslations.value,
        ...results.translations,
      };
      
      // Save to cache
      await saveTextTranslationsToCache(
        results.translations,
        targetLangCodes,
        currentRequestId.value || undefined,
        userInputAudioLink.value || undefined
      );

      // Display first selected language by default
      const firstLang = selectedTargetLanguages.value[0];
      if (results.translations[firstLang.langCode]) {
        currentDisplayLanguage.value = firstLang;
        translationLanguage.value = firstLang;
        translatedText.value = results.translations[firstLang.langCode];
        defaultTranslatedText.value = results.translations[firstLang.langCode];
      }
      
      // Clear selected languages after successful translation
      selectedTargetLanguages.value = [];
    } else {
      toast(t("translation-failed"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
    }
    await profileStore.getUserSubscription(authStore.token!);
  } catch (error) {
    console.error("Error making bulk translation request to the server:", error);
    toast(t("were-fixing-a-technical-issue-so-please-try"), {
      autoClose: 3000,
      type: "error",
      theme: "light",
    });
  }
};

const translateText = async () => {
  // If in multi-language mode and has selected languages, use bulk translation
  if (isMultiLanguageMode.value && selectedTargetLanguages.value.length > 0) {
    await translateTextBulk();
    return;
  }

  try {
    if (originalText.value.trim().length === 0) {
      toast(t("translation_empty"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (
      originalLanguage.value.langCode === translationLanguage.value.langCode
    ) {
      toast(
        t(
          "translation-language-matches-the-original-please-choose-a-different-language"
        ),
        {
          autoClose: 1500,
          type: "error",
          theme: "light",
        }
      );
      return;
    }
    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }
    const canProceed = await computeTranslationCost(true);
    if (!canProceed) {
      return;
    }
    // Use GPT endpoint if context hint is provided
    const useGPT = translationHint.value && translationHint.value.trim().length > 0;
    const endpointUrl = useGPT ? translateTextGPTUrl : translateTextUrl;
    
    let body;
    if (originalText.value === defaultOriginalText.value) {
      body = JSON.stringify({
        originalText: originalText.value,
        from: originalLanguage.value.langCode,
        to: translationLanguage.value.langCode,
        isOriginalText: true,
        externelLink: userInputAudioLink.value,
        ...(useGPT && { context: translationHint.value.trim() }),
      });
    } else {
      body = JSON.stringify({
        originalText: originalText.value,
        from: originalLanguage.value.langCode,
        to: translationLanguage.value.langCode,
        ...(useGPT && { context: translationHint.value.trim() }),
      });
    }

    const response = await fetch(endpointUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: body,
    });

    const results = await response.json();
    console.log(results);
    if (!response.ok) {
      switch (results.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return;
    }
    if (results.translatedText) {
      translatedText.value = results.translatedText;
      defaultTranslatedText.value = results.translatedText;
      latestTranslationId.value = results.requestId;
      
      // Store single translation in bulkTextTranslations for consistency
      if (translationLanguage.value?.langCode) {
        bulkTextTranslations.value = {
          ...bulkTextTranslations.value,
          [translationLanguage.value.langCode]: results.translatedText,
        };
        
        // Save to cache
        await saveTextTranslationsToCache(
          { [translationLanguage.value.langCode]: results.translatedText },
          [translationLanguage.value.langCode],
          currentRequestId.value || undefined,
          userInputAudioLink.value || undefined
        );
      }
      
      // Clear selected languages after successful translation (if in multi-mode)
      if (isMultiLanguageMode.value) {
        selectedTargetLanguages.value = [];
      }
    } else {
      translatedText.value = "Translation is not available";
    }
    await profileStore.getUserSubscription(authStore.token!);
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};

const showFontFamilyList = () => {
  fontFamilyListShow.value = !fontFamilyListShow.value;
};

const updateFontFamily = (selectedFont: string) => {
  fontFamily.value = selectedFont;
  showFontFamilyList();
};

async function applyFont(fontName:string) {
  const font:any = fontStore.fonts.find((f:any) => f.name === fontName);
  if (font) {
    await loadGoogleFont(fontName, font.files.regular);
    fontFamily.value = fontName;
    prefStore.setFontPreference({
      name: fontName,
      url: font.files.regular,
      variant: "regular",
    });
  }
  showFontFamilyList();
}

async function updatePreviewFont(fontName:string, fontUrl:string) {
  selectedPreviewFont.value = fontName;
  await loadGoogleFont(fontName, fontUrl);
}

const increaseFontSize = () => {
  try {
    if (fontSizePercent.value == 95) return;
    fontSizePercent.value += 5;
    updateTextSize();
  } catch (error) {
    console.log("increaseFontSize:", error);
  }
};

const updateTextSize = () => {
  if (fontSizePercent.value == 35) {
    fontSizeClass.value = "text-xs";
    fontSizeNumber.value = 8;
  } else if (fontSizePercent.value == 40) {
    fontSizeClass.value = "text-sm";
    fontSizeNumber.value = 10;
  } else if (fontSizePercent.value == 45) {
    fontSizeClass.value = "text-base";
    fontSizeNumber.value = 12;
  } else if (fontSizePercent.value == 50) {
    fontSizeClass.value = "text-lg";
    fontSizeNumber.value = 14;
  } else if (fontSizePercent.value == 55) {
    fontSizeClass.value = "text-xl";
    fontSizeNumber.value = 16;
  } else if (fontSizePercent.value == 60) {
    fontSizeClass.value = "text-2xl";
    fontSizeNumber.value = 18;
  } else if (fontSizePercent.value == 65) {
    fontSizeClass.value = "text-3xl";
    fontSizeNumber.value = 20;
  } else if (fontSizePercent.value == 70) {
    fontSizeClass.value = "text-4xl";
    fontSizeNumber.value = 22;
  } else if (fontSizePercent.value == 75) {
    fontSizeClass.value = "text-5xl";
    fontSizeNumber.value = 24;
  } else if (fontSizePercent.value == 80) {
    fontSizeClass.value = "text-6xl";
    fontSizeNumber.value = 26;
  } else if (fontSizePercent.value == 85) {
    fontSizeClass.value = "text-7xl";
    fontSizeNumber.value = 28;
  } else if (fontSizePercent.value == 90) {
    fontSizeClass.value = "text-8xl";
    fontSizeNumber.value = 30;
  } else if (fontSizePercent.value == 95) {
    fontSizeClass.value = "text-9xl";
    fontSizeNumber.value = 32;
  }
};

const downloadFileAs = async (type: string, isOriginal: boolean) => {
  try {
    if (type === "txt") {
      downloadAsTxt(isOriginal);
    } else if (type === "pdf") {
      showPdfPreviewModal(isOriginal);
    } else if (type === "doc") {
      await downloadAsDoc(isOriginal);
    } else if (type === "webvtt") {
      downloadWebVttFile(isOriginal);
    } else if (type === "srt") {
      downloadSrtFile(isOriginal);
    } else if (type === "json") {
      downloadJsonFile();
    } else {
      console.log("Unsupported file type");
    }
  } catch (error) {
    console.log("doenload error: ", error);
  }
};

const showPdfPreviewModal = (isOriginal: boolean) => {
  let val = "";
  if (isOriginal) {
    if (showOriginalSummarized.value) {
      val = originalSummarizedText.value;
    } else {
      val = originalText.value;
    }
  } else {
    if (showTranslatedSummarized.value) {
      val = translatedSummarizedText.value;
    } else {
      val = translatedText.value;
    }
  }

  const isArabic: boolean = isOriginal
    ? originalLanguage.value.langCode === "ar"
    : translationLanguage.value.langCode === "ar";

  previewText.value = val;
  previewConfig.value = {
    isOriginal,
    fontFamily: fontFamily.value || "Arial",
    fontSize: fontSizeNumber.value || 12,
    color: pickedColor.value || "#000000",
    isRtl: isArabic,
  };
  showPdfPreview.value = true;
};

const closePdfPreview = () => {
  showPdfPreview.value = false;
};

const downloadAsPdfWithFormatting = async (isOriginal: boolean, editedText: string, formatting: ParagraphFormat[]) => {
  const selectedFont = fontFamily.value || "";
  const selectedFontSize = fontSizeNumber.value || 12;
  const selectedColor = pickedColor.value || "#000000";
  
  const isArabic: boolean = isOriginal
    ? originalLanguage.value.langCode === "ar"
    : translationLanguage.value.langCode === "ar";
  
  if (isArabic) {
    console.log("=== USING HTML-TO-PDF APPROACH FOR ARABIC WITH FORMATTING ===");
    await downloadAsPdfHTML(isOriginal, editedText, selectedFont, selectedFontSize, selectedColor, formatting);
  } else {
    console.log("=== USING HTML-TO-PDF APPROACH FOR NON-ARABIC WITH FORMATTING ===");
    await downloadAsPdfHTML(isOriginal, editedText, selectedFont, selectedFontSize, selectedColor, formatting);
  }
};

const exportPdfFromPreview = async (editedText: string, formatting: ParagraphFormat[]) => {
  showPdfPreview.value = false;
  previewFormatting.value = formatting;
  await downloadAsPdfWithFormatting(previewConfig.value.isOriginal, editedText, formatting);
};

const hexToRgb = (hex: string): [number, number, number] => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
    : [0, 0, 0];
};

const downloadJsonFile = () => {
  const blob = new Blob([originalJsonContent.value], { type: "text/json" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `${generateFileName(true)}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const navToPayment = () => {
  try {
    activitesStore.setComingFrom("audiotranscription");
    router.push("/pricing");
  } catch (error) {
    console.log("navToPayment", error);
  }
};

const getLanguageText = () => {
  return (
    removeParentheses(originalLanguage.value.langName) || "Original Language"
  );
};

const downloadAsTxt = (isOriginal: boolean) => {
  let text = "";
  if (isOriginal) {
    if (showOriginalSummarized.value) {
      text = originalSummarizedText.value;
    } else {
      text = originalText.value;
    }
  } else {
    if (showTranslatedSummarized.value) {
      text = translatedSummarizedText.value;
    } else {
      text = translatedText.value;
    }
  }
  const blob = new Blob([text], {
    type: "text/plain;charset=utf-8",
  });
  saveAs(blob, `${generateFileName(isOriginal)}.txt`);
};

const normalizeText = (text: string, isArabic: boolean = false) => {
  console.log("=== TEXT NORMALIZATION ===");
  console.log("Input text length:", text.length);
  console.log("Is Arabic:", isArabic);
  console.log("Input preview (first 300 chars):", text.substring(0, 300));
  
  let normalized: string;
  if (isArabic) {
    normalized = text
      .split(/\n+/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0)
      .join("\n\n");
  } else {
    normalized = text
    .split("\n")
    .reduce((acc: any, line) => {
      const trimmedLine = line.trim();
      if (trimmedLine) {
        if (acc.length === 0) {
          return [trimmedLine];
        } else {
          const lastLine = acc[acc.length - 1];
          if (
            lastLine.endsWith(".") ||
            lastLine.endsWith("?") ||
            lastLine.endsWith("!")
          ) {
            return [...acc, trimmedLine];
          } else {
            return [...acc.slice(0, -1), `${lastLine} ${trimmedLine}`];
          }
        }
      }
      return acc;
    }, [])
    .join("\n");
  }
  
  console.log("Normalized text length:", normalized.length);
  console.log("Normalized preview (first 300 chars):", normalized.substring(0, 300));
  console.log("=== END NORMALIZATION ===\n");
  
  return normalized;
};

const preloadFont = async (fontFamily: string): Promise<boolean> => {
  if (fontLoadingCache.has(fontFamily)) {
    return fontLoadingCache.get(fontFamily)!;
  }
  
  const fontCheckString = `16px "${fontFamily}"`;
  let fontLoaded = false;
  
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }
  
  if (document.fonts && document.fonts.check) {
    fontLoaded = document.fonts.check(fontCheckString);
  } else {
    fontLoaded = true;
  }
  
  if (!fontLoaded) {
    const maxAttempts = 10;
    let attempts = 0;
    while (!fontLoaded && attempts < maxAttempts) {
      if (document.fonts && document.fonts.check) {
        fontLoaded = document.fonts.check(fontCheckString);
      } else {
        fontLoaded = true;
        break;
      }
      if (!fontLoaded) {
        attempts++;
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }
  }
  
  fontLoadingCache.set(fontFamily, fontLoaded);
  return fontLoaded;
};

const getUserFriendlyError = (error: Error, pageNumber?: number): { message: string, technical: string } => {
  const technical = error.message || String(error);
  
  if (technical.includes('Cancelled') || technical.includes('cancelled')) {
    return {
      message: pageNumber ? `PDF generation cancelled at page ${pageNumber}` : 'PDF generation cancelled',
      technical
    };
  }
  
  if (technical.includes('Canvas') || technical.includes('canvas')) {
    return {
      message: pageNumber ? `Failed to render page ${pageNumber}. Please try again.` : 'Failed to render PDF pages. Please try again.',
      technical
    };
  }
  
  if (technical.includes('font') || technical.includes('Font')) {
    return {
      message: 'Font loading failed. Please try again or use a different font.',
      technical
    };
  }
  
  if (technical.includes('html2canvas') || technical.includes('Failed to load')) {
    return {
      message: 'Failed to load required resources. Please check your internet connection and try again.',
      technical
    };
  }
  
  return {
    message: pageNumber ? `PDF generation failed at page ${pageNumber}. Please try again.` : 'PDF generation failed. Please try again.',
    technical
  };
};

const cancelPdfGeneration = () => {
  pdfCancelled.value = true;
  pdfProgress.value.status = 'error';
};

const downloadAsPdfHTML = async (isOriginal: boolean, text: string, fontFamily: string, fontSize: number, color: string, formatting: ParagraphFormat[] = []) => {
  const DEBUG_DOWNLOAD_IMAGES = false;
  
  console.log("=== HTML-TO-PDF GENERATION (Page-by-Page) ===");
  if (DEBUG_DOWNLOAD_IMAGES) {
    console.log("🔍 DEBUG MODE: Will download canvas images instead of PDF");
  }
  console.log("Font:", fontFamily, "Size:", fontSize, "Color:", color);
  
  const isRtl: boolean = isOriginal
    ? originalLanguage.value.langCode === "ar"
    : translationLanguage.value.langCode === "ar";
  
  isPdfGenerating.value = true;
  pdfCancelled.value = false;
  pdfError.value = null;
  pdfProgress.value = {
    currentPage: 0,
    totalPages: 0,
    percentage: 0,
    status: 'initializing'
  };
  
  const activeContainers: HTMLElement[] = [];
  
  try {
    pdfProgress.value.status = 'initializing';
    
    if (pdfCancelled.value) {
      throw new Error('Cancelled by user');
    }
    
    const fontLoaded = await preloadFont(fontFamily);
    if (!fontLoaded) {
      console.warn(`⚠️ Font "${fontFamily}" may not be fully loaded`);
    } else {
      console.log(`✅ Font "${fontFamily}" is confirmed loaded`);
    }
    
    const ensureHtml2Canvas = async (): Promise<any> => {
      if ((window as any).html2canvas) {
        return (window as any).html2canvas;
      }
      if (html2canvasLoadPromise) {
        await html2canvasLoadPromise;
        return (window as any).html2canvas;
      }
      
      html2canvasLoadPromise = new Promise<void>((resolve, reject) => {
        if ((window as any).html2canvas) {
          resolve();
          return;
        }
        
        const existingScript = document.querySelector('script[src*="html2canvas"]');
        if (existingScript) {
          existingScript.addEventListener('load', () => resolve());
          existingScript.addEventListener('error', () => reject(new Error("Failed to load html2canvas")));
          return;
        }
        
        console.log("Loading html2canvas from CDN...");
        const script = document.createElement("script");
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          html2canvasLoadPromise = null;
          reject(new Error("Failed to load html2canvas"));
        };
        document.head.appendChild(script);
      });
      
      await html2canvasLoadPromise;
      return (window as any).html2canvas;
    };
    
    const html2canvasLib = await ensureHtml2Canvas();
    
    const pageWidthMM = 210;
    const pageHeightMM = 297;
    const marginMM = 20;
    const contentWidthMM = pageWidthMM - (marginMM * 2);
    const dpi = 96;
    const contentWidthPX = Math.round((contentWidthMM / 25.4) * dpi);
    const pageHeightPX = Math.round((pageHeightMM / 25.4) * dpi);
    const marginPX = Math.round((marginMM / 25.4) * dpi);
    const contentHeightPX = pageHeightPX - (marginPX * 2);
    
    if (!text || text.trim().length === 0) {
      console.error("Empty text provided for PDF generation");
      throw new Error("Cannot generate PDF from empty text");
    }
    
    console.log("PDF Generation - Input text length:", text.length);
    console.log("PDF Generation - Formatting provided:", formatting?.length || 0);
    
    let paragraphs: string[] = [];
    let paragraphFormats: ParagraphFormat[] = [];
    
    if (formatting && formatting.length > 0) {
      const validFormats = formatting.filter(f => f && f.text && f.text.trim().length > 0);
      paragraphs = validFormats.map(f => f.text.trim());
      paragraphFormats = validFormats;
      console.log(`Using formatted paragraphs: ${paragraphs.length} paragraphs with formatting`);
      if (paragraphs.length === 0) {
        console.error("All formatted paragraphs are empty!");
        throw new Error("Cannot generate PDF: All paragraphs are empty");
      }
    } else {
      paragraphs = text.split(/\n\n+/).filter((p: string) => p.trim().length > 0);
      if (paragraphs.length === 0) {
        console.warn("No paragraphs found, using full text as single paragraph");
        paragraphs.push(text.trim());
      }
      const defaultAlignment = isRtl ? 'right' : 'left';
      paragraphFormats = paragraphs.map((p: string) => ({
        text: p,
        alignment: defaultAlignment as 'left' | 'center' | 'right' | 'justify',
        bold: false,
        italic: false,
        underline: false,
      }));
      console.log(`Processing ${paragraphs.length} paragraphs for PDF generation`);
    }
    
    console.log("Final paragraphs count:", paragraphs.length);
    console.log("Final formats count:", paragraphFormats.length);
    if (paragraphs.length > 0) {
      console.log("First paragraph preview:", paragraphs[0]?.substring(0, 50));
    }
    
    if (paragraphs.length === 0 || paragraphFormats.length === 0) {
      console.error("No paragraphs to process! paragraphs:", paragraphs.length, "formats:", paragraphFormats.length);
      throw new Error("Cannot generate PDF: No paragraphs found");
    }
    
    // Inject @font-face CSS rule for the selected font if not already present
    const fontFaceId = `pdf-font-face-${fontFamily.replace(/\s+/g, '-').toLowerCase()}`;
    let fontFaceElement = document.getElementById(fontFaceId) as HTMLStyleElement;
    
    if (!fontFaceElement && fontFamily) {
      // Get font URL from fontStore
      const font = fontStore.fonts.find((f: any) => f.name === fontFamily);
      if (font && font.files && font.files.regular) {
        console.log(`Injecting @font-face for "${fontFamily}" with URL: ${font.files.regular}`);
        fontFaceElement = document.createElement('style');
        fontFaceElement.id = fontFaceId;
        fontFaceElement.textContent = `
          @font-face {
            font-family: "${fontFamily}";
            src: url("${font.files.regular}") format("truetype");
            font-weight: normal;
            font-style: normal;
            font-display: swap;
          }
        `;
        document.head.appendChild(fontFaceElement);
        console.log(`✅ @font-face injected for "${fontFamily}"`);
        
        // Wait a bit for the font-face to be processed
        await new Promise(resolve => setTimeout(resolve, 300));
      } else {
        console.warn(`⚠️ Font "${fontFamily}" not found in fontStore, cannot inject @font-face`);
      }
    } else if (fontFaceElement) {
      console.log(`@font-face for "${fontFamily}" already exists`);
    }
    
    if (paragraphs.length !== paragraphFormats.length) {
      console.warn(`Mismatch: ${paragraphs.length} paragraphs but ${paragraphFormats.length} formats. Adjusting...`);
      while (paragraphFormats.length < paragraphs.length) {
        const defaultAlignment = isRtl ? 'right' : 'left';
        paragraphFormats.push({
          text: paragraphs[paragraphFormats.length],
          alignment: defaultAlignment as 'left' | 'center' | 'right' | 'justify',
          bold: false,
          italic: false,
          underline: false,
        });
      }
    }
    
    const doc = DEBUG_DOWNLOAD_IMAGES ? null : new jsPDF("p", "mm", "a4");
    // Track if we've used the first page (jsPDF auto-creates page 1)
    let firstPageUsed = false;
    // Store images for debug download
    const debugImages: Array<{imgData: string, pageNumber: number}> = [];
    
    let currentPageParagraphs: string[] = [];
    let currentPageFormats: ParagraphFormat[] = [];
    let currentPageHeight = 0;
    let currentPageStartIndex = 0; // Track starting paragraph index for current page
    const paragraphSpacingPX = Math.round(fontSize * 0.8); // Reduced spacing to prevent cutting issues
    
    const renderPage = async (pageParagraphs: string[], pageFormats: ParagraphFormat[], startParagraphIndex?: number): Promise<{imgData: string, widthMM: number, heightMM: number, canvasWidth: number, canvasHeight: number}> => {
      console.log(`Rendering page with ${pageParagraphs.length} paragraphs${startParagraphIndex !== undefined ? ` (starting at paragraph index ${startParagraphIndex})` : ''}`);
      
      if (pageParagraphs.length === 0) {
        console.warn("No paragraphs to render, skipping page");
        throw new Error("Cannot render empty page");
      }
      
      const pageContainer = document.createElement("div");
      // Use fixed positioning with specific coordinates for better html2canvas capture
      // Position off-screen but with proper dimensions for rendering
      pageContainer.style.position = "fixed";
      pageContainer.style.top = "0";
      pageContainer.style.left = "0";
      pageContainer.style.width = `${contentWidthPX + (marginPX * 2)}px`;
      pageContainer.style.maxWidth = `${contentWidthPX + (marginPX * 2)}px`;
      pageContainer.style.minWidth = `${contentWidthPX + (marginPX * 2)}px`; // Ensure minimum width
      // Remove minHeight - let content determine height naturally
      // Store original padding values (will be 0, but keeping for consistency)
      // Set padding for top, left, right to 0 - we'll add margins in PDF coordinates instead
      pageContainer.style.paddingTop = "0";
      pageContainer.style.paddingLeft = "0";
      pageContainer.style.paddingRight = "0";
      pageContainer.style.paddingBottom = "0"; // No padding - let html2canvas capture naturally
      pageContainer.style.backgroundColor = "#ffffff";
      pageContainer.style.fontFamily = `"${fontFamily}", Arial, sans-serif`; // Explicitly set font with quotes
      pageContainer.style.fontSize = `${fontSize}pt`;
      pageContainer.style.color = color;
      pageContainer.style.direction = isRtl ? "rtl" : "ltr";
      const defaultContainerAlignment = isRtl ? "right" : "left";
      pageContainer.style.lineHeight = "1.6";
      pageContainer.style.wordWrap = "break-word";
      pageContainer.style.overflowWrap = "break-word";
      pageContainer.style.boxSizing = "border-box";
      pageContainer.style.display = "block"; // Use block instead of flex
      pageContainer.style.visibility = "visible";
      pageContainer.style.opacity = "1"; // Fully visible for proper rendering
      pageContainer.style.pointerEvents = "none"; // Prevent interaction
      pageContainer.style.transform = "translateX(-9999px) translateZ(0)"; // Move off-screen but maintain layout
      pageContainer.style.overflow = "visible";
      pageContainer.style.zIndex = "-9999";
      
      pageParagraphs.forEach((paragraph: string, index: number) => {
        const trimmedParagraph = paragraph.trim();
        if (trimmedParagraph) {
          const p = document.createElement("p");
          const defaultAlignment = isRtl ? 'right' : 'left';
          const format = pageFormats[index] || {
            text: trimmedParagraph,
            alignment: defaultAlignment as 'left' | 'center' | 'right' | 'justify',
            bold: false,
            italic: false,
            underline: false,
          };
          
          p.style.margin = "0";
          p.style.marginTop = index > 0 ? `${paragraphSpacingPX}px` : "0";
          // Remove bottom margin completely, especially for last paragraph
          p.style.marginBottom = "0";
          p.style.padding = "0";
          // Ensure last paragraph has no extra spacing
          if (index === pageParagraphs.length - 1) {
            p.style.marginBottom = "0";
            p.style.paddingBottom = "0";
          }
          p.style.wordWrap = "break-word";
          p.style.overflowWrap = "break-word";
          p.style.wordBreak = "break-word"; // Additional safeguard for word breaking
          p.style.hyphens = "auto"; // Better word breaking with hyphens
          p.style.whiteSpace = "normal";
          p.style.display = "block";
          // Paragraph width should account for container padding - use contentWidthPX which is already calculated without padding
          p.style.width = `${contentWidthPX}px`; // Use exact content width, not 100%
          p.style.maxWidth = `${contentWidthPX}px`; // Prevent overflow
          p.style.minWidth = "0"; // Allow shrinking if needed
          p.style.boxSizing = "border-box";
          p.style.textAlign = format.alignment;
          // Add RTL-specific handling for proper text direction
          if (isRtl) {
            p.style.unicodeBidi = "bidi-override"; // Ensure proper RTL rendering
          }
          p.style.fontFamily = `"${fontFamily}", Arial, sans-serif`; // Explicitly set font with quotes
          p.style.fontWeight = format.bold ? "bold" : "normal";
          p.style.fontStyle = format.italic ? "italic" : "normal";
          p.style.textDecoration = format.underline ? "underline" : "none";
          p.style.lineHeight = "1.2"; // Restored to 1.2 for better readability
          p.style.overflow = "visible";
          p.textContent = trimmedParagraph;
          pageContainer.appendChild(p);
        }
      });
      
      document.body.appendChild(pageContainer);
      
      console.log(`📄 Page container created with ${pageContainer.children.length} paragraph children`);
      console.log(`Container initial dimensions: ${pageContainer.offsetWidth}x${pageContainer.offsetHeight}px`);
      
      // Wait for layout to calculate exact content bounds
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Calculate exact content bounds using Range API on all paragraphs
      const paragraphs = Array.from(pageContainer.querySelectorAll('p')) as HTMLElement[];
      let contentMinX = Infinity;
      let contentMinY = Infinity;
      let contentMaxX = -Infinity;
      let contentMaxY = -Infinity;
      
      if (paragraphs.length > 0) {
        const containerRect = pageContainer.getBoundingClientRect();
        
        // Use Range API for text content measurement (for precise width and top positioning)
        // Use element height for bottom boundary to include full rendered height with line-height and descenders
        paragraphs.forEach((p) => {
          const pRect = p.getBoundingClientRect();
          // Calculate relative to container for x position
          const relX = pRect.left - containerRect.left;
          const relY = pRect.top - containerRect.top;
          const relRight = relX + pRect.width;
          
          // Use element's getBoundingClientRect().bottom for bottom boundary
          // This includes full rendered height: line-height spacing, descenders, and all spacing
          const elementBottom = pRect.bottom - containerRect.top;
          
          // Use Range API for width and top positioning (more precise for text content)
          let textWidth = pRect.width; // Fallback to element width
          try {
            const range = document.createRange();
            range.selectNodeContents(p);
            const textRect = range.getBoundingClientRect();
            
            if (textRect.width > 0) {
              textWidth = textRect.width;
            }
            
            range.detach();
          } catch (error) {
            console.warn(`⚠️ Error using Range API for paragraph width:`, error);
          }
          
          console.log(`📏 Paragraph bounds: element height=${pRect.height}px, element bottom=${elementBottom.toFixed(2)}px, text width=${textWidth.toFixed(2)}px`);
          
          contentMinX = Math.min(contentMinX, relX);
          contentMinY = Math.min(contentMinY, relY);
          contentMaxX = Math.max(contentMaxX, relRight);
          // Use element bottom instead of text bottom to include full rendered height
          contentMaxY = Math.max(contentMaxY, elementBottom);
        });
        
        // Calculate exact content dimensions from bounds
        const exactContentWidth = Math.ceil(contentMaxX - contentMinX);
        const exactContentHeight = Math.ceil(contentMaxY - contentMinY);
        
        // Calculate padding based on computed line-height and descenders
        // Get computed line-height from the first paragraph to use for calculations
        let computedLineHeightPX = fontSize * 1.2; // Default fallback
        if (paragraphs.length > 0) {
          const firstParagraph = paragraphs[0];
          const computedStyle = window.getComputedStyle(firstParagraph);
          const lineHeightValue = computedStyle.lineHeight;
          
          // Parse line-height value (can be numeric like "1.2" or pixel value like "14.4px")
          if (lineHeightValue && lineHeightValue !== 'normal') {
            if (lineHeightValue.includes('px')) {
              // Pixel value: parse and use directly
              computedLineHeightPX = parseFloat(lineHeightValue);
            } else {
              // Numeric value: multiply by font size
              const numericValue = parseFloat(lineHeightValue);
              if (!isNaN(numericValue)) {
                computedLineHeightPX = fontSize * numericValue;
              }
            }
          }
        }
        
        // Calculate descender padding (25% of font size for characters like g, j, p, q, y)
        const descenderPadding = Math.ceil(fontSize * 0.25);
        
        // Calculate line-height padding: half of the extra spacing beyond font size
        // This accounts for line-height spacing that might not be fully captured
        const lineHeightSpacing = computedLineHeightPX - fontSize;
        const lineHeightPadding = Math.ceil(lineHeightSpacing / 2);
        
        // Total padding accounts for both descenders and line-height spacing
        const totalPadding = descenderPadding + lineHeightPadding;
        const boundsHeightWithPadding = exactContentHeight + totalPadding;
        
        // Add extra padding for the last line of the last paragraph
        // The last line needs full line-height plus descender space
        const lastLineExtraPadding = Math.ceil(computedLineHeightPX + descenderPadding);
        
        // Add significant buffer (15%) plus extra padding for last line to prevent cutting
        const boundsHeightWithBuffer = (boundsHeightWithPadding + lastLineExtraPadding) * 1.15;
        
        console.log(`📏 Exact content bounds: x=${contentMinX}, y=${contentMinY}, width=${exactContentWidth}, height=${exactContentHeight}`);
        console.log(`📏 Padding calculation: fontSize=${fontSize}pt, computedLineHeight=${computedLineHeightPX.toFixed(2)}px`);
        console.log(`📏 Padding breakdown: descenderPadding=${descenderPadding}px, lineHeightPadding=${lineHeightPadding}px, totalPadding=${totalPadding}px`);
        console.log(`📏 Last line extra padding: ${lastLineExtraPadding}px (lineHeight + descender)`);
        console.log(`📏 Bounds with padding: height=${boundsHeightWithPadding}px (added ${totalPadding}px padding)`);
        console.log(`📏 Bounds with last line padding: height=${(boundsHeightWithPadding + lastLineExtraPadding).toFixed(2)}px`);
        console.log(`📏 Bounds with 15% buffer: height=${boundsHeightWithBuffer.toFixed(2)}px (total added: ${(boundsHeightWithBuffer - exactContentHeight).toFixed(2)}px)`);
        console.log(`📏 Container dimensions: ${pageContainer.offsetWidth}x${pageContainer.offsetHeight}px`);
        
        // Use scrollHeight as a fallback if it's larger than our calculated bounds
        // scrollHeight includes all content including any overflow
        const containerScrollHeight = pageContainer.scrollHeight;
        const finalHeight = Math.max(boundsHeightWithBuffer, containerScrollHeight * 1.1);
        
        console.log(`📏 Container scrollHeight: ${containerScrollHeight}px`);
        console.log(`📏 Final height (max of calculated vs scrollHeight): ${finalHeight.toFixed(2)}px`);
        
        // Store for use in html2canvas with padding and buffer for safety margin
        (pageContainer as any).__contentBounds = {
          x: contentMinX,
          y: contentMinY,
          width: exactContentWidth,
          height: finalHeight // Use height with padding, last line padding, and buffer
        };
        
        // Let container height be determined naturally by content
        // Don't force height - let html2canvas capture naturally
        console.log(`✅ Container natural height: ${pageContainer.scrollHeight}px`);
      } else {
        // Fallback to scrollHeight if no paragraphs
        const exactContentHeight = pageContainer.scrollHeight;
        (pageContainer as any).__contentBounds = {
          x: 0,
          y: 0,
          width: pageContainer.offsetWidth,
          height: exactContentHeight
        };
        console.log(`📏 Fallback: Using scrollHeight for content height: ${exactContentHeight}px`);
      }
      
      // Wait for fonts and layout to settle
      if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
        console.log("✅ Fonts ready");
      }
      
      // Verify the specific font is loaded for this container
      const containerFontCheck = `16px "${fontFamily}"`;
      let containerFontLoaded = false;
      if (document.fonts && document.fonts.check) {
        containerFontLoaded = document.fonts.check(containerFontCheck);
        console.log(`Container font check: ${containerFontLoaded ? 'LOADED' : 'NOT LOADED'} for "${fontFamily}"`);
        
        if (!containerFontLoaded) {
          // Wait and retry
          for (let i = 0; i < 5; i++) {
            await new Promise(resolve => setTimeout(resolve, 400));
            containerFontLoaded = document.fonts.check(containerFontCheck);
            if (containerFontLoaded) {
              console.log(`✅ Font loaded after retry ${i + 1}`);
              break;
            }
          }
        }
      }
      
      // Additional wait time for font rendering and layout
      await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for layout to settle
      
      // Log computed font style to verify it's applied
      const computedStyle = window.getComputedStyle(pageContainer);
      const actualFontFamily = computedStyle.fontFamily;
      console.log(`📝 Container computed font-family: ${actualFontFamily}`);
      console.log(`📝 Expected font-family: "${fontFamily}"`);
      console.log(`📝 Font match: ${actualFontFamily.includes(fontFamily)}`);
      
      // Calculate actual content height - use only actual content dimensions, not forced minimum
      const containerHeight = Math.max(
        pageContainer.scrollHeight,
        pageContainer.offsetHeight
      );
      
      console.log(`📏 Container measurements:`);
      console.log(`  - offsetWidth: ${pageContainer.offsetWidth}px`);
      console.log(`  - offsetHeight: ${pageContainer.offsetHeight}px`);
      console.log(`  - scrollWidth: ${pageContainer.scrollWidth}px`);
      console.log(`  - scrollHeight: ${pageContainer.scrollHeight}px`);
      console.log(`  - clientWidth: ${pageContainer.clientWidth}px`);
      console.log(`  - clientHeight: ${pageContainer.clientHeight}px`);
      console.log(`  - Calculated height: ${containerHeight}px`);
      console.log(`  - Content height limit: ${contentHeightPX}px`);
      
      try {
        console.log("Starting html2canvas conversion...");
        
        // Get Range API bounds with small padding for html2canvas capture
        const contentBounds = (pageContainer as any).__contentBounds || {
          x: 0,
          y: 0,
          width: pageContainer.offsetWidth,
          height: pageContainer.offsetHeight
        };
        
        console.log(`Using Range API bounds with padding: x=${contentBounds.x}, y=${contentBounds.y}, width=${contentBounds.width}, height=${contentBounds.height}`);
        console.log(`Container dimensions: ${pageContainer.offsetWidth}x${pageContainer.offsetHeight}px (scrollHeight: ${pageContainer.scrollHeight}px)`);
        
        const containerScrollHeight = pageContainer.scrollHeight;
        const captureHeight = Math.max(contentBounds.height, containerScrollHeight * 1.2);
        
        console.log(`html2canvas capture: Using height=${captureHeight.toFixed(2)}px (scrollHeight=${containerScrollHeight}px * 1.2, calculated=${contentBounds.height}px)`);
        const canvas = await html2canvasLib(pageContainer, {
          scale: 2,
          useCORS: true,
          logging: true, // Enable logging to debug
          backgroundColor: "#ffffff",
          x: contentBounds.x, // Start capture at content x position
          y: contentBounds.y, // Start capture at content y position
          width: contentBounds.width, // Capture content width
          height: captureHeight,
          windowWidth: contentBounds.width,
          windowHeight: captureHeight,
          scrollX: 0, // Prevent scroll-related issues
          scrollY: 0, // Prevent scroll-related issues
          allowTaint: false,
          removeContainer: false,
          onclone: (clonedDoc: any, element: any) => {
            // Ensure font-face is available in cloned document
            const fontFaceId = `pdf-font-face-${fontFamily.replace(/\s+/g, '-').toLowerCase()}`;
            const originalFontFace = document.getElementById(fontFaceId) as HTMLStyleElement;
            
            if (originalFontFace && clonedDoc) {
              // Type assertion: clonedDoc is a Document, not File
              // html2canvas passes Document but TypeScript infers File type
              // Use helper function to properly type the document
              const getDocument = (doc: any): Document => doc as Document;
              const doc = getDocument(clonedDoc);
              // Check if font-face already exists in cloned document
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore - html2canvas passes Document, TypeScript incorrectly infers File
              let clonedFontFace = doc.getElementById(fontFaceId);
              if (!clonedFontFace) {
                // Inject font-face into cloned document
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - html2canvas passes Document, TypeScript incorrectly infers File
                const styleElement = doc.createElement('style');
                styleElement.id = fontFaceId;
                styleElement.textContent = originalFontFace.textContent;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - html2canvas passes Document, TypeScript incorrectly infers File
                doc.head.appendChild(styleElement);
                console.log(`✅ @font-face injected into cloned document for "${fontFamily}"`);
              } else {
                console.log(`@font-face already exists in cloned document`);
              }
            }
            
            // Ensure cloned element is visible and properly styled for capture
            const cloned = element as HTMLElement;
            cloned.style.visibility = "visible";
            cloned.style.opacity = "1";
            cloned.style.position = "absolute";
            cloned.style.top = "0";
            cloned.style.left = "0";
            cloned.style.display = "block";
            cloned.style.overflow = "visible";
            cloned.style.backgroundColor = "#ffffff";
            cloned.style.transform = "translateX(0) translateZ(0)"; // Reset transform for capture
            cloned.style.width = `${contentWidthPX + (marginPX * 2)}px`;
            cloned.style.maxWidth = `${contentWidthPX + (marginPX * 2)}px`;
            cloned.style.minWidth = `${contentWidthPX + (marginPX * 2)}px`;
            cloned.style.fontFamily = `"${fontFamily}", Arial, sans-serif`;
            console.log(`Cloned container font-family set to: "${fontFamily}"`);
            
            // Ensure all child paragraphs are also visible and properly styled
            const paragraphs = cloned.querySelectorAll("p");
            paragraphs.forEach((p: any, index: number) => {
              p.style.visibility = "visible";
              p.style.opacity = "1";
              p.style.color = color; // Ensure color is applied
              p.style.width = `${contentWidthPX}px`; // Use exact content width
              p.style.maxWidth = `${contentWidthPX}px`; // Prevent overflow
              p.style.fontFamily = `"${fontFamily}", Arial, sans-serif`; // Explicitly set font
              p.style.wordWrap = "break-word";
              p.style.overflowWrap = "break-word";
              p.style.wordBreak = "break-word"; // Additional safeguard
              p.style.hyphens = "auto"; // Better word breaking
              p.style.overflow = "visible";
              p.style.lineHeight = "1.2"; // Restored to 1.2 for better readability
              if (isRtl) {
                p.style.unicodeBidi = "bidi-override"; // Ensure proper RTL rendering
              }
              
              // Log font verification for first paragraph
              const getDocument = (doc: any): Document => doc as Document;
              const docForView = getDocument(clonedDoc);
              if (index === 0) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - html2canvas passes Document, TypeScript incorrectly infers File
                if (docForView.defaultView) {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore - html2canvas passes Document, TypeScript incorrectly infers File
                  const computedStyle = docForView.defaultView.getComputedStyle(p);
                  console.log(`📝 Cloned paragraph ${index} computed font-family: ${computedStyle.fontFamily}`);
                }
              }
            });
            console.log("onclone: Cloned element styled for capture, paragraphs:", paragraphs.length);
          }
        });
        
        console.log(`Canvas created: ${canvas.width}x${canvas.height}px`);
        console.log(`Canvas pixel ratio: ${window.devicePixelRatio || 1}`);
        console.log(`Canvas data size: ${canvas.width * canvas.height * 4} bytes (RGBA)`);
        
        if (!canvas || canvas.width === 0 || canvas.height === 0) {
          console.error("Canvas is empty!");
          console.error(`Container had ${pageContainer.children.length} children`);
          console.error(`Container scrollHeight: ${pageContainer.scrollHeight}px`);
          if (pageContainer && pageContainer.parentNode === document.body) {
            document.body.removeChild(pageContainer);
          }
          throw new Error("Canvas generation failed: empty canvas");
        }
        
        // Validate canvas has content by checking multiple areas for non-white pixels
        const ctx = canvas.getContext("2d");
        if (ctx) {
          // Sample from multiple areas: top-left, center, and bottom-right
          const sampleAreas = [
            { x: 0, y: 0, w: Math.min(canvas.width, 200), h: Math.min(canvas.height, 200) }, // Top-left
            { x: Math.max(0, canvas.width / 2 - 100), y: Math.max(0, canvas.height / 2 - 100), w: 200, h: 200 }, // Center
            { x: Math.max(0, canvas.width - 200), y: Math.max(0, canvas.height - 200), w: 200, h: 200 } // Bottom-right
          ];
          
          let hasNonWhitePixels = false;
          let hasTextColorPixels = false;
          
          // Convert color hex to RGB for comparison
          const colorRgb = hexToRgb(color);
          
          for (const area of sampleAreas) {
            if (area.x >= canvas.width || area.y >= canvas.height) continue;
            
            const actualW = Math.min(area.w, canvas.width - area.x);
            const actualH = Math.min(area.h, canvas.height - area.y);
            if (actualW <= 0 || actualH <= 0) continue;
            
            const imageData = ctx.getImageData(area.x, area.y, actualW, actualH);
            const pixels = imageData.data;
            
            for (let i = 0; i < pixels.length; i += 4) {
              const r = pixels[i];
              const g = pixels[i + 1];
              const b = pixels[i + 2];
              const a = pixels[i + 3];
              
              // Check if pixel is not white (255,255,255) or transparent
              if (a > 0 && (r < 250 || g < 250 || b < 250)) {
                hasNonWhitePixels = true;
                
                // Check if pixel matches text color (within tolerance)
                const colorMatch = Math.abs(r - colorRgb[0]) < 50 && 
                                  Math.abs(g - colorRgb[1]) < 50 && 
                                  Math.abs(b - colorRgb[2]) < 50;
                if (colorMatch) {
                  hasTextColorPixels = true;
                  break;
                }
              }
            }
            
            if (hasTextColorPixels) break;
          }
          
          if (!hasNonWhitePixels) {
            console.warn("⚠️ Canvas appears to be all white/transparent - this might indicate a rendering issue");
            console.warn(`Canvas size: ${canvas.width}x${canvas.height}, Container children: ${pageContainer.children.length}`);
          } else if (!hasTextColorPixels) {
            console.warn("⚠️ Canvas has content but no text color pixels detected - might be rendering issue");
          } else {
            console.log("✅ Canvas validation: Contains text color pixels (has content)");
          }
          
          // Canvas post-processing removed - let html2canvas capture naturally
          // Aggressive cropping was causing content to be cut off
        }
        
        const imgData = canvas.toDataURL("image/png");
        const imgDataSizeKB = Math.round(imgData.length / 1024);
        console.log(`Image data length: ${imgData.length} bytes (${imgDataSizeKB} KB)`);
        console.log(`Image data preview: ${imgData.substring(0, 50)}...`);
        console.log(`Image data valid: ${imgData.startsWith('data:image/png')}`);
        
        if (!imgData || imgData === "data:," || imgData.length < 100) {
          console.error("Invalid image data!");
          console.error(`Image data was: ${imgData ? imgData.substring(0, 100) : 'null/undefined'}`);
          if (pageContainer && pageContainer.parentNode === document.body) {
            document.body.removeChild(pageContainer);
          }
          throw new Error("Failed to convert canvas to image data");
        }
        
        // Additional validation: check if image data is not just a white image
        if (imgData.length < 5000) {
          console.warn("⚠️ Image data seems unusually small - might be a white/empty image");
        }
        
        // Debug: Download image for 2nd paragraph (index 1) for verification
        if (startParagraphIndex === 1) {
          try {
            console.log("🔍 DEBUG: Downloading canvas image for 2nd paragraph...");
            const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
            const filename = `debug-paragraph-2-${timestamp}.png`;
            
            // Convert data URL to blob
            const byteString = atob(imgData.split(',')[1]);
            const mimeString = imgData.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            
            // Create download link and trigger download
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            
            console.log(`✅ DEBUG: Downloaded canvas image as ${filename}`);
          } catch (error) {
            console.warn(`⚠️ DEBUG: Failed to download canvas image:`, error);
          }
        }
        
        if (pageContainer && pageContainer.parentNode === document.body) {
          document.body.removeChild(pageContainer);
        }
        
        // Calculate aspect ratio and image dimensions in mm
        const scale = 2; // html2canvas scale
        const dpi = 96; // DPI used for calculations
        const mmPerInch = 25.4;
        
        // Calculate actual canvas dimensions (divide by scale to get original size)
        const actualCanvasWidth = canvas.width / scale;
        const actualCanvasHeight = canvas.height / scale;
        
        // Calculate image dimensions in mm
        const imageWidthMM = (actualCanvasWidth / dpi) * mmPerInch;
        const imageHeightMM = (actualCanvasHeight / dpi) * mmPerInch;
        
        const aspectRatio = canvas.width / canvas.height;
        console.log(`✅ Page rendered successfully: ${pageParagraphs.length} paragraphs, ${canvas.width}x${canvas.height}px canvas (scale ${scale}), ${imgDataSizeKB}KB image`);
        console.log(`📐 Canvas aspect ratio: ${aspectRatio.toFixed(3)}`);
        console.log(`📏 Image dimensions: ${imageWidthMM.toFixed(2)}mm x ${imageHeightMM.toFixed(2)}mm`);
        console.log(`📄 Page dimensions: ${pageWidthMM}mm x ${pageHeightMM}mm`);
        
        // Return image data along with dimensions for proper scaling
        return {
          imgData,
          widthMM: imageWidthMM,
          heightMM: imageHeightMM,
          canvasWidth: canvas.width,
          canvasHeight: canvas.height
        };
      } catch (error) {
        if (pageContainer && pageContainer.parentNode === document.body) {
          document.body.removeChild(pageContainer);
        }
        console.error("Error in renderPage:", error);
        throw error;
      }
    };
    
    const chunkArray = <T>(array: T[], size: number): T[][] => {
      const chunks: T[][] = [];
      for (let i = 0; i < array.length; i += size) {
        chunks.push(array.slice(i, i + size));
      }
      return chunks;
    };
    
    pdfProgress.value.status = 'rendering';
    console.log(`Starting page splitting for ${paragraphs.length} paragraphs`);
    
    let estimatedPages = 1;
    let tempHeight = 0;
    for (let i = 0; i < Math.min(paragraphs.length, 100); i++) {
      const testContainer = document.createElement("div");
      testContainer.style.position = "absolute";
      testContainer.style.top = "0";
      testContainer.style.left = "0";
      testContainer.style.width = `${contentWidthPX}px`;
      testContainer.style.fontFamily = fontFamily || "Arial";
      testContainer.style.fontSize = `${fontSize}pt`;
      testContainer.style.lineHeight = "1.6";
      testContainer.style.visibility = "hidden";
      testContainer.style.opacity = "0";
      testContainer.textContent = paragraphs[i]?.trim() || '';
      document.body.appendChild(testContainer);
      await new Promise(resolve => setTimeout(resolve, 10));
      const rect = testContainer.getBoundingClientRect();
      const paraHeight = Math.ceil(rect.height);
      document.body.removeChild(testContainer);
      const spacing = tempHeight > 0 ? paragraphSpacingPX : 0;
      const totalH = tempHeight + spacing + paraHeight;
      if (totalH > contentHeightPX && tempHeight > 0) {
        estimatedPages++;
        tempHeight = paraHeight;
      } else {
        tempHeight = totalH;
      }
    }
    estimatedPages = Math.max(estimatedPages, Math.ceil(paragraphs.length / 10));
    
    if (estimatedPages > 50) {
      console.warn(`Large document detected: ${estimatedPages} pages. This may take longer and use more memory.`);
    }
    
    pdfProgress.value.totalPages = estimatedPages;
    pdfProgress.value.status = 'rendering';
    
    let renderedPages = 0;
    
    for (let i = 0; i < paragraphs.length; i++) {
      if (pdfCancelled.value) {
        throw new Error('Cancelled by user');
      }
      const paragraph = paragraphs[i];
      let format = paragraphFormats[i];
      
      if (!paragraph || paragraph.trim().length === 0) {
        console.warn(`Skipping empty paragraph at index ${i}`);
        continue;
      }
      
      if (!format) {
        console.warn(`Missing format for paragraph ${i}, using default`);
        const defaultAlignment = isRtl ? 'right' : 'left';
        format = {
          text: paragraph,
          alignment: defaultAlignment as 'left' | 'center' | 'right' | 'justify',
          bold: false,
          italic: false,
          underline: false,
        };
        paragraphFormats[i] = format;
      }
      
      const testContainer = document.createElement("div");
      testContainer.style.position = "absolute";
      testContainer.style.top = "0";
      testContainer.style.left = "0";
      testContainer.style.width = `${contentWidthPX}px`; // Use exact content width
      testContainer.style.maxWidth = `${contentWidthPX}px`; // Prevent overflow
      testContainer.style.minWidth = "0"; // Allow shrinking if needed
      testContainer.style.fontFamily = fontFamily || "Arial";
      testContainer.style.fontSize = `${fontSize}pt`;
      testContainer.style.lineHeight = "1.6";
      testContainer.style.wordWrap = "break-word";
      testContainer.style.overflowWrap = "break-word";
      testContainer.style.wordBreak = "break-word"; // Additional safeguard for word breaking
      testContainer.style.hyphens = "auto"; // Better word breaking with hyphens
      testContainer.style.padding = "0";
      testContainer.style.margin = "0";
      testContainer.style.visibility = "hidden";
      testContainer.style.opacity = "0";
      testContainer.style.pointerEvents = "none";
      testContainer.style.direction = isRtl ? "rtl" : "ltr";
      testContainer.style.textAlign = format?.alignment || (isRtl ? "right" : "left");
      testContainer.style.fontWeight = format?.bold ? "bold" : "normal";
      testContainer.style.fontStyle = format?.italic ? "italic" : "normal";
      testContainer.style.textDecoration = format?.underline ? "underline" : "none";
      testContainer.style.overflow = "hidden"; // Prevent text overflow in measurement
      testContainer.style.boxSizing = "border-box";
      if (isRtl) {
        testContainer.style.unicodeBidi = "bidi-override"; // Ensure proper RTL rendering
      }
      testContainer.textContent = paragraph.trim();
      document.body.appendChild(testContainer);
      
      // Wait for layout to calculate
      await new Promise(resolve => setTimeout(resolve, 50));
      
      // Use getBoundingClientRect() for accurate measurements including margins
      const rect = testContainer.getBoundingClientRect();
      const paragraphHeight = Math.ceil(rect.height);
      
      document.body.removeChild(testContainer);
      
      // Calculate spacing: add spacing between paragraphs, but not before first paragraph
      const spacing = currentPageParagraphs.length > 0 ? paragraphSpacingPX : 0;
      
      // Total height includes: current accumulated height + spacing (if not first) + new paragraph height
      const totalHeight = currentPageHeight + spacing + paragraphHeight;
      
      console.log(`Paragraph ${i}: height=${paragraphHeight}px, spacing=${spacing}px, currentHeight=${currentPageHeight}px, totalHeight=${totalHeight}px, maxHeight=${contentHeightPX}px`);
      
      if (totalHeight > contentHeightPX && currentPageParagraphs.length > 0) {
        // Validate we have content before rendering
        if (currentPageParagraphs.length === 0 || currentPageFormats.length === 0) {
          console.error("Attempted to render page with no paragraphs!");
          continue;
        }
        
        console.log(`📄 Page full, rendering ${currentPageParagraphs.length} paragraphs`);
        console.log(`   Paragraphs on this page: ${currentPageParagraphs.map((p, idx) => `[${idx}]: "${p.substring(0, 30)}..."`).join(', ')}`);
        
        if (pdfCancelled.value) {
          throw new Error('Cancelled by user');
        }
        
        const pageResult = await renderPage(currentPageParagraphs, currentPageFormats, currentPageStartIndex);
        renderedPages++;
        pdfProgress.value.currentPage = renderedPages;
        pdfProgress.value.percentage = Math.round((renderedPages / estimatedPages) * 100);
        console.log(`✅ Image data received, length: ${pageResult.imgData.length} bytes`);
        console.log(`📏 Image dimensions: ${pageResult.widthMM.toFixed(2)}mm x ${pageResult.heightMM.toFixed(2)}mm`);
        
        // Validate image data before adding to PDF
        if (!pageResult.imgData || pageResult.imgData.length < 100 || !pageResult.imgData.startsWith('data:image/png')) {
          console.error(`❌ Invalid image data for page: length=${pageResult.imgData?.length}, startsWith=${pageResult.imgData?.substring(0, 20)}`);
          throw new Error("Invalid image data received from renderPage");
        }
        
        // Calculate image position with margins in PDF coordinates (mm)
        // Since container has no padding, we add margins here in PDF coordinates
        const xPosition = marginMM; // Add left margin
        const yPosition = marginMM; // Add top margin
        
        // Use calculated dimensions instead of forcing page dimensions to prevent stretching
        const imageWidthMM = Math.min(pageResult.widthMM, pageWidthMM); // Don't exceed page width
        const imageHeightMM = Math.min(pageResult.heightMM, pageHeightMM); // Don't exceed page height
        
        console.log(`📐 Adding image to PDF: ${imageWidthMM.toFixed(2)}mm x ${imageHeightMM.toFixed(2)}mm at (${xPosition}, ${yPosition})`);
        
        if (DEBUG_DOWNLOAD_IMAGES) {
          // Debug mode: Store image for download instead of adding to PDF
          const pageNumber = debugImages.length + 1;
          debugImages.push({ imgData: pageResult.imgData, pageNumber });
          console.log(`🔍 DEBUG: Stored image for page ${pageNumber} (will download instead of PDF)`);
        } else {
          // Replace first page content if not used yet, otherwise add new page
          if (!firstPageUsed) {
            // Clear the auto-created first page and add our content
            doc!.setPage(1);
            doc!.deletePage(1);
            doc!.addPage();
            doc!.addImage(pageResult.imgData, "PNG", xPosition, yPosition, imageWidthMM, imageHeightMM);
            firstPageUsed = true;
            console.log(`📑 Added FIRST page to PDF (page 1)`);
          } else {
            doc!.addPage();
            doc!.addImage(pageResult.imgData, "PNG", xPosition, yPosition, imageWidthMM, imageHeightMM);
            console.log(`📑 Added page ${doc!.getNumberOfPages()} to PDF`);
          }
        }
        
        pageResult.imgData = '';
        
        currentPageParagraphs = [paragraph];
        currentPageFormats = [format];
        currentPageHeight = paragraphHeight;
        currentPageStartIndex = i; // Track starting index for new page
      } else {
        // If this is the first paragraph on the page, set the start index
        if (currentPageParagraphs.length === 0) {
          currentPageStartIndex = i;
        }
        currentPageParagraphs.push(paragraph);
        currentPageFormats.push(format);
        currentPageHeight = totalHeight;
      }
    }
    
    // Ensure first page has content - validate before rendering
    if (currentPageParagraphs.length > 0 && currentPageFormats.length > 0) {
      try {
        console.log(`📄 Rendering FINAL page with ${currentPageParagraphs.length} paragraphs`);
        console.log(`   Final page paragraphs: ${currentPageParagraphs.map((p, idx) => `[${idx}]: "${p.substring(0, 30)}..."`).join(', ')}`);
        
        // Double-check we have valid content
        const validParagraphs = currentPageParagraphs.filter(p => p && p.trim().length > 0);
        if (validParagraphs.length === 0) {
          console.error("❌ Final page has no valid paragraphs!");
          throw new Error("Cannot render page with empty paragraphs");
        }
        
        if (pdfCancelled.value) {
          throw new Error('Cancelled by user');
        }
        
        const pageResult = await renderPage(currentPageParagraphs, currentPageFormats, currentPageStartIndex);
        renderedPages++;
        pdfProgress.value.currentPage = renderedPages;
        pdfProgress.value.totalPages = renderedPages;
        pdfProgress.value.percentage = 100;
        console.log(`✅ Final page image data received, length: ${pageResult.imgData.length} bytes`);
        console.log(`📏 Image dimensions: ${pageResult.widthMM.toFixed(2)}mm x ${pageResult.heightMM.toFixed(2)}mm`);
        
        // Validate image data before adding to PDF
        if (!pageResult.imgData || pageResult.imgData.length < 100 || !pageResult.imgData.startsWith('data:image/png')) {
          console.error(`❌ Invalid image data for final page: length=${pageResult.imgData?.length}, startsWith=${pageResult.imgData?.substring(0, 20)}`);
          throw new Error("Invalid image data received from renderPage");
        }
        
        // Calculate image position with margins in PDF coordinates (mm)
        // Since container has no padding, we add margins here in PDF coordinates
        const xPosition = marginMM; // Add left margin
        const yPosition = marginMM; // Add top margin
        
        // Use calculated dimensions instead of forcing page dimensions to prevent stretching
        const imageWidthMM = Math.min(pageResult.widthMM, pageWidthMM); // Don't exceed page width
        const imageHeightMM = Math.min(pageResult.heightMM, pageHeightMM); // Don't exceed page height
        
        console.log(`📐 Adding final image to PDF: ${imageWidthMM.toFixed(2)}mm x ${imageHeightMM.toFixed(2)}mm at (${xPosition}, ${yPosition})`);
        
        if (DEBUG_DOWNLOAD_IMAGES) {
          // Debug mode: Store image for download instead of adding to PDF
          const pageNumber = debugImages.length + 1;
          debugImages.push({ imgData: pageResult.imgData, pageNumber });
          console.log(`🔍 DEBUG: Stored final image for page ${pageNumber} (will download instead of PDF)`);
        } else {
          // Replace first page content if not used yet, otherwise add new page
          if (!firstPageUsed) {
            // Clear the auto-created first page and add our content
            doc!.setPage(1);
            doc!.deletePage(1);
            doc!.addPage();
            doc!.addImage(pageResult.imgData, "PNG", xPosition, yPosition, imageWidthMM, imageHeightMM);
            firstPageUsed = true;
            console.log(`📑 Added FIRST (and only) page to PDF (page 1)`);
          } else {
            doc!.addPage();
            doc!.addImage(pageResult.imgData, "PNG", xPosition, yPosition, imageWidthMM, imageHeightMM);
            console.log(`📑 Added FINAL page ${doc!.getNumberOfPages()} to PDF`);
          }
        }
        
        pageResult.imgData = '';
        
        const pageCount = DEBUG_DOWNLOAD_IMAGES ? debugImages.length : (doc?.getNumberOfPages() || 0);
        console.log(`✅ Completed: Page ${pageCount} with ${currentPageParagraphs.length} paragraphs`);
      } catch (error) {
        console.error("Error rendering final page:", error);
        throw error;
      }
    } else {
      console.warn("No paragraphs to render for final page");
      if (!DEBUG_DOWNLOAD_IMAGES && doc && doc.getNumberOfPages() === 0) {
        throw new Error("PDF generation failed: No pages were created");
      }
      if (DEBUG_DOWNLOAD_IMAGES && debugImages.length === 0) {
        throw new Error("Image generation failed: No images were created");
      }
    }
    
    if (DEBUG_DOWNLOAD_IMAGES) {
      // Debug mode: Download all images instead of PDF
      console.log(`🔍 DEBUG MODE: Downloading ${debugImages.length} images instead of PDF`);
      
      if (debugImages.length === 0) {
        console.error("No images were generated");
        throw new Error("Failed to generate images: No images created");
      }
      
      // Download each image with a delay to avoid browser blocking multiple downloads
      for (let i = 0; i < debugImages.length; i++) {
        const { imgData, pageNumber } = debugImages[i];
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
        const fileName = `debug-page-${pageNumber}-${timestamp}.png`;
        
        try {
          // Convert data URL to blob
          const byteString = atob(imgData.split(',')[1]);
          const mimeString = imgData.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let j = 0; j < byteString.length; j++) {
            ia[j] = byteString.charCodeAt(j);
          }
          const blob = new Blob([ab], { type: mimeString });
          
          // Create download link and trigger download
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.style.display = 'none';
          document.body.appendChild(link);
          
          // Add delay between downloads to avoid browser blocking
          await new Promise(resolve => setTimeout(resolve, i * 500));
          link.click();
          
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          
          console.log(`✅ DEBUG: Downloaded ${fileName}`);
        } catch (error) {
          console.error(`❌ DEBUG: Failed to download image for page ${pageNumber}:`, error);
        }
      }
      
      console.log(`=== DEBUG MODE COMPLETE: Downloaded ${debugImages.length} images ===`);
    } else {
      if (!doc || doc.getNumberOfPages() === 0) {
        console.error("No pages were created in PDF");
        throw new Error("Failed to generate PDF: No pages created");
      }
      
      const fileName = `${generateFileName(isOriginal)}.pdf`;
      doc.save(fileName);
      
      console.log(`=== HTML-TO-PDF COMPLETE: ${doc.getNumberOfPages()} pages ===`);
    }
  } catch (error) {
    console.error("HTML-to-PDF error:", error);
    const errorInfo = getUserFriendlyError(error instanceof Error ? error : new Error(String(error)));
    pdfError.value = {
      message: errorInfo.message,
      technical: errorInfo.technical
    };
    pdfProgress.value.status = 'error';
  } finally {
    activeContainers.forEach(container => {
      if (container && container.parentNode === document.body) {
        try {
          document.body.removeChild(container);
        } catch (e) {
          console.warn('Failed to remove container:', e);
        }
      }
    });
    activeContainers.length = 0;
    
    if (!pdfCancelled.value && !pdfError.value) {
      pdfProgress.value.status = 'complete';
    }
    
    isPdfGenerating.value = false;
  }
};

const measureTextWidthHTML = (text: string, fontFamily: string, fontSize: number): number => {
  const measureElement = document.createElement("div");
  measureElement.style.position = "absolute";
  measureElement.style.visibility = "hidden";
  measureElement.style.whiteSpace = "nowrap";
  measureElement.style.fontFamily = fontFamily;
  measureElement.style.fontSize = `${fontSize}pt`;
  measureElement.style.direction = "rtl";
  measureElement.style.textAlign = "right";
  measureElement.textContent = text;
  
  document.body.appendChild(measureElement);
  const width = measureElement.offsetWidth * (72 / 96);
  document.body.removeChild(measureElement);
  
  return width;
};

const splitArabicTextByWords = (text: string, maxWidth: number, doc: any, fontName: string, fontSize: number): string[] => {
  console.log("=== CUSTOM ARABIC WORD-BOUNDARY SPLITTING (HTML-based measurement) ===");
  const paragraphs = text.split(/\n\n+/);
  const lines: string[] = [];
  
  doc.setFont(fontName, "normal");
  doc.setFontSize(fontSize);
  
  paragraphs.forEach((paragraph: string, paraIndex: number) => {
    const trimmedParagraph = paragraph.trim();
    if (!trimmedParagraph) return;
    
    console.log(`\n--- Processing Paragraph ${paraIndex + 1} ---`);
    console.log("Paragraph text:", trimmedParagraph.substring(0, 100));
    
    const words = trimmedParagraph.split(/\s+/).filter((w: string) => w.length > 0);
    console.log("Number of words:", words.length);
    console.log("First 10 words:", words.slice(0, 10));
    
    let currentLine = "";
    
    words.forEach((word: string, wordIndex: number) => {
      if (!word || word.trim().length === 0) return;
      
      const testLine = currentLine ? `${currentLine} ${word}` : word;
      
      const htmlWidth = measureTextWidthHTML(testLine, fontName, fontSize);
      const jsPdfWidth = doc.getTextWidth(testLine);
      
      const testWidth = htmlWidth > 0 ? htmlWidth : jsPdfWidth;
      
      if (testWidth > maxWidth && currentLine) {
        console.log(`  Word ${wordIndex}: "${word}" - Line too wide (${testWidth.toFixed(2)}pt > ${maxWidth.toFixed(2)}pt), wrapping`);
        console.log(`    HTML width: ${htmlWidth.toFixed(2)}pt, jsPDF width: ${jsPdfWidth.toFixed(2)}pt`);
        console.log(`    Adding line: "${currentLine}"`);
        if (currentLine.trim()) {
          lines.push(currentLine.trim());
        }
        currentLine = word;
      } else {
        currentLine = testLine;
        if (wordIndex < 5 || wordIndex % 20 === 0) {
          console.log(`  Word ${wordIndex}: "${word}" - Width: ${testWidth.toFixed(2)}pt (HTML: ${htmlWidth.toFixed(2)}pt, jsPDF: ${jsPdfWidth.toFixed(2)}pt), fits in line`);
        }
      }
    });
    
    if (currentLine && currentLine.trim()) {
      console.log(`  Final line: "${currentLine.trim()}"`);
      lines.push(currentLine.trim());
    }
    lines.push("");
  });
  
  if (lines.length > 0 && lines[lines.length - 1] === "") {
    lines.pop();
  }
  
  console.log(`\nTotal lines generated: ${lines.length}`);
  console.log("First 5 lines:", lines.slice(0, 5));
  console.log("=== END CUSTOM SPLITTING ===\n");
  
  return lines;
};

const downloadAsPdf = async (isOriginal: boolean) => {
  console.log("=== PDF GENERATION START ===");
  console.log("PDF Config:", {
    isOriginal: isOriginal,
    showOriginalSummarized: showOriginalSummarized.value,
    showTranslatedSummarized: showTranslatedSummarized.value,
    originalLanguage: originalLanguage.value?.langCode,
    translationLanguage: translationLanguage.value?.langCode
  });
  
  try {
    let val = "";
    if (isOriginal) {
      if (showOriginalSummarized.value) {
        val = originalSummarizedText.value;
        console.log("Using original summarized text, length:", val.length);
      } else {
        val = originalText.value;
        console.log("Using original text, length:", val.length);
      }
    } else {
      if (showTranslatedSummarized.value) {
        val = translatedSummarizedText.value;
        console.log("Using translated summarized text, length:", val.length);
      } else {
        val = translatedText.value;
        console.log("Using translated text, length:", val.length);
      }
    }
    
    const isArabic: boolean = isOriginal
      ? originalLanguage.value.langCode === "ar"
      : translationLanguage.value.langCode === "ar";
    const isChinese = isOriginal
      ? originalLanguage.value.langCode.includes("zh")
      : translationLanguage.value.langCode.includes("zh");
    const isTurkish = isOriginal
      ? originalLanguage.value.langCode === "tr"
      : translationLanguage.value.langCode === "tr";
    
    console.log("Language Detection:", {
      isArabic: isArabic,
      isChinese: isChinese,
      isTurkish: isTurkish,
      langCode: isOriginal ? originalLanguage.value.langCode : translationLanguage.value.langCode
    });
    
    const text = normalizeText(val, isArabic);
    console.log("Text after normalization, length:", text.length);
    
    const selectedFont = fontFamily.value || "";
    const selectedFontSize = fontSizeNumber.value || 12;
    const selectedColor = pickedColor.value || "#000000";
    
    if (isArabic) {
      console.log("=== USING HTML-TO-PDF APPROACH FOR ARABIC ===");
      await downloadAsPdfHTML(isOriginal, text, selectedFont, selectedFontSize, selectedColor, []);
      return;
    }
    
    const doc = new jsPDF("p", "pt", "a4");
    const margin = isArabic ? 72 : 56.7;
    const sideMargin = isArabic ? 72 : 56.7;
    console.log("PDF Document created, page size:", doc.internal.pageSize);
    
    console.log("Font Settings from UI:", {
      selectedFont: selectedFont,
      selectedFontSize: selectedFontSize,
      selectedColor: selectedColor,
      fontFamilyValue: fontFamily.value,
      fontSizeNumberValue: fontSizeNumber.value,
      pickedColorValue: pickedColor.value
    });

    let pdfFontName = "helvetica";
    console.log("=== FONT SELECTION PROCESS ===");

    if (selectedFont) {
      console.log("Custom font selected from UI, processing...");
      console.log("=== CUSTOM FONT PROCESSING ===");
      console.log("Selected font from UI:", selectedFont);
      console.log("Total fonts in store:", fontStore.fonts.length);
      console.log("Available fonts in store:", fontStore.fonts.map((f: any) => ({ name: f.name, hasFiles: !!f.files, hasRegular: !!(f.files && f.files.regular) })));
      
      const font = fontStore.fonts.find((f: any) => f.name === selectedFont);
      console.log("Font search result:", font ? {
        name: font.name,
        hasFiles: !!font.files,
        hasRegular: !!(font.files && font.files.regular),
        regularUrl: font.files?.regular
      } : "NOT FOUND");
      
      if (font && font.files && font.files.regular) {
        try {
          console.log("Attempting to load font from URL:", font.files.regular);
          const startTime = Date.now();
          const fontBase64 = await loadFontBase(selectedFont, font.files.regular, () => {});
          const loadTime = Date.now() - startTime;
          console.log(`Font loading completed in ${loadTime}ms, base64 length:`, fontBase64 ? fontBase64.length : 0);
          
          if (fontBase64) {
            const fontFileName = `${selectedFont.replace(/\s+/g, "-")}-normal.ttf`;
            console.log("Registering font in jsPDF:", {
              fileName: fontFileName,
              fontName: selectedFont,
              base64Length: fontBase64.length
            });
            
            doc.addFileToVFS(fontFileName, fontBase64);
            doc.addFont(fontFileName, selectedFont, "normal");
            doc.setFont(selectedFont, "normal");
            pdfFontName = selectedFont;
            
            const registeredFont = doc.getFont();
            console.log("Font registered successfully. Current font:", registeredFont.fontName, "Style:", registeredFont.fontStyle);
            console.log("Font name matches:", registeredFont.fontName === selectedFont);
          } else {
            console.log("ERROR: Font base64 is null/undefined, falling back to built-in font mapping");
            pdfFontName = getJsPdfFontName(selectedFont);
            console.log("Mapped to built-in font:", pdfFontName);
          }
        } catch (error) {
          console.error("EXCEPTION: Failed to load custom font:", error);
          console.log("Falling back to helvetica");
          pdfFontName = "helvetica";
        }
      } else {
        console.log("Font not found in store or missing files. Details:", {
          fontFound: !!font,
          hasFiles: !!(font && font.files),
          hasRegular: !!(font && font.files && font.files.regular)
        });
        pdfFontName = getJsPdfFontName(selectedFont);
        console.log("Using built-in font mapping:", pdfFontName);
      }
      } else {
        console.log("No font selected, using default helvetica");
        if (isArabic) {
          doc.setLanguage("ar");
        }
        pdfFontName = "helvetica";
      }

    console.log("=== APPLYING FONT SETTINGS ===");
    console.log("Setting font:", pdfFontName, "normal");
    
    if (isArabic) {
      doc.setLanguage("ar");
    }
    
    doc.setFont(pdfFontName, "normal");
    doc.setFontSize(selectedFontSize);
    doc.setLineHeightFactor(1.5);

    const [r, g, b] = hexToRgb(selectedColor);
    doc.setTextColor(r, g, b);
    
    const fontAfterSettings = doc.getFont();
    console.log("Font settings applied:", {
      fontName: fontAfterSettings.fontName,
      fontStyle: fontAfterSettings.fontStyle,
      fontSize: selectedFontSize,
      color: selectedColor,
      rgb: { r, g, b },
      expectedFontName: pdfFontName,
      fontMatches: fontAfterSettings.fontName === pdfFontName
    });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const maxLineWidth = pageWidth - (sideMargin * 2);
    
    console.log("=== TEXT SPLITTING ===");
    console.log("Page dimensions:", {
      pageWidth: pageWidth,
      pageHeight: pageHeight,
      margin: margin,
      maxLineWidth: maxLineWidth
    });
    
    const currentFontBeforeSplit = doc.getFont();
    console.log("Font before splitTextToSize:", {
      fontName: currentFontBeforeSplit.fontName,
      fontStyle: currentFontBeforeSplit.fontStyle,
      expectedFontName: pdfFontName,
      matches: currentFontBeforeSplit.fontName === pdfFontName
    });
    
    let lines: string[];
    if (isArabic) {
      console.log("=== ARABIC TEXT SPLITTING ===");
      console.log("Original text length:", text.length);
      console.log("Original text preview (first 200 chars):", text.substring(0, 200));
      console.log("Max line width:", maxLineWidth);
      console.log("Font:", pdfFontName, "Size:", selectedFontSize);
      
      lines = splitArabicTextByWords(text, maxLineWidth, doc, pdfFontName, selectedFontSize);
    } else {
      lines = doc.splitTextToSize(text, maxLineWidth);
    }
    console.log("Text split into", lines.length, "lines");
    
    const currentFontAfterSplit = doc.getFont();
    console.log("Font after splitTextToSize:", {
      fontName: currentFontAfterSplit.fontName,
      fontStyle: currentFontAfterSplit.fontStyle,
      expectedFontName: pdfFontName,
      matches: currentFontAfterSplit.fontName === pdfFontName,
      fontChanged: currentFontAfterSplit.fontName !== currentFontBeforeSplit.fontName
    });
    
    if (currentFontAfterSplit.fontName !== pdfFontName) {
      console.log("WARNING: Font changed after splitTextToSize! Resetting...");
      doc.setFont(pdfFontName, "normal");
      doc.setFontSize(selectedFontSize);
    }
    
    const currentFontAfterReset = doc.getFont();
    console.log("Font after reset:", {
      fontName: currentFontAfterReset.fontName,
      fontStyle: currentFontAfterReset.fontStyle,
      expectedFontName: pdfFontName,
      matches: currentFontAfterReset.fontName === pdfFontName
    });

    console.log("=== RENDERING TEXT ===");
    let currentHeight = margin;
    let pageNumber = 1;
    let lineNumber = 0;
    let fontMismatchCount = 0;

    lines.forEach((line: string | string[]) => {
      lineNumber++;
      const lineSpacing = 1.5;
      const lineHeight = doc.getLineHeight() * lineSpacing;
      
      if (currentHeight + lineHeight > pageHeight - margin) {
        console.log(`Page ${pageNumber} complete, starting page ${pageNumber + 1}`);
        doc.addPage();
        pageNumber++;
        currentHeight = margin;
      }
      
      if (isArabic) {
        doc.setLanguage("ar");
      }
      doc.setFont(pdfFontName, "normal");
      doc.setFontSize(selectedFontSize);
      doc.setLineHeightFactor(lineSpacing);
      doc.setTextColor(r, g, b);
      
      const fontBeforeText = doc.getFont();
      const fontMatches = fontBeforeText.fontName === pdfFontName;
      
      if (!fontMatches) {
        fontMismatchCount++;
        if (fontMismatchCount <= 5) {
          console.log(`WARNING [Line ${lineNumber}]: Font mismatch before text render. Expected: ${pdfFontName}, Got: ${fontBeforeText.fontName}`);
          console.log(`  Resetting font to: ${pdfFontName}`);
          doc.setFont(pdfFontName, "normal");
        }
      }
      
      const paragraphSpacing = isArabic ? 8 : 6;
      
      if (line === "") {
        currentHeight += paragraphSpacing;
      } else {
        if (isArabic) {
          doc.text(line, pageWidth - sideMargin, currentHeight, { 
            align: "right",
            maxWidth: maxLineWidth
          });
        } else {
          doc.text(line, sideMargin, currentHeight, {
            maxWidth: maxLineWidth
          });
      }
        currentHeight += lineHeight;
      }
      
      const fontAfterText = doc.getFont();
      if (fontAfterText.fontName !== pdfFontName && !isArabic && !isChinese && !isTurkish) {
        if (fontMismatchCount <= 5) {
          console.log(`WARNING [Line ${lineNumber}]: Font changed after text render. Expected: ${pdfFontName}, Got: ${fontAfterText.fontName}`);
        }
      }
    });
    
    console.log("=== RENDERING COMPLETE ===");
    console.log("Summary:", {
      totalLines: lines.length,
      totalPages: pageNumber,
      fontMismatches: fontMismatchCount,
      finalFont: doc.getFont().fontName,
      expectedFont: pdfFontName
    });
    
    const fileName = `${generateFileName(isOriginal)}.pdf`;
    console.log("Saving PDF as:", fileName);
    doc.save(fileName);
    console.log("=== PDF GENERATION COMPLETE ===");
  } catch (error) {
    console.error("=== PDF GENERATION ERROR ===");
    console.error("Error details:", error);
    console.error("Error stack:", error instanceof Error ? error.stack : "No stack trace");
    console.log("downloadAsPdf error: ", error);
  }
};

const getJsPdfFontName = (fontName: string): string => {
  if (!fontName || fontName.trim() === "") {
    return "helvetica";
  }
  
  const fontMap: { [key: string]: string } = {
    "arial": "helvetica",
    "helvetica": "helvetica",
    "times new roman": "times",
    "times": "times",
    "courier new": "courier",
    "courier": "courier",
    "roboto": "helvetica",
    "open sans": "helvetica",
    "lato": "helvetica",
    "montserrat": "helvetica",
    "raleway": "helvetica",
    "poppins": "helvetica",
    "source sans pro": "helvetica",
    "oswald": "helvetica",
    "merriweather": "times",
    "playfair display": "times",
    "lora": "times",
    "pt serif": "times",
    "inconsolata": "courier",
    "source code pro": "courier",
    "fira code": "courier",
  };
  
  const lowerFontName = fontName.toLowerCase().trim();
  
  if (fontMap[lowerFontName]) {
    return fontMap[lowerFontName];
  }
  
  for (const [key, value] of Object.entries(fontMap)) {
    if (lowerFontName.includes(key)) {
      return value;
    }
  }
  
  return "helvetica";
};
const downloadAsDoc = async (isOriginal: boolean) => {
  let text = "";
  if (isOriginal) {
    if (showOriginalSummarized.value) {
      text = originalSummarizedText.value;
    } else {
      text = originalText.value;
    }
  } else {
    if (showTranslatedSummarized.value) {
      text = translatedSummarizedText.value;
    } else {
      text = translatedText.value;
    }
  }
  const docxFontSizeHalfPoints = getDocxExportFontSizeHalfPoints();
  const doc = new Document({
    sections: [
      {
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text,
                size: docxFontSizeHalfPoints,
              }),
            ],
          }),
        ],
      },
    ],
  });
  const blob = await Packer.toBlob(doc);
  saveAs(blob, `${generateFileName(isOriginal)}.docx`);
};

const decreaseFontSize = () => {
  try {
    if (fontSizePercent.value == 35) return;
    fontSizePercent.value -= 5;
    updateTextSize();
    //updateTextTrackStyles();
  } catch (error) {
    console.log("decreaseFontSize:", error);
  }
};

const copySubtitle = (isOriginal: boolean) => {
  if (
    isOriginal
      ? originalAudioSubtitle.value.length == 0
      : translatedAudioSubtitle.value.length == 0
  ) {
    return;
  }
  navigator.clipboard
    .writeText(
      isOriginal ? originalAudioSubtitle.value : translatedAudioSubtitle.value
    )
    .then(() => {
      toast(t("text-copied-to-clipboard"), {
        autoClose: 1500,
        type: "success",
        theme: "light",
      });
    })
    .catch((error) => {
      toast(t("failed-to-copy-text-please-try-again"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      console.error("Error copying text:", error);
    });
};

const toggleShowTranslatedSummarized = (value: boolean) => {
  if (showTranslatedSummarized.value === value) return;
  if (value) {
    if (!translatedSummarizedText.value) {
      return;
    }
    showTranslatedSummarized.value = true;
  } else {
    showTranslatedSummarized.value = false;
  }
};

const toggleShowOrinialSummarized = (value: boolean) => {
  if (showOriginalSummarized.value === value) return;
  if (value) {
    if (!originalSummarizedText.value) {
      return;
    }
    showOriginalSummarized.value = true;
  } else {
    showOriginalSummarized.value = false;
  }
};

const selectTranslatedSummaryLang = (langCode: any) => {
  selectedSummarizedLanguage.value = langCode;
  translatedSummarizedText.value =
    summarizesData.value.find((e: any) => e.lang === langCode).summary || "";
  isSummarizedLangsDropOpen.value = false;
};

const fetchSummarizedText = async () => {
  try {
    const getData = await fetch(
      `${summarizeTextUrl}/${currentRequestId.value}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      }
    );

    const data = await getData.json();

    if (!getData.ok) {
      switch (data.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        default:
          break;
      }
      return;
    }

    if (getData.status === 200 && data.results) {
      summarizesData.value = data.results;
      selectedSummarizedLanguage.value =
        translatedSummarizesLangs.value.length === 0
          ? translationLanguage.value.langCode
          : translatedSummarizesLangs.value[0];
      as.originalSummarizedText = summarizesData.value.find(
        (e: any) => e.lang === originalLanguage.value.langCode
      )?.summary;
      as.translatedSummarizedText =
        summarizesData.value.find(
          (e: any) => e.lang === translationLanguage.value.langCode
        )?.summary || "";
    }
  } catch (error) {
    as.originalSummarizedText = "";
    console.log(`fetchSummarizedText: ${error}`);
  }
};

const summarizeText = async (isOriginalText: boolean) => {
  try {
    let textToSummarize = isOriginalText
      ? originalText.value
      : translatedText.value;
    if (textToSummarize.trim().length === 0) {
      toast(t("translation_empty"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }

    if (
      textToSummarize.split(/\s+/).filter((word) => word.length > 0).length <
        10 &&
      textToSummarize.length < 40
    ) {
      toast(t("please-enter-at-least-10-words"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }

    let textTokenLenth = isOriginalText
      ? origineTokenValue.value
      : translatedTokenValue.value;
    let textLang = isOriginalText
      ? originalLanguage.value.langCode
      : translationLanguage.value.langCode;
    let serviceType =
      userInputAudioLink.value.trim().length === 0 ? "AUDIO" : "EXTAUDIO";
    let stillOriginalText;
    let relatedId = isOriginalText ? "" : latestTranslationId.value;
    if (isOriginalText) {
      summarizingOriginalText.value = true;
      stillOriginalText = originalText.value === defaultOriginalText.value;
    } else {
      summarizingTranslatedText.value = true;
      stillOriginalText = translatedText.value === defaultTranslatedText.value;
    }
    let body;
    body = JSON.stringify({
      text: textToSummarize,
      length: textTokenLenth,
      serviceType: serviceType,
      serviceRequestId: currentRequestId.value,
      summaryLang: textLang,
      relatedRequestId: relatedId,
      isOriginal: stillOriginalText,
      externelLink: as.userInputAudioLink,
    });
    const response = await fetch(summarizeTextUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: body,
    });

    const results = await response.json();
    if (!response.ok) {
      switch (results.error) {
        case "serviceRequestId is required":
          toast(t("ai-summarization-is-not-available-free"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Request not found or does not belong to user":
          toast(t("invalid-or-unauthorized"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Summary already exists for this request and language":
          toast(t("a-summary-for-this-request-and"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Rate limit exceeded. Try again later.":
          toast(t("rate-limit-reached-please"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
      }
      if (isOriginalText) {
        summarizingOriginalText.value = false;
      } else {
        summarizingTranslatedText.value = false;
      }
      return;
    }
    if (results.result) {
      if (isOriginalText) {
        as.originalSummarizedText = results.result;
      } else {
        as.translatedSummarizedText = results.result;
        summarizesData.value.push({
          summary: results.result,
          lang: translationLanguage.value.langCode,
        });
        translatedSummarizesLangs.value = summarizesData.value
          .filter((e: any) => e.lang !== originalLanguage.value.langCode)
          .map((item) => item.lang);
        selectTranslatedSummaryLang(translationLanguage.value.langCode);
      }
    }
    if (isOriginalText) {
      summarizingOriginalText.value = false;
    } else {
      summarizingTranslatedText.value = false;
    }
  } catch (error) {
    if (isOriginalText) {
      summarizingOriginalText.value = false;
    } else {
      summarizingTranslatedText.value = false;
    }
    console.error("Error making request to the server:", error);
  }
};

const resetText = (isOriginal: boolean) => {
  if (isOriginal) {
    if (showOriginalSummarized.value) return;
  } else {
    if (showTranslatedSummarized.value) return;
  }
  if (isOriginal) {
    originalText.value = defaultOriginalText.value;
  } else {
    translatedText.value = defaultTranslatedText.value;
  }
};

const resetSubtitle = (isOriginal: boolean) => {
  if (isOriginal) {
    originalAudioSubtitle.value = defaultOriginalAudioSubtitle.value;
  } else {
    translatedAudioSubtitle.value = defaultTranslatedAudioSubtitle.value;
  }
};

// Find/Replace functions
const openFindReplace = (mode: "text" | "caption", target: "original" | "translated") => {
  findReplaceMode.value = mode;
  findReplaceTarget.value = target;
  showFindReplace.value = true;
  findReplaceSearchTerm.value = "";
  findReplaceMatches.value = [];
  currentFindMatchIndex.value = -1;
};

const closeFindReplace = () => {
  showFindReplace.value = false;
  findReplaceSearchTerm.value = "";
  findReplaceMatches.value = [];
  currentFindMatchIndex.value = -1;
};

const performFind = (searchTerm: string, target: "original" | "translated") => {
  if (!searchTerm) {
    findReplaceMatches.value = [];
    currentFindMatchIndex.value = -1;
    if (findReplaceDialogRef.value) {
      findReplaceDialogRef.value.setMatchInfo(-1, 0);
    }
    return;
  }

  findReplaceSearchTerm.value = searchTerm;

  let content = "";
  let textOnlyContent = "";

  if (findReplaceMode.value === "text") {
    if (target === "original") {
      content = showOriginalSummarized.value
        ? originalSummarizedText.value
        : originalText.value;
    } else {
      content = showTranslatedSummarized.value
        ? translatedSummarizedText.value
        : translatedText.value;
    }
    textOnlyContent = content;
  } else {
    // caption mode - extract text only from WebVTT
    const webvttContent = target === "original" 
      ? originalAudioSubtitle.value 
      : translatedAudioSubtitle.value;
    
    const blocks = parseWebVTTForFindReplace(webvttContent);
    textOnlyContent = blocks.map(block => block.text).join("\n");
    content = webvttContent;
  }

  // Find all matches in text content
  const regex = new RegExp(escapeRegex(searchTerm), "gi");
  const matches: number[] = [];
  let match;
  while ((match = regex.exec(textOnlyContent)) !== null) {
    matches.push(match.index);
  }

  findReplaceMatches.value = matches;
  currentFindMatchIndex.value = matches.length > 0 ? 0 : -1;

  if (findReplaceDialogRef.value) {
    findReplaceDialogRef.value.setMatchInfo(
      currentFindMatchIndex.value,
      matches.length
    );
  }

  if (matches.length > 0) {
    scrollToMatch(matches[0], searchTerm.length, false);
  }
};

const escapeRegex = (str: string): string => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

const findNextMatch = () => {
  if (findReplaceMatches.value.length === 0) return;

  currentFindMatchIndex.value =
    (currentFindMatchIndex.value + 1) % findReplaceMatches.value.length;

  if (findReplaceDialogRef.value) {
    findReplaceDialogRef.value.setMatchInfo(
      currentFindMatchIndex.value,
      findReplaceMatches.value.length
    );
  }

  const matchIndex = findReplaceMatches.value[currentFindMatchIndex.value];
  const searchTerm = findReplaceDialogRef.value?.getSearchTerm() || findReplaceSearchTerm.value;
  scrollToMatch(matchIndex, searchTerm.length, true);
};

const findPreviousMatch = () => {
  if (findReplaceMatches.value.length === 0) return;

  currentFindMatchIndex.value =
    currentFindMatchIndex.value <= 0
      ? findReplaceMatches.value.length - 1
      : currentFindMatchIndex.value - 1;

  if (findReplaceDialogRef.value) {
    findReplaceDialogRef.value.setMatchInfo(
      currentFindMatchIndex.value,
      findReplaceMatches.value.length
    );
  }

  const matchIndex = findReplaceMatches.value[currentFindMatchIndex.value];
  const searchTerm = findReplaceDialogRef.value?.getSearchTerm() || findReplaceSearchTerm.value;
  scrollToMatch(matchIndex, searchTerm.length, true);
};

const scrollToMatch = (index: number, length: number, shouldFocus: boolean = false) => {
  nextTick(() => {
    let textarea: HTMLTextAreaElement | null = null;
    let actualIndex = index;
    
    if (findReplaceMode.value === "text") {
      if (findReplaceTarget.value === "original") {
        textarea = showOriginalSummarized.value
          ? originalSummarizedTextAreaRef.value
          : originalTextAreaRef.value;
      } else {
        textarea = showTranslatedSummarized.value
          ? translatedSummarizedTextAreaRef.value
          : translatedTextAreaRef.value;
      }
    } else {
      const webvttContent = findReplaceTarget.value === "original" 
        ? originalAudioSubtitle.value 
        : translatedAudioSubtitle.value;
      const blocks = parseWebVTTForFindReplace(webvttContent);
      
      let textOffset = 0;
      let webvttOffset = 0;
      const headerLength = webvttContent.startsWith("WEBVTT") ? webvttContent.indexOf("\n\n") + 2 : 0;
      webvttOffset = headerLength;

      for (let i = 0; i < blocks.length; i++) {
        const blockTextLength = blocks[i].text.length;
        
        if (index >= textOffset && index < textOffset + blockTextLength) {
          const relativeIndex = index - textOffset;
          actualIndex = webvttOffset + 
            (i > 0 ? blocks.slice(0, i).reduce((sum, b) => sum + b.fullBlock.length + 2, 0) : 0) +
            String(i + 1).length + 1 +
            blocks[i].timestamp.length + 1 +
            relativeIndex;
          break;
        }
        
        textOffset += blockTextLength + 1;
      }

      textarea = findReplaceTarget.value === "original" 
        ? webvttTextArea1.value
        : webvttTextArea2.value;
    }

    if (textarea) {
      if (shouldFocus) {
      textarea.focus();
      }
      const maxIndex = Math.min(actualIndex, textarea.value.length);
      const maxLength = Math.min(length, textarea.value.length - maxIndex);
      textarea.setSelectionRange(maxIndex, maxIndex + maxLength);
      const lineHeight = parseInt(getComputedStyle(textarea).lineHeight) || 20;
      const lines = textarea.value.substring(0, maxIndex).split("\n").length - 1;
      textarea.scrollTop = Math.max(0, lines * lineHeight - textarea.clientHeight / 2);
      
      if (showFindReplace.value) {
        const dialogOverlay = document.querySelector('.overlay.bg-gray-600.bg-opacity-50');
        const dialogContent = dialogOverlay?.querySelector('.bg-white.rounded-lg.shadow-lg') as HTMLElement;
        const dialogHeight = dialogContent ? dialogContent.offsetHeight + 64 : 0;
        
        const textareaRect = textarea.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const scrollY = window.scrollY;
        
        const desiredTopPosition = dialogHeight + 20;
        const textareaTop = textareaRect.top + scrollY;
        const textareaBottom = textareaRect.bottom + scrollY;
        
        const isCoveredByDialog = textareaRect.top < dialogHeight;
        const isNotFullyVisible = textareaRect.bottom > viewportHeight || textareaRect.top < 0;
        
        if (isCoveredByDialog || isNotFullyVisible) {
          const targetScrollY = textareaTop - desiredTopPosition;
          
          window.scrollTo({
            top: Math.max(0, targetScrollY),
            behavior: 'smooth'
          });
        }
      } else {
        const textareaRect = textarea.getBoundingClientRect();
        const isNotFullyVisible = textareaRect.bottom > window.innerHeight || textareaRect.top < 0;
        
        if (isNotFullyVisible) {
          textarea.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }
  });
};

const replaceCurrentMatch = async (replaceTerm: string) => {
  if (currentFindMatchIndex.value === -1 || findReplaceMatches.value.length === 0) return;

  const searchTerm = findReplaceDialogRef.value?.getSearchTerm() || findReplaceSearchTerm.value;
  if (!searchTerm) return;

  if (findReplaceMode.value === "text") {
    await replaceInText(replaceTerm, searchTerm);
  } else {
    replaceInCaption(replaceTerm, searchTerm);
  }

  performFind(searchTerm, findReplaceTarget.value);
};

const replaceAllMatches = async (replaceTerm: string) => {
  const searchTerm = findReplaceDialogRef.value?.getSearchTerm() || findReplaceSearchTerm.value;
  if (!searchTerm) return;

  if (findReplaceMode.value === "text") {
    await replaceInText(replaceTerm, searchTerm, true);
  } else {
    replaceInCaption(replaceTerm, searchTerm, true);
  }

  findReplaceMatches.value = [];
  currentFindMatchIndex.value = -1;
  if (findReplaceDialogRef.value) {
    findReplaceDialogRef.value.setMatchInfo(-1, 0);
  }
};

const replaceInText = async (replaceTerm: string, searchTerm: string, replaceAll: boolean = false) => {
  if (findReplaceTarget.value === "original") {
      if (showOriginalSummarized.value) {
        if (replaceAll) {
          const regex = new RegExp(escapeRegex(searchTerm), 'g');
          originalSummarizedText.value = originalSummarizedText.value.replace(
            regex,
            replaceTerm
          );
        } else {
        const currentIndex = findReplaceMatches.value[currentFindMatchIndex.value];
        const before = originalSummarizedText.value.substring(0, currentIndex);
        const after = originalSummarizedText.value.substring(currentIndex + searchTerm.length);
        originalSummarizedText.value = before + replaceTerm + after;
      }
    } else {
      if (replaceAll) {
        const regex = new RegExp(escapeRegex(searchTerm), 'g');
        originalText.value = originalText.value.replace(regex, replaceTerm);
      } else {
        const currentIndex = findReplaceMatches.value[currentFindMatchIndex.value];
        const before = originalText.value.substring(0, currentIndex);
        const after = originalText.value.substring(currentIndex + searchTerm.length);
        originalText.value = before + replaceTerm + after;
      }
    }
  } else {
    let updatedText = "";
    if (showTranslatedSummarized.value) {
      if (replaceAll) {
        const regex = new RegExp(escapeRegex(searchTerm), 'g');
        translatedSummarizedText.value = translatedSummarizedText.value.replace(
          regex,
          replaceTerm
        );
        updatedText = translatedSummarizedText.value;
      } else {
        const currentIndex = findReplaceMatches.value[currentFindMatchIndex.value];
        const before = translatedSummarizedText.value.substring(0, currentIndex);
        const after = translatedSummarizedText.value.substring(currentIndex + searchTerm.length);
        translatedSummarizedText.value = before + replaceTerm + after;
        updatedText = translatedSummarizedText.value;
      }
    } else {
      if (replaceAll) {
        const regex = new RegExp(escapeRegex(searchTerm), 'g');
        translatedText.value = translatedText.value.replace(regex, replaceTerm);
        updatedText = translatedText.value;
      } else {
        const currentIndex = findReplaceMatches.value[currentFindMatchIndex.value];
        const before = translatedText.value.substring(0, currentIndex);
        const after = translatedText.value.substring(currentIndex + searchTerm.length);
        translatedText.value = before + replaceTerm + after;
        updatedText = translatedText.value;
      }
    }
    
    if ((currentRequestId.value || userInputAudioLink.value) && translationLanguage.value?.langCode) {
      try {
        await saveTextTranslationsToCache(
          { [translationLanguage.value.langCode]: updatedText },
          [translationLanguage.value.langCode],
          currentRequestId.value || undefined,
          userInputAudioLink.value || undefined
        );
      } catch (error) {
        console.error("Failed to update cache after replace:", error);
      }
    }
  }
};

const parseWebVTTForFindReplace = (webvtt: string): Array<{ index: number; timestamp: string; text: string; fullBlock: string }> => {
  const blocks: Array<{ index: number; timestamp: string; text: string; fullBlock: string }> = [];
  const lines = webvtt.split("\n");
  let i = 0;
  let blockIndex = 0;

  if (lines[0]?.trim() === "WEBVTT") {
    i = 1;
  }

  while (i < lines.length) {
    while (i < lines.length && lines[i].trim() === "") {
      i++;
    }
    if (i >= lines.length) break;

    if (/^\d+$/.test(lines[i].trim())) {
      i++;
    }

    const timestampLine = lines[i]?.trim();
    if (!timestampLine || !timestampLine.includes("-->")) {
      i++;
      continue;
    }

    const timestamp = timestampLine;
    i++;

    const textLines: string[] = [];
    while (i < lines.length && lines[i].trim() !== "" && !/^\d+$/.test(lines[i].trim())) {
      if (!lines[i].includes("-->")) {
        textLines.push(lines[i]);
      }
      i++;
    }

    const text = textLines.join("\n");
    const fullBlock = `${blockIndex + 1}\n${timestamp}\n${text}`;

    blocks.push({
      index: blockIndex,
      timestamp,
      text,
      fullBlock,
    });

    blockIndex++;
  }

  return blocks;
};

const reconstructWebVTT = (blocks: Array<{ index: number; timestamp: string; text: string }>): string => {
  let result = "WEBVTT\n\n";
  blocks.forEach((block) => {
    result += `${block.index + 1}\n${block.timestamp}\n${block.text}\n\n`;
  });
  return result;
};

const replaceInCaption = (replaceTerm: string, searchTerm: string, replaceAll: boolean = false) => {
  const content = findReplaceTarget.value === "original" 
    ? originalAudioSubtitle.value 
    : translatedAudioSubtitle.value;

  const blocks = parseWebVTTForFindReplace(content);

  if (replaceAll) {
    const regex = new RegExp(escapeRegex(searchTerm), 'g');
    blocks.forEach((block) => {
      block.text = block.text.replace(regex, replaceTerm);
    });
  } else {
    let currentBlockIndex = -1;
    let textOffset = 0;

    for (let i = 0; i < blocks.length; i++) {
      const blockTextLength = blocks[i].text.length;
      const matchIndex = findReplaceMatches.value[currentFindMatchIndex.value];

      if (matchIndex >= textOffset && matchIndex < textOffset + blockTextLength) {
        currentBlockIndex = i;
        break;
      }

      textOffset += blockTextLength + 1;
    }

    if (currentBlockIndex !== -1) {
      const block = blocks[currentBlockIndex];
      const relativeIndex = findReplaceMatches.value[currentFindMatchIndex.value] - textOffset;
      const before = block.text.substring(0, relativeIndex);
      const after = block.text.substring(relativeIndex + searchTerm.length);
      block.text = before + replaceTerm + after;
    }
  }

  const newWebVTT = reconstructWebVTT(blocks);

  if (findReplaceTarget.value === "original") {
    originalAudioSubtitle.value = newWebVTT;
  } else {
    translatedAudioSubtitle.value = newWebVTT;
  }
};

const toggleDownloadTranslatedSRTTypes = () => {
  if (translatedAudioSubtitle.value.length === 0) return;
  showDownloadTranslatedSRTTypes.value = !showDownloadTranslatedSRTTypes.value;
};

const syncScroll = (target: "webvttTextArea1" | "webvttTextArea2") => {
  const sourceTextarea =
    target === "webvttTextArea1"
      ? webvttTextArea2.value
      : webvttTextArea1.value;
  const targetTextarea =
    target === "webvttTextArea1"
      ? webvttTextArea1.value
      : webvttTextArea2.value;

  if (sourceTextarea && targetTextarea) {
    targetTextarea.scrollTop = sourceTextarea.scrollTop;
  }
};

const translateCaptions = async () => {
  try {
    if (
      originalAudioSubtitle.value.trim().length === 0 ||
      !hasWebVttCaptions(originalAudioSubtitle.value)
    ) {
      toast(t("no-captions-available"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (
      originalLanguage.value.langCode === translationLanguage.value.langCode
    ) {
      toast(
        t(
          "translation-language-matches-the-original-please-choose-a-different-language"
        ),
        {
          autoClose: 1500,
          type: "error",
          theme: "light",
        }
      );
      return;
    }
    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }
    isTranslatingCaptions.value = true;
    if (latestTranslationTarget.value === translationLanguage.value.langCode) {
      if (defaultOriginalAudioSubtitle.value != originalAudioSubtitle.value) {
        if (translatedAudioSubtitle.value.length != 0) {
          await handleEditedCaptionsTranslation();
          return;
        }
      }
    }
    const canProceed = await computeTranslationCost(false);
    if (!canProceed) {
      return;
    }
    if (balanceNotEnough.value) {
      return;
    }
    let body;
    if (defaultOriginalAudioSubtitle.value === originalAudioSubtitle.value) {
      body = JSON.stringify({
        captionsList: parseWebVTT(),
        from: originalLanguage.value.langCode,
        to: translationLanguage.value.langCode,
        isOriginalText: true,
        externelLink: userInputAudioLink.value,
      });
    } else {
      body = JSON.stringify({
        captionsList: parseWebVTT(),
        from: originalLanguage.value.langCode,
        to: translationLanguage.value.langCode,
      });
    }
    // translate captions
    const response = await fetch(translateCpationUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: body,
    });
    const r = await response.json();
    if (!response.ok) {
      if (
        r.error &&
        String(r.error).toLowerCase().includes("captions list")
      ) {
        toast(t("no-captions-available"), {
          autoClose: 3000,
          type: "error",
          theme: "light",
        });
        return;
      }
      switch (r.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return;
    }
    const translatedLines = r?.translatedText;
    if (!Array.isArray(translatedLines) || translatedLines.length === 0) {
      toast(t("no-captions-available"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    replaceTranslatedSentences(translatedLines);
    await profileStore.getUserSubscription(authStore.token!);
    const { original: paddedOriginal, translated: paddedTranslated } =
      padCaptionsToEqualLines(
        originalAudioSubtitle.value,
        translatedAudioSubtitle.value
      );
    translatedAudioSubtitle.value = paddedTranslated;
    defaultTranslatedAudioSubtitle.value = paddedTranslated;
  } catch (error) {
    console.log("Error making request to the server:", error);
  } finally {
    isTranslatingCaptions.value = false;
  }
};

function padCaptionsToEqualLines(originalText: any, translatedText: any) {
  const originalLines = originalText.split("\n");
  const translatedLines = translatedText.split("\n");
  const originalHeader = originalLines[0].startsWith("WEBVTT")
    ? originalLines.shift()
    : "";
  const translatedHeader = translatedLines[0].startsWith("WEBVTT")
    ? translatedLines.shift()
    : "";
  const originalCaptions = splitCaptions(originalLines);
  const translatedCaptions = splitCaptions(translatedLines);
  const paddedOriginal = [];
  const paddedTranslated = [];

  for (let i = 0; i < originalCaptions.length; i++) {
    const originalCaption = originalCaptions[i];
    const translatedCaption = translatedCaptions[i] || {
      index: originalCaption.index,
      timestamp: originalCaption.timestamp,
      text: "",
    };
    const originalTextLines = originalCaption.text.split("\n");
    const translatedTextLines = translatedCaption.text.split("\n");
    const maxLines = Math.max(
      originalTextLines.length,
      translatedTextLines.length
    );
    const paddedOriginalText = [
      ...originalTextLines,
      ...Array(maxLines - originalTextLines.length).fill(""),
    ];
    const paddedTranslatedText = [
      ...translatedTextLines,
      ...Array(maxLines - translatedTextLines.length).fill(""),
    ];
    paddedOriginal.push(
      `${originalCaption.index}\n${
        originalCaption.timestamp
      }\n${paddedOriginalText.join("\n")}`
    );
    paddedTranslated.push(
      `${translatedCaption.index}\n${
        translatedCaption.timestamp
      }\n${paddedTranslatedText.join("\n")}`
    );
  }

  return {
    original: `${originalHeader}\n\n${paddedOriginal.join("\n\n")}`,
    translated: `${translatedHeader}\n\n${paddedTranslated.join("\n\n")}`,
  };
}

function splitCaptions(lines: any) {
  const captions = [];
  let index = "";
  let timestamp = "";
  let text = "";

  lines.forEach((line: any) => {
    if (/^\d+$/.test(line)) {
      if (index && timestamp && text) {
        captions.push({ index, timestamp, text: text.trim() });
        text = "";
      }
      index = line;
    } else if (line.includes("-->")) {
      timestamp = line;
    } else {
      text += line + "\n";
    }
  });

  if (index && timestamp && text) {
    captions.push({ index, timestamp, text: text.trim() });
  }

  return captions;
}

const replaceTranslatedSentences = (translatedSentences: any) => {
  const lines = originalAudioSubtitle.value.split("\n");
  let isCaptionsSection = false;
  let lineIndex = 0;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    if (line.match(/(\d{2}:){2}\d{2}\.\d{3} --> (\d{2}:){2}\d{2}\.\d{3}/)) {
      isCaptionsSection = true;
    } else if (
      isCaptionsSection &&
      line.trim() !== "" &&
      !line.match(/^\d+$/)
    ) {
      lines[i] = translatedSentences[lineIndex] || lines[i];
      lineIndex++;
    }
  }

  translatedAudioSubtitle.value = lines.join("\n");
};

const handleEditedCaptionsTranslation = async () => {
  if (!hasWebVttCaptions(originalAudioSubtitle.value)) {
    toast(t("no-captions-available"), {
      autoClose: 3000,
      type: "error",
      theme: "light",
    });
    return;
  }
  const parseSRT = (srt: string) => {
    return srt.split("\n\n").reduce((acc, block) => {
      const [index, timestamp, ...textLines] = block.split("\n");
      if (index && timestamp) {
        acc[timestamp] = { index, text: textLines.join("\n") };
      }
      return acc;
    }, {} as Record<string, { index: string; text: string }>);
  };

  const originalCaptions = parseSRT(prebuildAudioSubtitle.value);
  const editedCaptions = parseSRT(originalAudioSubtitle.value);

  const updates: { timestamp: string; text?: string; newText?: string }[] = [];
  for (const timestamp in editedCaptions) {
    const updatedCaption = editedCaptions[timestamp];
    const originalCaption = originalCaptions[timestamp];

    if (!originalCaption) {
      updates.push({ timestamp, newText: updatedCaption.text });
    } else if (updatedCaption.text !== originalCaption.text) {
      updates.push({
        timestamp,
        text: originalCaption.text,
        newText: updatedCaption.text,
      });
    }
  }

  const translateCaptionss = async (
    captions: { timestamp: string; newText: string }[]
  ) => {
    return await Promise.all(
      captions.map(async (caption) => {
        const translatedText = await translateSentence(caption.newText);
        return { timestamp: caption.timestamp, translatedText };
      })
    );
  };

  const captionsToTranslate = updates
    .filter((update) => update.newText !== undefined)
    .map((update) => ({
      timestamp: update.timestamp,
      newText: update.newText!,
    }));

  const translations = await translateCaptionss(captionsToTranslate);

  const translatedUpdates = updates.map((update) => {
    const translation = translations.find(
      (t) => t.timestamp === update.timestamp
    );
    return {
      timestamp: update.timestamp,
      translatedText: translation ? translation.translatedText : undefined,
    };
  });

  let translatedContent = translatedAudioSubtitle.value;
  translatedUpdates.forEach(({ timestamp, translatedText }) => {
    const regex = new RegExp(`(${timestamp}\\n)[^\n]+`, "g");
    const existingCaptionMatch = translatedContent.match(regex);
    if (translatedText && existingCaptionMatch) {
      translatedContent = translatedContent.replace(
        regex,
        `$1${translatedText}`
      );
    } else if (translatedText && !existingCaptionMatch) {
      translatedContent += `\n${editedCaptions[timestamp].index}\n${timestamp}\n${translatedText}\n`;
    }
  });
  translatedAudioSubtitle.value = translatedContent;
  defaultTranslatedAudioSubtitle.value = translatedContent;
  prebuildAudioSubtitle.value = originalAudioSubtitle.value;
};

const translateSentence = async (text: string): Promise<string | undefined> => {
  try {
    const canProceed = await computeTranslationCost(true);
    if (!canProceed) {
      return undefined;
    }
    // Use GPT endpoint if context hint is provided
    const useGPT = translationHint.value && translationHint.value.trim().length > 0;
    const endpointUrl = useGPT ? translateTextGPTUrl : translateTextUrl;
    
    const secondResponse = await fetch(endpointUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        originalText: text,
        from: originalLanguage.value.langCode,
        to: translationLanguage.value.langCode,
        ...(useGPT && { context: translationHint.value.trim() }),
      }),
    });
    if (!secondResponse.ok) {
      console.error("Error fetching translated text from the server");
      return;
    }
    await profileStore.getUserSubscription(authStore.token!);
    const responseData = await secondResponse.json();
    if (!secondResponse.ok) {
      switch (responseData.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return;
    }
    return responseData.translatedText;
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};

const downloadSrtFile = (isOriginal: boolean) => {
  if (isOriginal) {
    if (originalAudioSubtitle.value.length == 0) {
      return;
    }
    const srtContent = webVttToSrt(originalAudioSubtitle.value);
    const blob = new Blob([srtContent], { type: "text/srt" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${generateFileName(isOriginal)}.srt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    if (translatedAudioSubtitle.value.length == 0) {
      return;
    }
    const srtContent = webVttToSrt(translatedAudioSubtitle.value);
    const blob = new Blob([srtContent], { type: "text/srt" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${generateFileName(isOriginal)}.srt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

function webVttToSrt(webVttContent: any) {
  const lines = webVttContent.split("\n");
  let srtContent = "";
  let counter = 1;
  for (let i = 0; i < lines.length; i++) {
    if (lines[i].includes("-->")) {
      srtContent += counter + "\n";
      counter++;
      const timecode = lines[i].replace(".", ",").replace(" --> ", " --> ");
      srtContent += timecode + "\n";
      i++;
      while (i < lines.length && lines[i].trim() !== "") {
        srtContent += lines[i] + "\n";
        i++;
      }
      srtContent += "\n";
    }
  }
  return srtContent;
}

function extractSentencesFromWebVTT(webvtt: string): string {
  if (downloadOnlySentencesSrt.value) {
    return webvtt
      .split("\n")
      .filter((line) => !line.match(/^WEBVTT|^\d+$|^\d{2}:\d{2}:\d{2}\.\d{3}/))
      .join("\n")
      .trim();
  } else {
    return webvtt;
  }
}

const handleIgnoreSrtCheckbox = (event: any) => {
  try {
    event.stopPropagation();
    downloadOnlySentencesSrt.value = event.target.checked;
  } catch (error) {
    console.log("handleIgnoreSrtCheckbox:", error);
  }
};

const downloadWebVttFile = (originalContent: boolean) => {
  if (originalContent) {
    if (originalAudioSubtitle.value.length == 0) {
      return;
    }
    const blob = new Blob(
      [extractSentencesFromWebVTT(originalAudioSubtitle.value)],
      { type: "text/vtt" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${generateFileName(originalContent)}.vtt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    if (translatedAudioSubtitle.value.length == 0) {
      return;
    }
    const blob = new Blob(
      [extractSentencesFromWebVTT(translatedAudioSubtitle.value)],
      {
        type: "text/vtt",
      }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${generateFileName(originalContent)}.vtt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

function getCapitalizedFontName(fontFamily: string): string {
  const fontName = fontFamily.split(",")[0].replace(/['"]+/g, "").trim();
  return fontName
    .replace(/-/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const removeParentheses = (langName: string) => {
  return langName.replace(/\s*\(.*?\)\s*/g, "").trim();
};

function getLanguageName(langCode: string): string {
  return languages.find((e: any) => e.langCode === langCode)?.langName || "";
}

const fontFamilies = [
  "Aclonica",
  "arimo",
  "calligraffitti",
  "cherrycreamsoda",
  "chewy",
  "comingsoon",
  "cousine",
  "craftygirls",
  "creepstercaps",
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui",
  "math",
];

const supportFileDownloadTypes = ["txt", "pdf", "doc", "json"];
const supportFileDownloadSRTTypes = ["webvtt", "srt"];

// Title is set by the route/page component, not by this reusable component
</script>
